import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { forkJoin, of, throwError, Subscription } from 'rxjs';
import { catchError, concatMap, finalize, map } from 'rxjs/operators';
import { PopUpConfirmacionComponent, PopUpConfirmacionData } from '../pop-up-confirmacion/pop-up-confirmacion.component';
import { PopUpMensajeComponent, PopUpMensajeData } from '../pop-up-mensaje/pop-up-mensaje.component';
import { ConsultarLineasGruposProgramasService, ProgramaCompleto } from '../../../../../../services/cotizador-programas/consultar-lineas-grupos-programas.service';
import { ConsultarSubcuentasService } from '../../../../../../services/cotizador-contratante/consultar-subcuentas.service';
import { ConsultarSubcuentasColectivosGruposService } from '../../../../../../services/cotizador-contratante/consultar-subcuentas-colectivos-grupos.service';
import { ConsultarTarifasColectivosGruposService } from '../../../../../../services/cotizador-contratante/consultar-tarifas-colectivos-grupos.service';
import { ConsultarSubcuentasCoGaDataItem } from '../../../../../../models/cotizador-contratante/consultar-subcuentas-co-ga/response/consultar-subcuentas-c-ga-response.model';
import { ConsultarHistorialService } from '../../../../../../services/cotizador-contratante/consultar-historial.service';
import { ConsultarAsociadoService } from '../../../../../../services/cotizador-contratante/consultar-asociado.service';
import { NetworkingBeneficiary } from '../../../../../../services/beneficiario/beneficiario.service';
import { IListTarifa } from '../../../../../../models/cotizador/IListTarifa';
import { LineaNegocio } from '../../../../../../models/cotizador-programas/lineas-negocio/consultar-lineas-negocio-response.model';
import { AdresPerson } from '../../../../../../models/cotizador/response/model.adres.response';
import { HistorialItem } from '../../../../../../models/cotizador-contratante/consultar-historial/response/consultar-historial-response.model';
import { ConsultarAsociadoResponse } from '../../../../../../models/cotizador-contratante/consultar-asociado/response/consultar-asociado-response.model';
import { CotizacionesIncompletasService } from '../../../../../../services/cotizador-contratante/cotizaciones-incompletas.service';
import { CrearCotizacionContratanteService } from '../../../../../../services/cotizador-contratante/crear-cotizacion-contratante.service';
import {
  KEY_COTIZACION_CONTRATANTE_SESION_ACTIVA,
  KEY_COTIZACION_CREADA_DESDE_CONTRATANTE
} from '../../../../../../models/cotizador-contratante/crear cotizacion/cotizacion-creada-contratante-guardada.model';
import { ConsultarProgramasContratanteService } from '../../../../../../services/cotizador-contratante/consultar-programas-contratante.service';
import { ConsultarProgramasContratanteItem } from '../../../../../../models/cotizador-contratante/consultar-programas-contratante/response/consultar-programas-contratante-response.model';
import { ConsultarAnexosColectivosGruposService } from '../../../../../../services/cotizador-contratante/consultar-anexos-colectivos-grupos.service';
import { ConsultarAnexosColectivosGruposRequest } from '../../../../../../models/cotizador-contratante/consultar-anexos-colectivos-grupos/request/consultar-anexos-colectivos-grupos-request.model';
import { ConsultarProgramasInclusionService } from '../../../../../../services/cotizador-contratante/consultar-programas-inclusion.service';
import { ProgramaInclusionItem } from '../../../../../../models/cotizador-contratante/consultar-programas-inclusion/response/consultar-programas-inclusion-response.model';
import { ConsultarCampanasNuevoService } from '../../../../../../services/cotizador-contratante/consultar-campanas-nuevo.service';
import { ConsultarCampanasNuevoParams } from '../../../../../../models/cotizador-contratante/consultar-campanas-nuevo/request/consultar-campanas-nuevo-request.model';
import { CampaniaNuevoItem } from '../../../../../../models/cotizador-contratante/consultar-campanas-nuevo/response/consultar-campanas-nuevo-response.model';
import { ConsultarTarifasIndividualesService } from '../../../../../../services/cotizador-contratante/consultar-tarifas-individuales.service';
import { ConsultarCotizacionService } from '../../../../../../services/cotizador-cotizacion/consultar-cotizacion.service';
import { ConsultarTarifasIndividualesParams } from '../../../../../../models/cotizador-contratante/consultar-tarifas-individuales/request/consultar-tarifas-individuales-request.model';
import { SubcuentaItem } from '../../../../../../models/cotizador-contratante/consultar-subcuentas/ressponse/consultar-subcuentas-response.model';
import { ProgramaSeleccionStore, ProgramasContratanteStore, ProgramaItemStore, ProgramaTarifaDetalle, ProgramaAnexoDetalle, ProgramaCampaniaDetalle } from '../../../../../../services/cotizador-contratante/programa-seleccion.store';
import {
  combinarContextoCotizacionPrecargada,
  CotizacionPrecargadaContexto
} from '../../../../../../models/cotizador-contratante/cotizacion-edicion-contexto.model';
import { BeneficiarioLocalStorageService } from '../../../../../../services/beneficiario/beneficiario-local-storage.service';

// TODO: Crear interface en archivo separado cuando se defina el modelo completo
interface Programa {
  id: string;
  codigo: string;
  nombre: string;
  lineaNegocio: 'MI' | 'SO' | 'CEM';
  color: string;
  imagen?: string;
  carnet?: string; // Base64 de la imagen del carnet
  grupoPrograma?: string; // Código del grupo al que pertenece
}

interface AnexoProgramaOption {
  planCod1: string;
  planCod2: string;
  nombre: string;
  tari: string;
  valor: string;
}

export interface ProgramaSeleccionado {
  id: string;
  nombre: string;
  grupoPrograma?: string;
  subcuenta: string;
  tarifa: string;
  campana: string;
  anexoCodigo?: string;
  tarifaAnexo?: string;
  nombreAnexo?: string;
  requiereAnexo?: 'si' | 'no' | null;
  anexosDisponibles?: AnexoProgramaOption[];
  subcuentasDisponibles: string[];
  /** true cuando ya se realizó la consulta de subcuentas (para mostrar mensaje si data viene vacía) */
  subcuentasConsultaRealizada?: boolean;
  /** Tarifas devueltas por el servicio para este programa (subcuenta + línea) */
  tarifasDisponibles: IListTarifa[];
  /** true cuando ya se realizó la consulta de tarifas (para mostrar mensaje si data viene vacía) */
  tarifasConsultaRealizada?: boolean;
  /** Individual: Legacy devolvió filas antes de cruzar con valores. */
  tarifasLegacyConDatos?: boolean;
  /** Individual: al menos una tarifa con valor monetario válido tras consultar valores. */
  tarifasValoresConDatos?: boolean;
  /** Campañas devueltas por el servicio (detalle completo para guardarCampanias). */
  campaniasDisponibles: CampaniaDetalleItem[];
  /** true cuando ya se realizó la consulta de campañas (para mostrar mensaje si data viene vacía) */
  campaniasConsultaRealizada?: boolean;
  /** Inclusión: tarifa coincidió con catálogo; el select queda bloqueado. */
  tarifaBloqueadaPorInclusion?: boolean;
  /** Inclusión: campaña coincidió con catálogo; el select queda bloqueado. */
  campanaBloqueadaPorInclusion?: boolean;
}

/** Detalle de campaña (paridad con campanias + buildCampaniasPayloadFromSeleccion). */
interface CampaniaDetalleItem {
  codigo_campania: string;
  nombre: string;
  modalidad?: string;
  tarifa?: string;
  descripcionTarifa?: string;
  cuenta?: number | string;
  subcuenta?: string;
  tipo_campania?: string;
  solo_nuevos?: string;
  ingresa_moroso?: string;
  meses_mora_permitidos?: string;
  bonifica_moroso?: string;
  id_campania?: number;
  tipo_plan?: string;
  parentesco?: string;
  edad_desde?: number;
  edad_hasta?: number;
  cant_benef_desde?: number;
  cant_benef_hasta?: number;
  acumulable?: boolean;
  pago_debito_auto?: boolean;
  aplica_pronto_pago?: boolean;
  observaciones?: string;
  usuario_actualizacion?: string;
  linea_negocio?: string;
  grupo_programa?: string;
  programa?: string;
  inicio_vigencia?: string;
  fin_vigencia?: string;
  estado?: boolean;
  genero?: string;
}

interface DatosModal {
  tipoDocumento: string;
  numeroDocumento: string;
  datosContratante: any;
  esUsuario?: boolean; // Indica si el contratante es usuario (SI/NO)
  validaciones?: any; // Datos de validaciones previas
  /** Id de cotización en BD cuando se retoma una incompleta; se usa para sincronizar validaciones/programas (back comentado). */
  idCotizacion?: number | string;
  /** Cuando true, oculta el tab ELECCIÓN PROGRAMA aunque esUsuario=true (los programas se gestionan desde otro lugar). */
  soloValidaciones?: boolean;
  editMode?: boolean;
  pasoActual?: number;
  idTipoSolicitud?: number | null;
  tieneProgramasContratantePersistidos?: boolean;
  programasContratantePersistidos?: any[];
  reiniciarProgramasPorCambioPlan?: boolean;
}

/** Item de validación guardado en validaciones_contratante (cada uno puede bloquear el proceso) */
interface ItemValidacion {
  fuente: string;
  descripcion: string;
  fechaEvento: string;
  tipo?: string; // 'error' | 'success' | 'info' para precarga y color
  bloquea_proceso?: boolean;
}

/** Payload guardado en validaciones_contratante */
interface ValidacionesContratantePayload {
  tipoDocumento?: string;
  idContratante: string;
  fechaConsulta?: string;
  items: ItemValidacion[];
}

@Component({
  selector: 'app-modal-seleccion-programas',
  templateUrl: './modal-seleccion-programas.component.html',
  styleUrls: ['./modal-seleccion-programas.component.css']
})
export class ModalSeleccionProgramasComponent implements OnInit {

  // Control de tabs (0 = resultados, 1 = programas)
  tabSeleccionadoIndex: number = 0;

  // Tab Resultados - Datos de validación (ADRES, Historial, Condición asociado, Consultas previas)
  historialCliente: any[] = [];
  estadoEPS: any[] = [];
  condicionAsociado: { tipo: string; mensaje: string }[] = [];
  consultasPrevias: { tipo: string; mensaje: string }[] = [];

  // Tab Programas - Línea de negocio y programas
  lineasSeleccionadas: ('MI' | 'SO' | 'CEM')[] = [];
  lineasNegocioDisponibles: { codigo: 'MI' | 'SO' | 'CEM', nombre: string, lineaOriginal: LineaNegocio }[] = [];
  programasDisponibles: Programa[] = [];
  programasSeleccionados: ProgramaSeleccionado[] = [];

  // Información del contratante
  nombreCompleto: string = '';
  tipoDocumento: string = '';
  numeroDocumento: string = '';

  // Control de visibilidad según si el contratante es usuario
  esUsuario: boolean | null = null;

  /** Keys de localStorage (viven en este componente) */
  readonly KEY_VALIDACIONES_CONTRATANTE = 'validaciones_contratante';
  readonly KEY_PROGRAMAS_CONTRATANTE = 'programas_contratante';
  readonly KEY_PROGRAMAS_CONTRATANTE_INCLUSIONES = 'programas_contratante_inclusiones';
  readonly KEY_DATOS_CONTRATANTE = 'datosRQ002_Contratante';
  readonly KEY_TIPO_PLAN = 'tipoPlan';
  readonly KEY_TIPO_SOLICITUD = 'tipoSolicitud';
  readonly KEY_TIPO_DOCUMENTO_EMPRESA = 'tipoDocumentoEmpresa';
  readonly KEY_NUMERO_DOCUMENTO_EMPRESA = 'numeroDocumentoEmpresa';
  readonly KEY_CONSULTAS_PREVIAS = 'consultas_previas_contratante';
  /** Marca de precarga desde incompleta (se setea en formulario-contratante). */
  readonly KEY_COTIZACION_PRECARGADA = 'cotizacion_precargada';
  /** true cuando tipoPlan es C (Colectivo) o GA (Grupos Afinidad); usa flujo con consulta activos + subcuentas del response */
  get esFlujoColectivoOGA(): boolean {
    const t = (localStorage.getItem(this.KEY_TIPO_PLAN) ?? '').toString().trim().toUpperCase();
    // En algunos entornos llega como AG; se soportan ambos
    return t === 'C' || t === 'GA' || t === 'AG';
  }

  /** NC0070: solo Grupos de afinidad. Colectivo (C) no entra. */
  get esFlujoGruposAfinidad(): boolean {
    const t = (localStorage.getItem(this.KEY_TIPO_PLAN) ?? '').toString().trim().toUpperCase();
    return t === 'GA' || t === 'AG';
  }

  /** F/A de Afilmed vs C en pantalla (AREA→AREC, OPLF→OPLC). */
  private coincidePlanCodiAfinidad(rowPlan: string, uiPlan: string): boolean {
    const r = (rowPlan || '').toString().trim().toUpperCase();
    const u = (uiPlan || '').toString().trim().toUpperCase();
    if (!r || !u) return false;
    if (r === u) return true;
    if ((r.endsWith('F') || r.endsWith('A')) && `${r.slice(0, -1)}C` === u) {
      return true;
    }
    return false;
  }

  /** En afinidad se guarda el plan de Afilmed (F/A). El código colectivo de pantalla no se persiste. */
  private elegirFilaAfinidad(filas: any[], codigoUi: string): any {
    if (!Array.isArray(filas) || filas.length === 0) return undefined;
    if (!this.esFlujoGruposAfinidad) return filas[0];

    const planDe = (row: any): string => String(row?.plan_codi ?? row?.PLAN_CODI ?? '').trim().toUpperCase();
    const ui = (codigoUi || '').toString().trim().toUpperCase();
    return filas.find((row) => {
      const plan = planDe(row);
      if (!(plan.endsWith('F') || plan.endsWith('A'))) return false;
      return plan === ui || `${plan.slice(0, -1)}C` === ui;
    });
  }

  /**
   * NC0082: getCampaniaCtz en C/GA usa plan_codi de ActivoAC, no el id UI.
   * En GA el carnet es OPLC y Afilmed trae OPLF/OPLA; no se transforma C→F.
   * Misma fila que tarifas (subcta + cuenta + coincidePlanCodiAfinidad). Fallback: id UI.
   */
  private resolverPlanCodiActivoAcParaCampania(uiPlan: string, subcta: string, cuenta: string): string {
    const fallback = (uiPlan || '').toString().trim();
    if (!this.esFlujoColectivoOGA || !subcta || !(this.datosColectivoGA?.length)) {
      return fallback;
    }
    const planCodigo = fallback.toUpperCase();
    const cuentaActual = (cuenta || '').toString().trim();
    const filas = (this.datosColectivoGA || []).filter((row: any) => {
      const rowPlan = (row.plan_codi ?? row.PLAN_CODI ?? '').toString().trim().toUpperCase();
      const rowSub = (row.subcta ?? row.SUBCTA ?? '').toString().trim();
      const rowCuenta = String(row.cuenta ?? row.CUENTA ?? '').trim();
      const mismaSubYCuenta = rowSub === subcta && (!cuentaActual || rowCuenta === cuentaActual);
      if (!mismaSubYCuenta) return false;
      return this.coincidePlanCodiAfinidad(rowPlan, planCodigo);
    });
    const fila = this.elegirFilaAfinidad(filas, planCodigo) || filas[0];
    const planRaw = (fila?.plan_codi ?? fila?.PLAN_CODI ?? '').toString().trim().toUpperCase();
    if (this.esFlujoGruposAfinidad && planRaw.endsWith('C')) {
      return fallback;
    }
    return planRaw || fallback;
  }

  /** true cuando hay algún programa colectivo/GA sin subcuenta seleccionada (usado en [disabled] del template). */
  get tieneColectivoSinSubcuenta(): boolean {
    if (!this.esFlujoColectivoOGA) return false;
    return this.programasSeleccionados.some(p => !p.subcuenta);
  }

  /** Inclusión (tipoSolicitud 2): preselección desde ConsultarProgramasxAfiliado + catálogo por parámetro. */
  get esFlujoInclusion(): boolean {
    return (localStorage.getItem(this.KEY_TIPO_SOLICITUD) ?? '').toString().trim() === '2';
  }

  /** Truco temporal de salida: en venta nueva individual solo se ofrece Medicina Integral. */
  private get ocultarLineasNoMiVentaNueva(): boolean {
    const tipoSolicitud = (localStorage.getItem(this.KEY_TIPO_SOLICITUD) ?? '1').toString().trim();
    return tipoSolicitud === '1' && !this.esFlujoInclusion && !this.esFlujoColectivoOGA;
  }

  /** Logs de diagnóstico anexo/store — filtrar en consola: [Store-Anexo-Trace] */
  private traceAnexo(paso: string, detalle?: Record<string, unknown>): void {
    console.log(`[Store-Anexo-Trace] ${paso}`, detalle ?? '');
  }

  private resumenAnexoEnStore(): Array<{ programa: string; anexoCodigo: string; tieneAnexoDetalle: boolean }> {
    const stored = this.programaSeleccionStore.cargar();
    return (stored?.programas ?? []).map(p => ({
      programa: (p.programa || '').trim(),
      anexoCodigo: (p.anexoCodigo || '').trim(),
      tieneAnexoDetalle: !!p.anexoDetalle,
    }));
  }

  private readonly grupoProgramaPorCodigo = new Map<string, string>();

  private readonly MENSAJE_SIN_ANTECEDENTES_AFILMED = 'No se encontraron antecedentes registrados en AFILMED para este usuario.';
  private readonly MENSAJE_NO_BENEFICIARIO_MI = 'Este usuario no puede ser beneficiario para la línea de negocio MI.';

  private readonly MENSAJE_BLOQUEO_RETIRO =
    'El sistema ha detectado que el cliente se retiró hace menos de 7 meses. Por políticas comerciales, no se permite realizar ventas nuevas en este caso.';

  /** Estado de cobertura CEM: true solo si el usuario validó y fue aprobada */
  coberturaCemValida: boolean = false;

  /** Response del servicio consultarSubcuentasColectivosGrupos; solo poblado cuando esFlujoColectivoOGA */
  private datosColectivoGA: ConsultarSubcuentasCoGaDataItem[] = [];
  /** Cuenta del colectivo/GA (del response getconsultacolectivoac); solo para C/GA en payload de tarifa/campaña */
  cuentaColectivoGA: number | null = null;
  /** plan_codi (trim) + subcta (trim) -> tari (trim). Solo para flujo C/GA. */
  private tarifasPorProgramaYSubcta: Map<string, string> = new Map();
  /** Cache para cotConsultarTarifa: cuenta:subcta:plan -> display */
  private cacheTarifaColectivo: Map<string, string> = new Map();
  /** plan_codi (trim) + subcta (trim) -> label (nombre_fantasia + ciudad). Solo para flujo C/GA. */
  private labelsPorProgramaYSubcta: Map<string, string> = new Map();
  /** plan_codi (trim) -> claves "subcta:cuenta" válidas del colectivo/GA. */
  private subcuentasValidasPorPlan: Map<string, Set<string>> = new Map();
  /** programaId -> (deno trim -> subcta trim). Se llena al consultar subcuentas. */
  private mapaDenoASubctaPorPrograma: Map<string, Map<string, string>> = new Map();
  /** programaId -> (deno trim -> plan_grupo trim). Se llena al consultar subcuentas. */
  private mapaDenoAPlanGrupoPorPrograma: Map<string, Map<string, string>> = new Map();
  /** programaId -> (deno trim -> label). Para mostrar en el select de subcuentas. */
  private mapaDenoALabelPorPrograma: Map<string, Map<string, string>> = new Map();
  /** Id de cotización resuelto/creado en esta sesión del modal (fallback cuando no viene en data). */
  private idCotizacionActual: number | null = null;

  // ──  Snapshot de contingencia exclusivo para restaurar sesiones de edición en Inclusiones ──
  private inclusionSnapshotAlAbrir: string | null = null;

  /**
   * Copia del store programas_contratante al abrir el modal.
   * Se usa para restaurar en "Salir sin guardar" y no perder idBenPrograma/guardadoEnBd.
   */
  private programasStoreSnapshotAlAbrir: ProgramasContratanteStore | null = null;
  private habiaProgramasStoreAlAbrir = false;

  /**
   * Última suscripción HTTP de consultar anexos por id de programa.
   * Se cancela al disparar una nueva consulta para el mismo programa (evita doble llamada y respuestas cruzadas).
   */
  private consultarAnexosSubscriptionPorPrograma = new Map<string, Subscription>();

  /**
   * Por código de plan (trim): tarifa/campaña sugeridas por consultar programas inclusión.
   * Solo se usa en flujo inclusión para preseleccionar si existen en los catálogos de servicios.
   */
  private inclusionPreferenciasPorPrograma = new Map<string, { tarifa: string | null; campana: string | null; nombreTarifa?: string | null; codCuenta?: string | null; subcuenta?: string | null }>();
  /**
   * Resuelve el idCotizacion en curso para evitar crear una nueva cuando ya existe:
   * 1) data.idCotizacion (si el modal fue abierto con una incompleta)
   * 2) idCotizacionActual (si ya se creó dentro de este modal)
   * 3) KEY_COTIZACION_CREADA_DESDE_CONTRATANTE (response guardado por este flujo)
   * 4) KEY_COTIZACION_PRECARGADA (precarga desde incompleta más reciente)
   */
  private getIdCotizacionEnCurso(): number | null {
    const fromData = Number((this.data as any)?.idCotizacion);
    if (Number.isFinite(fromData) && fromData > 0) return fromData;

    if (this.idCotizacionActual != null && Number.isFinite(this.idCotizacionActual) && this.idCotizacionActual > 0) {
      return this.idCotizacionActual;
    }

    // 3) Cotización creada desde este flujo (response del backend + documento)
    try {
      const raw = localStorage.getItem(KEY_COTIZACION_CREADA_DESDE_CONTRATANTE);
      if (raw) {
        const saved = JSON.parse(raw);
        const tipoDocSaved = (saved?.tipoDocumento ?? '').toString().trim();
        const numDocSaved = (saved?.numeroDocumento ?? '').toString().trim();
        const tipoDocActual = (this.tipoDocumento ?? '').toString().trim();
        const numDocActual = (this.numeroDocumento ?? '').toString().trim();
        if (tipoDocSaved && numDocSaved && tipoDocSaved === tipoDocActual && numDocSaved === numDocActual) {
          // La key `cotizacion_creada_desde_contratante` guarda el response en la raíz (no dentro de `data`)
          const id = Number(saved?.idCotizacion ?? saved?.data?.idCotizacion);
          if (Number.isFinite(id) && id > 0) return id;
        }
      }
    } catch (_) { }

    // 4) Precarga / edición: exigir mismo documento (NC0107: sin match reutilizaba id viejo → UPDATE).
    try {
      const raw = localStorage.getItem(this.KEY_COTIZACION_PRECARGADA);
      if (raw) {
        const prec = JSON.parse(raw);
        const tipoDocSaved = (prec?.tipoDocumento ?? '').toString().trim();
        const numDocSaved = (prec?.numeroDocumento ?? '').toString().trim();
        const tipoDocActual = (this.tipoDocumento ?? '').toString().trim();
        const numDocActual = (this.numeroDocumento ?? '').toString().trim();
        if (tipoDocSaved && numDocSaved && tipoDocSaved === tipoDocActual && numDocSaved === numDocActual) {
          const id = Number(prec?.idCotizacion);
          if (Number.isFinite(id) && id > 0) return id;
        }
      }
    } catch (_) { }

    return null;
  }

  /** Filtra subcuentas del servicio consultarSubcuentas por subcta + cuenta del colectivo/GA. */
  private filtrarSubcuentasColectivoGA(planId: string, todos: SubcuentaItem[]): SubcuentaItem[] {

    if (!this.esFlujoColectivoOGA || this.esFlujoInclusion || !this.datosColectivoGA || this.datosColectivoGA.length === 0) {
      return todos;
    }

    const cuentaActual = this.cuentaColectivoGA != null ? String(this.cuentaColectivoGA).trim() : '';
    const planIdNorm = (planId || '').trim().toUpperCase();

    const obtenerCodigoComercialC = (codigo: string): string => {
      const c = (codigo || '').toString().trim().toUpperCase();
      if (c.endsWith('F') || c.endsWith('A')) {
        return c.substring(0, c.length - 1) + 'C';
      }
      return c;
    };

    const subctasColectivoMap = new Map<string, any>();
    (this.datosColectivoGA || []).forEach((row: any) => {
      const rowCuenta = String(row.cuenta ?? row.CUENTA ?? '').trim();
      const rawPlan = (row.plan_codi ?? row.PLAN_CODI ?? '').toString().trim().toUpperCase();
      const rowSub = (row.subcta ?? row.SUBCTA ?? '').toString().trim();
      // GA: solo plan_codi crudo F/A → id UI C. No identidad C==C (eso metía AFISAO en OPLC).
      const matchPlan = this.esFlujoGruposAfinidad
        ? this.coincidePlanCodiAfinidad(rawPlan, planIdNorm)
        : obtenerCodigoComercialC(rawPlan) === planIdNorm;

      if (rowSub && (rowCuenta === cuentaActual || !cuentaActual) && matchPlan) {
        subctasColectivoMap.set(rowSub, row);
      }
    });

    // NC0011: mapa vacío no devolver el catálogo nacional (combo sucio PST).
    if (subctasColectivoMap.size === 0) {
      return [];
    }

    // 2. Catálogo: misma subcta del activo Y misma cuenta (Inclusión ya filtra así).
    const coincidencias = todos.filter(i => {
      const subCode = (i.subcta || '').toString().trim();
      if (!subctasColectivoMap.has(subCode)) return false;
      if (!cuentaActual) return true;
      const iCuenta = (i.cuenta ?? (i as any).CUENTA ?? '').toString().trim();
      return iCuenta === cuentaActual;
    });

    const esPlanCem = planIdNorm.includes('CEM');
    if (!esPlanCem && coincidencias.length > 1) {
      const sinCem = coincidencias.filter(i => {
        const subCode = (i.subcta || '').toString().trim().toUpperCase();
        const denoName = (i.deno || '').toString().trim().toUpperCase();
        return !subCode.startsWith('CEM') && !denoName.startsWith('CEM');
      });
      if (sinCem.length > 0) {
        return sinCem;
      }
    }

    if (coincidencias.length > 0) {
      return coincidencias;
    }
    if (coincidencias.length > 0) {
      return coincidencias;
    }

    // 3. Fallback: Si el catálogo general no trajo la subcuenta, creamos los ítems directamente desde consultaActivoAC
    const sinteticas: SubcuentaItem[] = Array.from(subctasColectivoMap.values()).map((row: any) => {
      const subCode = (row.subcta ?? row.SUBCTA ?? '').toString().trim();
      const denoName = (
        row.nombre_fantasia ||
        row.plan_deno ||
        row.tari_deno ||
        row.descripcion_sucursal ||
        `SUBCUENTA ${subCode}`
      ).toString().trim();

      return {
        subcta: subCode,
        deno: denoName,
        cuenta: row.cuenta,
        plan_grupo: row.plan_grupo || row.grupo_programa || ''
      } as any;
    });

    return sinteticas;
  }

  getSubcuentaLabel(programaId: string, deno: string): string {
    const p = (programaId || '').trim();
    const d = (deno || '').trim();
    return this.mapaDenoALabelPorPrograma.get(p)?.get(d) ?? deno;
  }

  /**
   * Label C/GA: plan_codi del programa actual + subcta + cuenta.
   * Si varios planes comparten la misma subcta, NO tomar el primer plan del response
   * (eso hacía que OROC mostrara OR2KC). Solo se usa en esFlujoColectivoOGA.
   */
  private getPlanCodiLabelColectivo(
    subcta: string,
    fallbackPlan: string
  ): string {
    const sub = String(subcta || '').trim();
    const fallback = String(fallbackPlan || '')
      .trim()
      .toUpperCase();

    const cuentaActual = this.cuentaColectivoGA != null
      ? String(this.cuentaColectivoGA).trim()
      : '';

    const fila = (this.datosColectivoGA || []).find(
      (row: any) => {
        const rowSubcta = String(
          row?.subcta ??
          row?.SUBCTA ??
          ''
        ).trim();

        const rowCuenta = String(
          row?.cuenta ??
          row?.CUENTA ??
          ''
        ).trim();

        const rowPlan = String(
          row?.plan_codi ??
          row?.PLAN_CODI ??
          ''
        ).trim().toUpperCase();

        const coincidePlan = this.coincidePlanCodiAfinidad(
          rowPlan,
          fallback
        );

        return (
          coincidePlan &&
          rowSubcta === sub &&
          (!cuentaActual || rowCuenta === cuentaActual)
        );
      }
    );

    return String(
      fila?.plan_codi ??
      fallback
    ).trim().toUpperCase();
  }

  /** Mensaje de hint debajo del select de subcuenta en flujo Colectivo / GA. */
  getSubcuentaHintMessage(programaSel: ProgramaSeleccionado): string | null {
    if (!this.esFlujoColectivoOGA) return null;
    if (programaSel.subcuentasConsultaRealizada && (programaSel.subcuentasDisponibles?.length ?? 0) === 0) {
      return 'No se encontraron subcuentas para este programa.';
    }
    return null;
  }

  private marcarSubcuentasConsultaSinResultados(programaSel: ProgramaSeleccionado): void {
    programaSel.subcuentasConsultaRealizada = true;
    programaSel.subcuentasDisponibles = [];
  }

  /**
   * NC0011: una fila por subcta (first-wins / orden estable).
   * Genérico: no hardcodea códigos de subcuenta.
   */
  private deduplicarSubcuentasPorSubcta(items: SubcuentaItem[]): SubcuentaItem[] {
    const seen = new Set<string>();
    const out: SubcuentaItem[] = [];
    for (const i of items || []) {
      const sub = (i?.subcta || '').toString().trim();
      if (!sub || seen.has(sub)) continue;
      seen.add(sub);
      out.push(i);
    }
    return out;
  }

  /**
   * Clave de opción del select: si el mismo deno apunta a varias subcta,
   * desambiguar con subcta para no colapsar (NC0011). Genérico.
   */
  private claveOpcionSubcuenta(
    deno: string,
    subcta: string,
    denoCount: Map<string, number>,
    desambiguarPorSubcta: boolean
  ): string {
    const d = (deno || '').trim();
    const s = (subcta || '').trim();
    if (!d) return '';
    if (desambiguarPorSubcta && s && (denoCount.get(d) || 0) > 1) {
      return `${d}||${s}`;
    }
    return d;
  }

  private procesarSubcuentasRespuesta(
    programaSel: ProgramaSeleccionado,
    codigoPrograma: string,
    todos: SubcuentaItem[],
    options?: { filtrarColectivoGA?: boolean; autoSeleccionarPrimera?: boolean }
  ): void {
    const filtrar = options?.filtrarColectivoGA ?? false;
    const autoSel = options?.autoSeleccionarPrimera ?? false;
    const preseleccionada = (programaSel.subcuenta || '').toString().trim();
    programaSel.subcuentasConsultaRealizada = true;
    let items = filtrar ? this.filtrarSubcuentasColectivoGA(codigoPrograma, todos) : todos;

    // C/GA: no fusionar subcuentas distintas que compartan el mismo nombre comercial.
    const desambiguar = filtrar && this.esFlujoColectivoOGA;
    if (desambiguar) {
      items = this.deduplicarSubcuentasPorSubcta(items);
    }

    const denoCount = new Map<string, number>();
    if (desambiguar) {
      items.forEach(i => {
        const d = (i.deno || '').trim();
        if (d) denoCount.set(d, (denoCount.get(d) || 0) + 1);
      });
    }

    const subcuentasDisponiblesUnicas = Array.from(
      new Set(
        items
          .map(i => this.claveOpcionSubcuenta((i.deno || '').trim(), (i.subcta || '').trim(), denoCount, desambiguar))
          .filter(Boolean)
      )
    );
    programaSel.subcuentasDisponibles = subcuentasDisponiblesUnicas;

    const mapa = new Map<string, string>();
    const mapaPlanGrupo = new Map<string, string>();
    const mapaLabel = new Map<string, string>();
    items.forEach(i => {
      const deno = (i.deno || '').trim();
      const sub = (i.subcta || '').trim();
      const planGrupo = (i.plan_grupo || '').trim();
      const key = this.claveOpcionSubcuenta(deno, sub, denoCount, desambiguar);
      if (key && sub) {
        mapa.set(key, sub);
        if (planGrupo) mapaPlanGrupo.set(key, planGrupo);
        if (this.esFlujoColectivoOGA) {
          const base = this.getPlanCodiLabelColectivo(sub, codigoPrograma.trim()) || deno;
          mapaLabel.set(key, `${base} (ID:${sub} - ${deno})`);
        }
      }
    });
    this.mapaDenoASubctaPorPrograma.set(programaSel.id, mapa);
    this.mapaDenoAPlanGrupoPorPrograma.set(programaSel.id, mapaPlanGrupo);
    if (this.esFlujoColectivoOGA) {
      this.mapaDenoALabelPorPrograma.set(programaSel.id, mapaLabel);
    }

    // Restaurar subcuenta precargada (no pisarla con autoSel vacío).
    const preNorm = preseleccionada.toUpperCase();
    let denoRestaurada = '';
    if (preNorm) {
      denoRestaurada = subcuentasDisponiblesUnicas.find(d => d.toUpperCase() === preNorm) || '';
      if (!denoRestaurada) {
        // Prefijo/label guardado o código técnico subcta
        for (const [deno, subcta] of mapa.entries()) {
          if (
            deno.toUpperCase() === preNorm
            || subcta.toUpperCase() === preNorm
            || preNorm.includes(`ID:${subcta}`)
            || preNorm.includes(`(${subcta}`)
            || preNorm.endsWith(`- ${deno.toUpperCase()})`)
          ) {
            denoRestaurada = deno;
            break;
          }
        }
      }
    }

    if (denoRestaurada) {
      programaSel.subcuenta = denoRestaurada;
    } else if (autoSel && subcuentasDisponiblesUnicas.length === 1) {
      programaSel.subcuenta = subcuentasDisponiblesUnicas[0];
    } else if (autoSel && !preseleccionada) {
      programaSel.subcuenta = '';
    }
    // Si había preselección inválida, conservar el valor para que el usuario lo vea/corrija.
  }

  constructor(
    public dialogRef: MatDialogRef<ModalSeleccionProgramasComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DatosModal,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private consultarLineasService: ConsultarLineasGruposProgramasService,
    private consultarSubcuentasService: ConsultarSubcuentasService,
    private networkingBeneficiary: NetworkingBeneficiary,
    private consultarHistorialService: ConsultarHistorialService,
    private consultarAsociadoService: ConsultarAsociadoService,
    private cotizacionesIncompletasService: CotizacionesIncompletasService,
    private crearCotizacionContratanteService: CrearCotizacionContratanteService,
    private consultarProgramasContratanteService: ConsultarProgramasContratanteService,
    private consultarSubcuentasColectivosGruposService: ConsultarSubcuentasColectivosGruposService,
    private consultarTarifasColectivosGruposService: ConsultarTarifasColectivosGruposService,
    private consultarAnexosColectivosGruposService: ConsultarAnexosColectivosGruposService,
    private consultarProgramasInclusionService: ConsultarProgramasInclusionService,
    private consultarCampanasNuevoService: ConsultarCampanasNuevoService,
    private consultarTarifasIndividualesService: ConsultarTarifasIndividualesService,
    private programaSeleccionStore: ProgramaSeleccionStore,
    private beneficiarioLocalStorage: BeneficiarioLocalStorageService,
    private consultarCotizacionService: ConsultarCotizacionService,
    private cdr: ChangeDetectorRef
  ) {
    // Inicializar datos del contratante
    this.tipoDocumento = this.data.tipoDocumento || '';
    this.numeroDocumento = this.data.numeroDocumento || '';

    // Cargar esUsuario desde los datos
    this.esUsuario = this.data.esUsuario !== undefined
      ? this.data.esUsuario
      : null;

    if (this.data.datosContratante) {
      const { primerNombre, segundoNombre, primerApellido, segundoApellido } = this.data.datosContratante;
      this.nombreCompleto = `${primerNombre || ''} ${segundoNombre || ''} ${primerApellido || ''} ${segundoApellido || ''}`.trim();
    }
  }

  /*
    ngOnInit(): void {
      // Diferir la carga para que el modal se pinte primero; el spinner solo se muestra mientras se llaman los servicios
      setTimeout(() => {
        this.cargarResultadosValidacion();
        if (this.esUsuario === true) {
          if (this.esFlujoColectivoOGA) {
            this.cargarLineasNegocio(false);
            this.cargarProgramasYPreseleccionColectivoGA();
          } else if (this.esFlujoInclusion) {
            this.cargarLineasNegocio(false);
            this.cargarProgramasYPreseleccionInclusion();
          } else {
            this.cargarLineasNegocio(false, () => {
              if (this.esPrecargaVisualFAEM) {
                this.cargarProgramasPrecargadosVisualFAEM();
              } else if (this.esPrecargaIncompleta || this.esEditModeActivo) {
                this.cargarProgramasPrecargadosEditableFAEM();
              } else {
                this.intentarPrecargarProgramasDesdeLocalStorage();
              }
            });
          }
        }
      }, 0);
    }*/

  ngOnInit(): void {

    if (this.esFlujoInclusion) {
      this.inclusionSnapshotAlAbrir = localStorage.getItem(this.KEY_PROGRAMAS_CONTRATANTE);
      console.log('[Flujo-Inclusion] Estado inicial respaldado con éxito al abrir el modal.');

      localStorage.setItem(this.KEY_PROGRAMAS_CONTRATANTE_INCLUSIONES, this.inclusionSnapshotAlAbrir || '[]');

      console.log('[Flujo-Inclusion] Estado inicial respaldado con éxito al abrir el modal.');
    }

    this.capturarSnapshotProgramasAlAbrir();
    // Diferir la carga para que el modal se pinte primero
    setTimeout(() => {
      this.traceAnexo('Modal ngOnInit', {
        esUsuario: this.esUsuario,
        esFlujoInclusion: this.esFlujoInclusion,
        esFlujoColectivoOGA: this.esFlujoColectivoOGA,
        esPrecargaIncompleta: this.esPrecargaIncompleta,
        esEditModeActivo: this.esEditModeActivo,
        esPrecargaVisualFAEM: this.esPrecargaVisualFAEM,
        idCotizacion: this.getIdCotizacionEnCurso(),
        storeAntes: this.resumenAnexoEnStore(),
      });

      this.cargarResultadosValidacion();
      if (this.esUsuario === true) {

        // se da prioridad de inclución
        if (this.esFlujoInclusion) {
          this.traceAnexo('Rama precarga', { destino: 'cargarProgramasYPreseleccionInclusion' });
          this.cargarLineasNegocio(false);
          this.cargarProgramasYPreseleccionInclusion();
        } else if (this.esFlujoColectivoOGA) {
          this.traceAnexo('Rama precarga', { destino: 'cargarProgramasYPreseleccionColectivoGA' });
          this.cargarLineasNegocio(false);
          this.cargarProgramasYPreseleccionColectivoGA();
        } else {
          this.cargarLineasNegocio(false, () => {
            if (this.esPrecargaVisualFAEM) {
              this.traceAnexo('Rama precarga', { destino: 'cargarProgramasPrecargadosVisualFAEM' });
              this.cargarProgramasPrecargadosVisualFAEM();
            } else if (this.data.reiniciarProgramasPorCambioPlan === true) {
              this.traceAnexo('Rama precarga', { destino: 'intentarPrecargarProgramasDesdeLocalStorage (cambio plan)' });
              this.intentarPrecargarProgramasDesdeLocalStorage();
            } else if (this.esPrecargaIncompleta || this.esEditModeActivo) {
              this.traceAnexo('Rama precarga', { destino: 'cargarProgramasPrecargadosEditableFAEM (BD primero)' });
              this.cargarProgramasPrecargadosEditableFAEM();
            } else {
              this.traceAnexo('Rama precarga', { destino: 'intentarPrecargarProgramasDesdeLocalStorage' });
              this.intentarPrecargarProgramasDesdeLocalStorage();
            }
          });
        }

      }
    }, 0);
  }



  /**
   * Verificar si se debe mostrar la pestaña de programas
   */
  get mostrarPestanaProgramas(): boolean {
    return this.esUsuario === true && !this.data.soloValidaciones && !this.procesoBloqueadoPorHistorial;
  }

  /**
   * Verificar si se debe mostrar la sección de EPS
   */
  get mostrarSeccionEPS(): boolean {
    //  Solo se muestra si es usuario Y si el servicio ADRES no está caído/vacío
    return this.esUsuario === true && this.estadoEPS && this.estadoEPS.length > 0;
  }

  /** true cuando validaciones_contratante tiene bloquea_proceso (retiro < 7 meses, tipoSolicitud 1). */
  /** 15/08/2026 Ya no bloquea el proceso. Se conserva por compatibilidad, pero siempre retorna false. */

  get procesoBloqueadoPorHistorial(): boolean {
    // if ((localStorage.getItem(this.KEY_TIPO_SOLICITUD) ?? '').trim() !== '1') {
    //   return false;
    // }
    // try {
    //   const raw = localStorage.getItem(this.KEY_VALIDACIONES_CONTRATANTE);
    //   const parsed = raw ? JSON.parse(raw) : null;
    //   return Array.isArray(parsed?.items)
    //     && parsed.items.some((i: ItemValidacion) => i.bloquea_proceso === true);
    // } catch {
    //   return false;
    // }
    return false;
  }

  /** Ventana en meses para considerar válida una consulta precargada (consultas asociadas). */
  private readonly MESES_VALIDEZ_CONSULTA = 6;

  /**
   * Cargar resultados de validaciones (Tab 1). Si hay datos en validaciones_contratante para el mismo documento
   * y fechaConsulta < 7 meses, se precargan; si no, se llaman ADRES e Historial y se guarda con fechaConsulta.
   */
  cargarResultadosValidacion(): void {
    this.historialCliente = [];
    this.estadoEPS = [];
    this.condicionAsociado = [];
    this.consultasPrevias = [];

    const tipoDoc = this.tipoDocumento?.trim() || '';
    const numDoc = this.numeroDocumento?.trim() || '';

    if (!tipoDoc || !numDoc) { return; }

    const precargado = this.intentarPrecargarValidaciones(tipoDoc, numDoc);
    if (precargado) {
      if (this.procesoBloqueadoPorHistorial) {
        this.mostrarPopupBloqueoRetiro();
      }
      return;
    }

    console.log('Consultando servicios externos');
    this.spinner.show();

    const historial$ = this.consultarHistorialService.consultarHistorial({
      pty_tipo_documento: tipoDoc,
      pty_documento: numDoc
    }).pipe(
      catchError(err => {
        console.error('Error en consultarHistorial:', err);
        return of(null);
      })
    );

    const adres$ = this.esUsuario === true ? this.networkingBeneficiary.consultarAdres(tipoDoc, numDoc).pipe(
      catchError(err => {
        console.error('Error capturado en servicio ADRES:', err);

        const mensaje = this.mapearErrorAdres(err);

        const isHttpError = err?.status === 503 || err?.status === 500 || err?.status === 0 || err?.status === 504;
        const isBodyError = err?.error?.codeStatus === '503' || err?.error?.codeStatus === '500' || err?.error?.message === 'Servicio inactivo';

        if (isHttpError || isBodyError || mensaje === 'No se pudo completar la consulta de EPS.' || mensaje.includes('Error en el servicio')) {
          console.log('[ADRES-Modal] Falla de infraestructura detectada. Forzando estado vacío para ocultar sección.');
          this.estadoEPS = []; // 
        } else {
          this.estadoEPS = [{ tipo: 'error', mensaje }];
        }

        return of(null);
      })
    ) : of(null);

    const asociado$ = this.consultarAsociadoService.consultarAsociado(
      ConsultarAsociadoService.buildRequest(tipoDoc, numDoc)
    ).pipe(
      catchError(err => {
        console.error('Error en consultarAsociado:', err);
        return of(null);
      })
    );

    forkJoin({ historial: historial$, adres: adres$, asociado: asociado$ }).subscribe({
      next: ({ historial, adres, asociado }) => {
        try {
          const itemsKey: ItemValidacion[] = [];

          if (adres) {
            const adresControl = adres as any;
            if (adresControl.codeStatus === '503' || adresControl.codeStatus === '500' || adresControl.message === 'Servicio inactivo' || adresControl.errorMessage?.includes('desactivada')) {
              console.log('[ADRES-Modal]  Payload de error/inactividad interno detectado en DTO. Limpiando estadoEPS.');
              this.estadoEPS = [];
            } else if (!adres.afiliacion) {
              this.estadoEPS = [{ tipo: 'error', mensaje: 'No se encontró información asociada a la EPS del usuario.' }];
              this.estadoEPS.forEach(t => itemsKey.push({ fuente: 'ADRES', descripcion: t.mensaje, fechaEvento: '', tipo: t.tipo }));
            } else {
              const a = adres.afiliacion;
              this.estadoEPS = [
                { tipo: 'success', mensaje: `El usuario se encuentra ${a.estado?.toLowerCase() === 'activo' ? 'activo' : 'inactivo'} en ${a.entidad}.` },
                { tipo: 'success', mensaje: `El usuario se encuentra bajo régimen ${a.regimen?.toLowerCase()}.` }
              ];
              const fechaAdres = a.fecha_efectiva || (adres as any).fecha_creacion || a.fecha_creacion || '';
              this.estadoEPS.forEach(t => itemsKey.push({ fuente: 'ADRES', descripcion: t.mensaje, fechaEvento: fechaAdres, tipo: t.tipo }));
            }
          } else if (this.estadoEPS.length > 0) {
            this.estadoEPS.forEach(t => itemsKey.push({ fuente: 'ADRES', descripcion: t.mensaje, fechaEvento: '', tipo: t.tipo }));
          }

          let bloqueaProcesoEnHistorial = false;
          if (historial?.status && historial.data?.jsonRespuesta?.length) {
            const tarjetasHistorial = this.mapearHistorialATarjetas(historial.data.jsonRespuesta);
            this.historialCliente = tarjetasHistorial;
            const primerItem = historial.data.jsonRespuesta[0];
            const tipoSolicitud = localStorage.getItem(this.KEY_TIPO_SOLICITUD);
            const meses = this.mesesDesdeRetiro(primerItem?.realbaja_fecha);

            if (tipoSolicitud === '1' && meses !== null && meses >= 0 && meses <= 7) {
              bloqueaProcesoEnHistorial = true;
            }
            const itemsHistorial = this.mapearTarjetasHistorialAItemsKey(historial.data.jsonRespuesta, tarjetasHistorial, bloqueaProcesoEnHistorial);
            itemsKey.push(...itemsHistorial);

            if (meses !== null && meses >= 0 && meses <= 7) {
              this.guardarConsultaPreviaEnStorage(tipoDoc, numDoc, itemsKey);
              this.consultasPrevias = this.recuperarConsultasPrevias(tipoDoc, numDoc);
              this.consultasPrevias.forEach(c => itemsKey.push({ fuente: 'Consultas previas', descripcion: c.mensaje, fechaEvento: '', tipo: c.tipo }));
            }
          } else {
            this.historialCliente = [{ tipo: 'info', mensaje: this.MENSAJE_SIN_ANTECEDENTES_AFILMED }];
            itemsKey.push({ fuente: 'Historial Afilmed', descripcion: this.MENSAJE_SIN_ANTECEDENTES_AFILMED, fechaEvento: '', tipo: 'info' });
          }

          // ── EVALUACIÓN CONDICIÓN ASOCIADO ────────────────────────────────────
          if (asociado) {
            this.condicionAsociado = this.mapearCondicionAsociadoDesdeAsociado(asociado);
          } else {
            this.condicionAsociado = [{ tipo: 'info', mensaje: 'No se pudo determinar la condición de asociado del contratante.' }];
          }
          this.condicionAsociado.forEach(c => itemsKey.push({ fuente: 'Condición asociado', descripcion: c.mensaje, fechaEvento: '', tipo: c.tipo }));

          const payload: ValidacionesContratantePayload = { tipoDocumento: tipoDoc, idContratante: numDoc, fechaConsulta: new Date().toISOString(), items: itemsKey };
          localStorage.setItem(this.KEY_VALIDACIONES_CONTRATANTE, JSON.stringify(payload));
          this.spinner.hide();

          if (itemsKey.some(i => i.bloquea_proceso)) {
            this.mostrarPopupBloqueoRetiro();
          }
        } catch (innerError) {
          console.error('Error crítico procesando la suscripción de validaciones:', innerError);
          this.spinner.hide();
        }
      },
      error: (err) => {
        console.error('Error general en el flujo forkJoin de validaciones:', err);
        this.spinner.hide();
      }
    });
  }

  private formatearFechaDDMMYYYY(iso: string | null | undefined): string {
    if (!iso || !String(iso).trim()) return '';
    const s = String(iso).trim();
    const [y, m, d] = s.split('-');
    if (!d || !m || !y) return s;
    return `${d.padStart(2, '0')}/${m.padStart(2, '0')}/${y}`;
  }

  private mostrarPopupBloqueoRetiro(): void {
    this.tabSeleccionadoIndex = 0;
    this.dialog.open(PopUpMensajeComponent, {
      width: '500px',
      maxWidth: '90vw',
      disableClose: true,
      data: {
        titulo: 'No es posible continuar',
        texto: this.MENSAJE_BLOQUEO_RETIRO,
        tipoIcono: 'error',
        textoBoton: 'ACEPTAR'
      } as PopUpMensajeData
    });
  }

  /** Meses transcurridos desde la fecha de retiro (realbaja_fecha). Retorna null si no hay fecha válida. */
  private mesesDesdeRetiro(realbaja_fecha: string | null | undefined): number | null {
    if (!realbaja_fecha || !String(realbaja_fecha).trim()) return null;
    const s = String(realbaja_fecha).trim();
    const parts = s.split('-').map(Number);
    const y = parts[0], m = parts[1], d = parts[2];
    if (!y || !m) return null;
    const fechaBaja = new Date(y, m - 1, d || 1);
    const hoy = new Date();
    let meses = (hoy.getFullYear() - fechaBaja.getFullYear()) * 12 + (hoy.getMonth() - fechaBaja.getMonth());
    if (hoy.getDate() < fechaBaja.getDate()) meses--;
    return meses;
  }

  /**
   * Intenta precargar desde validaciones_contratante si el documento coincide y la fecha de consulta es menor a 7 meses.
   * @returns true si se precargó y no debe llamar a los servicios
   */
  private intentarPrecargarValidaciones(tipoDoc: string, numDoc: string): boolean {
    try {
      const raw = localStorage.getItem(this.KEY_VALIDACIONES_CONTRATANTE);
      if (!raw) return false;
      const stored: ValidacionesContratantePayload = JSON.parse(raw);
      if (!stored.items || !Array.isArray(stored.items)) return false;
      if (stored.tipoDocumento !== tipoDoc || stored.idContratante !== numDoc) return false;
      if (!stored.fechaConsulta) return false;
      const fechaConsulta = new Date(stored.fechaConsulta);
      const haceMeses = new Date();
      haceMeses.setMonth(haceMeses.getMonth() - this.MESES_VALIDEZ_CONSULTA);
      // En modo edición siempre usar las validaciones almacenadas sin validar antigüedad.
      let editModeActivo = false;
      try {
        const rawPrec = localStorage.getItem(this.KEY_COTIZACION_PRECARGADA);
        editModeActivo = rawPrec ? JSON.parse(rawPrec)?.editMode === true : false;
      } catch (_) { }
      if (!editModeActivo && fechaConsulta < haceMeses) return false;

      const items = stored.items;
      this.estadoEPS = items
        .filter(i =>
          i.fuente === 'ADRES' &&
          i.descripcion !== 'No se pudo completar la consulta de EPS.' &&
          !i.descripcion.includes('Error en el servicio')
        )
        .map(i => ({ tipo: i.tipo || 'success', mensaje: i.descripcion }));
      this.historialCliente = items
        .filter(i => i.fuente === 'Historial Afilmed')
        .map(i => ({ tipo: i.tipo || 'info', mensaje: i.descripcion }));
      this.condicionAsociado = items
        .filter(i => i.fuente === 'Condición asociado')
        .map(i => ({ tipo: i.tipo || 'success', mensaje: i.descripcion }));
      this.consultasPrevias = items
        .filter(i => i.fuente === 'Consultas previas')
        .map(i => ({ tipo: i.tipo || 'info', mensaje: i.descripcion }));

      return true;
    } catch (_) {
      return false;
    }
  }

  private mapearHistorialATarjetas(items: HistorialItem[]): { tipo: string; mensaje: string }[] {
    const tarjetas: { tipo: string; mensaje: string }[] = [];
    const primerItem = items[0];
    if (!primerItem) return tarjetas;

    // 3.1 Negación: alerta roja + fecha (es_negado !== '0', fecha_negado)
    const esNegado = (primerItem.es_negado || '').trim() !== '0';
    if (esNegado && primerItem.fecha_negado) {
      const fechaNegado = this.formatearFechaDDMMYYYY(primerItem.fecha_negado);
      tarjetas.push({
        tipo: 'error',
        mensaje: `El usuario presenta antecedentes de negación el día ${fechaNegado}.`
      });
    } else if (esNegado) {
      tarjetas.push({
        tipo: 'error',
        mensaje: 'El usuario presenta antecedentes de negación.'
      });
    }

    if (primerItem.realbaja_fecha?.trim() || primerItem.motivo_retiro?.trim()) {
      const fecha = this.formatearFechaDDMMYYYY(primerItem.realbaja_fecha);
      const motivo = (primerItem.motivo_retiro || '').trim() || 'no indicado';
      tarjetas.push({
        tipo: 'error',
        mensaje: `El usuario presenta antecedentes de retiro el día ${fecha} por motivo ${motivo}.`
      });
    }

    // 3.3 Solo cuando bloquea_ingreso = S/s (independiente de negación/retiro)
    const bloqueaIngreso = (primerItem.bloquea_ingreso || '').trim().toUpperCase() === 'S';
    if (bloqueaIngreso) {
      tarjetas.push({ tipo: 'error', mensaje: this.MENSAJE_NO_BENEFICIARIO_MI });
    }

    // 3.4 Reactivación: alerta en verde (tipo success)
    if (primerItem.aplica_reactivacion === '1') {
      tarjetas.push({ tipo: 'success', mensaje: 'El usuario podría aplicar para reactivación.' });
    }
    return tarjetas;
  }

  /**
   * Condición de asociado desde servicio consultarAsociado: tarjeta 1 = es asociado (jsonRespuesta con datos),
   * tarjeta 2 = estado activo (estado "A") y corte.
   */
  private mapearCondicionAsociadoDesdeAsociado(asociado: ConsultarAsociadoResponse | null): { tipo: string; mensaje: string }[] {
    const resultado: { tipo: string; mensaje: string }[] = [];
    const items = asociado?.status && asociado?.data?.jsonRespuesta?.length ? asociado.data.jsonRespuesta : [];
    const primerItem = items[0];

    const esAsociado = items.length > 0;
    resultado.push({
      tipo: esAsociado ? 'success' : 'error',
      mensaje: esAsociado ? 'El usuario es asociado.' : 'El usuario no es asociado.'
    });

    const estaActivo = primerItem && (primerItem.estado || '').trim() === 'A';
    const corte = primerItem?.corte?.trim() || 'N/A';
    resultado.push({
      tipo: estaActivo ? 'success' : 'error',
      mensaje: estaActivo
        ? `El estado como asociado es activo y el corte: ${corte}.`
        : 'El usuario no se encuentra activo (estado no activo).'
    });
    return resultado;
  }

  /**
   * Guarda la consulta actual en localStorage cuando hay retiro con antigüedad <= 7 meses (consultas previas).
   */
  private guardarConsultaPreviaEnStorage(tipoDoc: string, numDoc: string, itemsActuales: ItemValidacion[]): void {
    try {
      const docKey = `${tipoDoc}|${numDoc}`;
      const ahora = new Date().toISOString();
      const registro = {
        docKey,
        tipoDoc,
        numDoc,
        fechaConsulta: ahora,
        resumen: itemsActuales.map(i => i.descripcion).join('; ')
      };
      const raw = localStorage.getItem(this.KEY_CONSULTAS_PREVIAS);
      let list: any[] = raw ? JSON.parse(raw) : [];
      list.unshift(registro);
      // Mantener últimas 50 consultas en total
      list = list.slice(0, 50);
      localStorage.setItem(this.KEY_CONSULTAS_PREVIAS, JSON.stringify(list));
    } catch (_) { }
  }

  /**
   * Recupera consultas previas del mismo documento realizadas en los últimos 7 meses.
   */
  private recuperarConsultasPrevias(tipoDoc: string, numDoc: string): { tipo: string; mensaje: string }[] {
    const resultado: { tipo: string; mensaje: string }[] = [];
    try {
      const raw = localStorage.getItem(this.KEY_CONSULTAS_PREVIAS);
      if (!raw) return resultado;
      const list: any[] = JSON.parse(raw);
      const docKey = `${tipoDoc}|${numDoc}`;
      const hace6Meses = new Date();
      hace6Meses.setMonth(hace6Meses.getMonth() - 6);
      const previas = list.filter((r: any) => r.docKey === docKey && new Date(r.fechaConsulta) >= hace6Meses);
      if (previas.length > 0) {
        resultado.push({
          tipo: 'info',
          mensaje: `Se encontraron ${previas.length} consulta(s) previa(s) en los últimos 7 meses para este documento.`
        });
      }
    } catch (_) { }
    return resultado;
  }

  private mapearTarjetasHistorialAItemsKey(
    items: HistorialItem[],
    tarjetas: { tipo: string; mensaje: string }[],
    bloqueaProceso: boolean = false
  ): ItemValidacion[] {
    const primerItem = items[0];
    const fechaEvento = this.formatearFechaDDMMYYYY(primerItem?.realbaja_fecha) || '';
    return tarjetas.map(t => ({
      fuente: 'Historial Afilmed',
      descripcion: t.mensaje,
      fechaEvento,
      tipo: t.tipo,
      ...(bloqueaProceso ? { bloquea_proceso: true } : {})
    }));
  }

  private mapearErrorAdres(err: any): string {
    try {
      const be = err?.error;
      if (be?.errorMessage) {
        const match = be.errorMessage.match(/\{\\?"message\\?"\s*:\s*\\?"([^"]+)\\?"\}/);
        if (match && match[1]) return match[1];
        return this.limpiarTecnico(be.errorMessage);
      }
      if (typeof be?.message === 'string' && be.message.trim().length > 0) return be.message;
      if (err?.status === 404) return 'No existe la persona buscada.';
      if (err?.status === 500) return 'Error en el servicio. Intenta más tarde.';
    } catch (_) { }
    return 'No se pudo completar la consulta de EPS.';
  }

  private limpiarTecnico(texto: string): string {
    if (!texto) return 'Error en el servicio.';
    return texto
      .replace(/https?:\/\/\S+/g, '')
      .replace(/\b\d{3}\s*(OK|Error|Not Found)?\b/gi, '')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  /**
   * Cargar líneas de negocio desde el servicio.
   * @param mostrarSpinner Si false, no se muestra el spinner global (evita doble spinner en carga inicial con tarjetas).
   * @param onLineasCargadas Callback opcional cuando las líneas están listas (para precargar programas desde localStorage).
   */
  cargarLineasNegocio(mostrarSpinner: boolean = true, onLineasCargadas?: () => void): void {
    if (mostrarSpinner) {
      this.spinner.show();
    }
    this.consultarLineasService.consultarLineasNegocio().subscribe({
      next: (response) => {
        if (response.status && response.data?.jsonRespuesta) {
          // Mapear las líneas del servicio a nuestro formato
          this.lineasNegocioDisponibles = response.data.jsonRespuesta
            .filter(linea => linea.baja_fecha === null) // Solo líneas activas
            .map(linea => {
              // Extraer código y nombre de linea_negocio
              // Formato esperado: "SMP-MEDICINA INTEGRAL", "SAO-SALUD ORAL", "CEM-EMERGENCIA MEDICA"
              let codigo: 'MI' | 'SO' | 'CEM' = 'MI';

              // Extraer la parte después del guion (el nombre completo)
              const partes = linea.linea_negocio.split('-');
              const nombre = partes.length > 1 ? partes.slice(1).join('-').trim() : linea.linea_negocio;

              // Determinar el código según la abreviatura inicial
              if (linea.linea_negocio.startsWith('SMP') || linea.linea_negocio.includes('MEDICINA')) {
                codigo = 'MI';
              } else if (linea.linea_negocio.startsWith('SAO') || linea.linea_negocio.includes('SALUD ORAL')) {
                codigo = 'SO';
              } else if (linea.linea_negocio.startsWith('CEM') || linea.linea_negocio.includes('EMERGENCIA')) {
                codigo = 'CEM';
              }

              return {
                codigo: codigo,
                nombre: nombre,
                lineaOriginal: linea
              };
            })
            .filter((linea, index, self) =>
              // Eliminar duplicados por código
              index === self.findIndex(l => l.codigo === linea.codigo)
            );

          if (this.ocultarLineasNoMiVentaNueva) {
            this.lineasNegocioDisponibles = this.lineasNegocioDisponibles.filter(linea => linea.codigo === 'MI');
          }
        }
        if (mostrarSpinner) {
          this.spinner.hide();
        }
        onLineasCargadas?.();
      },
      error: (error) => {
        console.error('Error al cargar líneas de negocio:', error);
        if (mostrarSpinner) {
          this.spinner.hide();
        }
        onLineasCargadas?.();
      }
    });
  }

  /**
   * Flujo C/GA: consulta programas completos + activos colectivo/GA; filtra por intersección y preselecciona todos.
   * Procesa la limpieza de espacios (trim) y homologación de sufijos directamente en el navegador.
   */
  private cargarProgramasYPreseleccionColectivoGA(): void {
    const documento = (localStorage.getItem(this.KEY_NUMERO_DOCUMENTO_EMPRESA) ?? '').trim();
    const tipoDocumento = (localStorage.getItem(this.KEY_TIPO_DOCUMENTO_EMPRESA) ?? '').trim();
    const tipoPlan = (localStorage.getItem(this.KEY_TIPO_PLAN) ?? 'C').trim().toUpperCase();

    if (!documento || !tipoDocumento) {
      console.warn('[Colectivo-OGA] Falta el NIT de la empresa contratante en el LocalStorage.');
      return;
    }

    // Formateador elástico de padding y sufijos legacy corporativos
    const obtenerCodigoComercialC = (codigo: string): string => {
      const c = (codigo || '').toString().trim().toUpperCase();
      if (c.endsWith('F') || c.endsWith('A')) {
        return c.substring(0, c.length - 1) + 'C';
      }
      return c;
    };

    this.spinner.show();
    this.tarifasPorProgramaYSubcta.clear();
    this.cacheTarifaColectivo.clear();
    this.labelsPorProgramaYSubcta.clear();
    this.subcuentasValidasPorPlan.clear();
    this.mapaDenoASubctaPorPrograma.clear();
    this.mapaDenoAPlanGrupoPorPrograma.clear();
    this.mapaDenoALabelPorPrograma.clear();

    if (this.esFlujoColectivoOGA && !this.esFlujoInclusion) {
      this.spinner.show();
      this.consultarSubcuentasColectivosGruposService.consultarSubcuentasColectivosGrupos({
        documento,
        tipoDocumento,
        evaluador: tipoPlan === 'GA' ? 'AC' : tipoPlan
      }).pipe(
        concatMap((colectivoRESP: any) => {
          if (!colectivoRESP?.status || !colectivoRESP?.data?.length) {
            return of({ colectivoRESP, catalogoResp: null });
          }

          this.datosColectivoGA = colectivoRESP.data;
          this.cuentaColectivoGA = colectivoRESP.data[0]?.cuenta ?? colectivoRESP.data[0]?.CUENTA ?? null;

          const uniquePlanes = Array.from(new Set(
            colectivoRESP.data.map((r: any) => obtenerCodigoComercialC(r.plan_codi))
          )).filter(Boolean) as string[];

          return this.consultarLineasService.consultarCarnets({
            lineaNegocio: ['MI', 'SAO', 'CEM'],
            tipoPlan: tipoPlan,
            programas: uniquePlanes,
            tipoSolicitud: '3'
          }).pipe(
            map(catalogoResp => ({ colectivoRESP, catalogoResp })),
            catchError(() => of({ colectivoRESP, catalogoResp: null }))
          );
        }),
        finalize(() => this.spinner.hide())
      ).subscribe({
        next: ({ colectivoRESP, catalogoResp }: any) => {
          if (!colectivoRESP?.status || !colectivoRESP?.data?.length) {
            this.programasDisponibles = [];
            this.programasSeleccionados = [];
            this.cdr.detectChanges();
            return;
          }

          const carnetImagesMap = new Map<string, string>();
          const carnetsArray = Array.isArray(catalogoResp) ? catalogoResp : (catalogoResp?.data?.data || catalogoResp?.data || []);
          if (Array.isArray(carnetsArray)) {
            carnetsArray.forEach((c: any) => {
              const code = (c?.code || c?.codigo || c?.id || '').toString().trim().toUpperCase();
              if (code && c?.file) carnetImagesMap.set(code, c.file);
            });
          }

          const uniquePlanesMap = new Map<string, any>();
          colectivoRESP.data.forEach((row: any) => {
            const planCodi = obtenerCodigoComercialC(row.plan_codi);
            if (planCodi && !uniquePlanesMap.has(planCodi)) uniquePlanesMap.set(planCodi, row);
          });

          this.programasDisponibles = Array.from(uniquePlanesMap.values()).map((row: any) => {
            const planCodi = obtenerCodigoComercialC(row.plan_codi);
            const planDeno = (row.plan_deno || row.PLAN_DENO || planCodi).toString().trim();
            const lineaAsignada = this.mapNumberToLinea(row.linea_negocio, planCodi);

            return {
              id: planCodi,
              codigo: planCodi,
              nombre: planDeno.toUpperCase(),
              lineaNegocio: lineaAsignada,
              color: this.obtenerColorPorLinea(lineaAsignada),
              imagen: carnetImagesMap.get(planCodi) || '',
              carnet: carnetImagesMap.get(planCodi) || '',
              grupoPrograma: this.extraerGrupoPrograma(row)
            };
          });

          this.lineasSeleccionadas = Array.from(new Set(this.programasDisponibles.map(p => p.lineaNegocio))) as any;

          let programasPreexistentes: any[] = [];
          try {
            const rawProgramas = localStorage.getItem(this.KEY_PROGRAMAS_CONTRATANTE);
            if (rawProgramas) {
              const parsed = JSON.parse(rawProgramas);
              programasPreexistentes = Array.isArray(parsed) ? parsed : (parsed?.programas || []);
            }
          } catch (_) { }

          if (programasPreexistentes.length > 0 || this.esPrecargaIncompleta || this.esEditModeActivo) {
            this.programasSeleccionados = this.programasDisponibles
              .filter(p => programasPreexistentes.some(x => (x.programa || x.id || '').toString().trim().toUpperCase() === p.id))
              .map(p => {
                const pref = programasPreexistentes.find(x => (x.programa || x.id || '').toString().trim().toUpperCase() === p.id);
                return {
                  id: p.id,
                  nombre: p.nombre,
                  grupoPrograma:
                    pref?.grupoPrograma ||
                    p.grupoPrograma ||
                    '',
                  subcuenta: (pref?.subcuenta || pref?.nombreSubcuenta || '').toString().trim(),
                  // Preferir código limpio / display guardado; aplicarTarifas matchea por código en paréntesis
                  tarifa: (
                    (pref as any)?.tarifaDetalle?.tari
                    || pref?.tarifa
                    || pref?.nombreTarifa
                    || ''
                  ).toString().trim(),
                  campana: (pref?.campana || '').toString().trim(),
                  anexoCodigo: pref?.anexoCodigo || '',
                  tarifaAnexo: pref?.tarifaAnexo || '',
                  nombreAnexo: pref?.nombreAnexo || '',
                  requiereAnexo: pref?.requiereAnexo || null,
                  anexosDisponibles: [],
                  subcuentasDisponibles: [],
                  subcuentasConsultaRealizada: false,
                  tarifasDisponibles: [],
                  tarifasConsultaRealizada: false,
                  campaniasDisponibles: [],
                  campaniasConsultaRealizada: false
                };
              });
          }

          this.programasSeleccionados.forEach(ps => this.cargarSubcuentasColectivo(ps));
          this.cdr.detectChanges();
        },
        error: () => this.spinner.hide()
      });
      return;
    }

    let tipoPlanActual = this.getTipoPlanActual();
    if (tipoPlanActual === 'NULL' || tipoPlanActual === 'UNDEFINED' || tipoPlanActual === '') {
      tipoPlanActual = 'C';
    }

    this.spinner.show();
    this.consultarLineasService.consultarProgramasCompletosPorParametro(true, tipoPlanActual, this.obtenerEdadContratante())
      .subscribe({
        next: (programasCompletos: any) => {
          this.spinner.hide();
          const todos: Programa[] = [];
          (programasCompletos?.grupos || []).forEach((g: any) => {
            const linea: 'MI' | 'SO' | 'CEM' = g.codigo === '1' ? 'MI' : g.codigo === '2' ? 'SO' : 'CEM';
            (g.programas || []).forEach((p: any) => {
              const codigoProg = (p.codigo || '').trim().toUpperCase();
              if (codigoProg) {
                todos.push({
                  id: codigoProg,
                  codigo: codigoProg,
                  nombre: p.programa || p.description || codigoProg,
                  lineaNegocio: linea,
                  color: this.obtenerColorPorLinea(linea),
                  imagen: p.carnet?.file || '',
                  carnet: p.carnet?.file || '',
                  grupoPrograma: ''
                });
              }
            });
          });

          this.programasDisponibles = todos;
          this.lineasSeleccionadas = Array.from(new Set(todos.map(p => p.lineaNegocio))) as any;
          this.cdr.detectChanges();
        },
        error: () => this.spinner.hide()
      });
  }

  private cargarSubcuentasColectivo(
    ps: ProgramaSeleccionado
  ): void {
    const planCodigoUi = String(ps.id || '')
      .trim()
      .toUpperCase();

    const cuentaActual =
      this.cuentaColectivoGA != null
        ? String(this.cuentaColectivoGA).trim()
        : '';

    /*
    * Obtiene el plan_codi técnico directamente de from
    * getConsultaActivoAc.
    *
    * Ejemplos:
    * OPLC   → OPLF
    * CLAC   → CLAF
    * DECEAC → DECEAC
    */
    const filaPlanActivo = (
      this.datosColectivoGA || []
    ).find((fila: any) => {
      const filaPlan = String(
        fila?.plan_ccodi ??
        fila?.plan_codi ??
        fila?.PLAN_CODI ??
        ''
      ).trim().toUpperCase();

      const filaCuenta = String(
        fila?.cuenta ??
        fila?.CUENTA ??
        ''
      ).trim();

      const coincidePlan = this.coincidePlanCodiAfinidad(
        filaPlan,
        planCodigoUi
      );

      return (
        coincidePlan &&
        (!cuentaActual || filaCuenta === cuentaActual)
      );
    });

    const planCodigoConsulta = String(
      filaPlanActivo?.plan_codi ??
      planCodigoUi
    ).trim().toUpperCase();

    console.log('[OGA-Subcuentas] Código resuelto', {
      programaUI: planCodigoUi,
      programaConsulta: planCodigoConsulta,
      cuenta: cuentaActual,
      filaActivo: filaPlanActivo
    });

    ps.subcuentasConsultaRealizada = false;

    this.consultarSubcuentasService
      .consultarSubcuentas(planCodigoConsulta)
      .subscribe({
        next: (response: any) => {
          const rows =
            response?.data?.jsonRespuesta ??
            response?.data?.JSONRESPUESTA ??
            [];

          console.log(
            `[OGA-Subcuentas] Servicio respondió para '${planCodigoConsulta}'.`,
            rows
          );

          if (
            response?.status &&
            Array.isArray(rows) &&
            rows.length > 0
          ) {
            /*
            * Se conserva el código comercial para realizar
            * el cruce interno contra el programa seleccionado.
            */
            this.procesarSubcuentasRespuesta(
              ps,
              planCodigoUi,
              rows,
              {
                filtrarColectivoGA: true,
                autoSeleccionarPrimera: true
              }
            );

            if (ps.subcuenta) {
              this.cargarTarifasColectivoDesdeActivosLocal(ps);
            }
          } else {
            this.procesarSubcuentasRespuesta(
              ps,
              planCodigoUi,
              [],
              {
                filtrarColectivoGA: true,
                autoSeleccionarPrimera: true
              }
            );

            if (ps.subcuenta) {
              this.cargarTarifasColectivoDesdeActivosLocal(ps);
            }
          }

          this.cdr.detectChanges();
        },
        error: (err: any) => {
          console.error(
            `[OGA-Subcuentas] Error consultando '${planCodigoConsulta}'`,
            err
          );

          this.marcarSubcuentasConsultaSinResultados(ps);
          this.cdr.detectChanges();
        }
      });
  }

  private resolverPlanCodiServicio(
    uiPlan: string,
    subcta: string,
    cuenta: string
  ): string {
    const fallback = String(uiPlan || '')
      .trim()
      .toUpperCase();

    const subcuentaActual = String(
      subcta || ''
    ).trim();

    const cuentaActual = String(
      cuenta || ''
    ).trim();

    if (
      !fallback ||
      !subcuentaActual ||
      !this.datosColectivoGA?.length
    ) {
      return fallback;
    }

    const filas = (
      this.datosColectivoGA || []
    ).filter((row: any) => {
      const rowPlan = String(
        row?.plan_codi ??
        row?.PLAN_CODI ??
        ''
      ).trim().toUpperCase();

      const rowSubcuenta = String(
        row?.subcta ??
        row?.SUBCTA ??
        ''
      ).trim();

      const rowCuenta = String(
        row?.cuenta ??
        row?.CUENTA ??
        ''
      ).trim();

      const coincidePlan = this.coincidePlanCodiAfinidad(
        rowPlan,
        fallback
      );

      return (
        coincidePlan &&
        rowSubcuenta === subcuentaActual &&
        (
          !cuentaActual ||
          rowCuenta === cuentaActual
        )
      );
    });

    const fila = this.elegirFilaAfinidad(filas, fallback) || filas[0];
    const planOriginal = String(
      fila?.plan_codi ??
      fila?.PLAN_CODI ??
      ''
    ).trim().toUpperCase();

    if (this.esFlujoGruposAfinidad && (!planOriginal || planOriginal.endsWith('C'))) {
      const amplias = (this.datosColectivoGA || []).filter((row: any) =>
        this.coincidePlanCodiAfinidad(
          String(row?.plan_codi ?? row?.PLAN_CODI ?? ''),
          fallback
        )
      );
      const familiar = this.elegirFilaAfinidad(amplias, fallback);
      const planFamiliar = String(
        familiar?.plan_codi ?? familiar?.PLAN_CODI ?? ''
      ).trim().toUpperCase();
      if (planFamiliar && !planFamiliar.endsWith('C')) {
        return planFamiliar;
      }
    }

    return planOriginal || fallback;
  }

  private codigoProgramaParaGuardar(ps: ProgramaSeleccionado): string {
    const codigoUi = String(ps.id || '').trim().toUpperCase();

    if (!this.esFlujoGruposAfinidad) {
      return codigoUi;
    }

    const deno = String(ps.subcuenta || '').trim();
    const subcta = this.mapaDenoASubctaPorPrograma
      .get(ps.id)?.get(deno) || '';
    const cuenta = String(this.cuentaColectivoGA ?? '').trim();

    const filas = (this.datosColectivoGA || []).filter((row: any) => {
      const plan = String(row?.plan_codi ?? row?.PLAN_CODI ?? '')
        .trim().toUpperCase();
      const subcuenta = String(row?.subcta ?? row?.SUBCTA ?? '').trim();
      const cuentaFila = String(row?.cuenta ?? row?.CUENTA ?? '').trim();

      return this.coincidePlanCodiAfinidad(plan, codigoUi)
        && (!subcta || subcuenta === subcta)
        && (!cuenta || cuentaFila === cuenta);
    });

    let fila = this.elegirFilaAfinidad(filas, codigoUi);
    if (!fila) {
      const amplias = (this.datosColectivoGA || []).filter((row: any) =>
        this.coincidePlanCodiAfinidad(
          String(row?.plan_codi ?? row?.PLAN_CODI ?? ''),
          codigoUi
        )
      );
      fila = this.elegirFilaAfinidad(amplias, codigoUi) || filas[0];
    }
    const codigoAfilmed = String(
      fila?.plan_codi ?? fila?.PLAN_CODI ?? ''
    ).trim().toUpperCase();

    if (!subcta || !codigoAfilmed) {
      throw new Error(
        `No se encontró el plan_codi de Afinidad para ${codigoUi}, subcuenta ${subcta}`
      );
    }

    return codigoAfilmed;
  }

  private deduplicarTarifas(tarifas: IListTarifa[]): IListTarifa[] {
    const mapa = new Map<string, IListTarifa>();

    (tarifas || []).forEach(tarifa => {
      const codigo = this.extraerCodigoTarifaLimpio(
        tarifa?.tarifa
      ).toUpperCase();

      if (codigo && !mapa.has(codigo)) {
        mapa.set(codigo, tarifa);
      }
    });

    return Array.from(mapa.values());
  }

  //  Carga de tarifas para Colectivos OGA: Prioriza servicio de VALORES, usa tari_deno de ActivoAC y valida discrepancias de precio
  private cargarTarifasColectivoDesdeActivosLocal(
    ps: ProgramaSeleccionado
  ): void {
    const planCodigo = (ps.id || '').trim().toUpperCase();
    const denoSelected = (ps.subcuenta || '').trim();

    const mapDenoToCode =
      this.mapaDenoASubctaPorPrograma.get(ps.id);

    const subctaCodeSelected = (
      mapDenoToCode?.get(denoSelected) || ''
    ).trim();

    const cuentaActual =
      this.cuentaColectivoGA != null
        ? String(this.cuentaColectivoGA).trim()
        : '';
    
    const planCodiServicio =
      this.resolverPlanCodiServicio(
        planCodigo,
        subctaCodeSelected,
        cuentaActual
      );

    console.log(
      `[Colectivo-Tarifas] Código de programa resuelto`,
      {
        programaUI: planCodigo,
        programaServicio: planCodiServicio,
        subcuenta: subctaCodeSelected,
        cuenta: cuentaActual
      }
    );    

    if (
      !planCodigo ||
      !subctaCodeSelected ||
      !cuentaActual
    ) {
      console.warn(
        `[Colectivo-Tarifas] Datos incompletos para consultar tarifas`,
        {
          programa: planCodigo,
          subcuenta: subctaCodeSelected,
          cuenta: cuentaActual
        }
      );

      this.aplicarTarifasAColectivo(ps, []);
      return;
    }

    const requestKey =
      `${cuentaActual}:${subctaCodeSelected}:${planCodiServicio}`;

    const mismaConsulta =
      (ps as any).__lastTarifaRequestKey === requestKey;

    if (
      mismaConsulta &&
      (
        (ps as any).__loadingTarifasColectivo ||
        (
          ps.tarifasConsultaRealizada &&
          (ps.tarifasDisponibles?.length ?? 0) > 0
        )
      )
    ) {
      console.log(
        `[Colectivo-Tarifas] Consulta repetida omitida: ${requestKey}`
      );
      return;
    }

    const requestId = Date.now();

    (ps as any).__lastTarifaRequestKey = requestKey;
    (ps as any).__lastTarifaRequestId = requestId;
    (ps as any).__loadingTarifasColectivo = true;

    const datosTarifa =
      this.obtenerEdadSexoContratanteParaTarifa();

      const fuentesTarifas = (
        this.datosColectivoGA || []
      ).filter((fila: any) => {
        const filaCuenta = String(
          fila?.cuenta ??
          fila?.CUENTA ??
          ''
        ).trim();

        const filaSubcuenta = String(
          fila?.subcta ??
          fila?.SUBCTA ??
          ''
        ).trim();

        const filaPlan = String(
          fila?.plan_codi ??
          fila?.PLAN_CODI ??
          ''
        ).trim().toUpperCase();

        return (
          filaCuenta === cuentaActual &&
          filaSubcuenta === subctaCodeSelected &&
          filaPlan === planCodiServicio
        );
      });

      console.log(
        '[Colectivo-Tarifas] Filas de getConsultaActivoAc',
        {
          cuenta: cuentaActual,
          subcuenta: subctaCodeSelected,
          planCodi: planCodiServicio,
          cantidad: fuentesTarifas.length,
          filas: fuentesTarifas
        }
      );

        /*
        * Genera una entrada única por código de tarifa.
        */
        const tarifasReferencia = Array.from(
          new Map<string, any>(
            fuentesTarifas
              .map((fila: any) => {
                const codigo = String(
                  fila?.tarifa_codigo ??
                  fila?.TARIFA_CODIGO ??
                  fila?.tari ??
                  fila?.TARI ??
                  ''
                ).trim();

                return [codigo, fila] as [string, any];
              })
              .filter(([codigo]) => !!codigo)
          ).values()
        );

        console.log(
          `[Colectivo-Tarifas] Tarifas encontradas para consultar`,
          {
            programa: planCodigo,
            subcuenta: subctaCodeSelected,
            cuenta: cuentaActual,
            cantidad: tarifasReferencia.length,
            tarifas: tarifasReferencia
          }
        );

        if (tarifasReferencia.length === 0) {
          console.warn(
            `[Colectivo-Tarifas] No se encontraron códigos de tarifa`,
            {
              programa: planCodigo,
              subcuenta: subctaCodeSelected,
              cuenta: cuentaActual
            }
          );

          this.aplicarTarifasAColectivo(ps, []);
          return;
        }

        /*
        * Consulta el valor correspondiente a cada tarifa.
        */
        const consultasValores = tarifasReferencia.map(
          (fila: any) => {
            const codigoTarifa = String(
              fila?.tarifa_codigo ??
              fila?.TARIFA_CODIGO ??
              fila?.tari ??
              fila?.TARI ??
              ''
            ).trim();

            const planCodiValores = String(
              fila?.plan_codi ??
              fila?.PLAN_CODI ??
              planCodiServicio
            ).trim().toUpperCase();

            return this.consultarTarifasIndividualesService
              .consultarTarifasIndividualesValores({
                prm_cuenta: cuentaActual,
                prm_plan_codi: planCodiValores,
                prm_tari: codigoTarifa,
                prm_subcta: subctaCodeSelected,
                prm_paren: 'T',
                prm_edad: datosTarifa.edad,
                prm_sexo: datosTarifa.sexo,
                prm_inte_tipo: 'I'
              })
              .pipe(
                map((response: any) => ({
                  fila,
                  codigoTarifa,
                  response
                })),
                catchError(error => {
                  console.warn(
                    `[Colectivo-Tarifas] No fue posible consultar el valor de ${codigoTarifa}`,
                    error
                  );

                  return of({
                    fila,
                    codigoTarifa,
                    response: null
                  });
                })
              );
          }
        );

        forkJoin(consultasValores).subscribe({
          next: resultados => {
            if (
              (ps as any).__lastTarifaRequestId !== requestId
            ) {
              console.log(
                `[Colectivo-Tarifas] Respuesta anterior ignorada: ${requestKey}`
              );
              return;
            }

            const tarifas: IListTarifa[] = [];

            resultados.forEach(resultado => {
              const itemsRaw =
                resultado.response?.data?.jsonRespuesta ??
                resultado.response?.data?.respuesta ??
                resultado.response?.data ??
                [];

              const items: any[] = Array.isArray(itemsRaw)
                ? itemsRaw
                : [];

              console.log(
                `[Colectivo-Tarifas] Respuesta de valores para ${resultado.codigoTarifa}`,
                items
              );

              items.forEach((item: any) => {
                const codigo = String(
                  item?.tari ??
                  item?.TARI ??
                  item?.tarifa_codigo ??
                  item?.TARIFA_CODIGO ??
                  resultado.codigoTarifa ??
                  ''
                ).trim();

                const descripcionCatalogo = String(
                  resultado.fila?.tarifa_nombre ??
                  resultado.fila?.TARIFA_NOMBRE ??
                  resultado.fila?.tari_deno ??
                  resultado.fila?.TARI_DENO ??
                  ''
                ).trim();

                const descripcionValores = String(
                  item?.tarifa_nombre ??
                  item?.TARIFA_NOMBRE ??
                  item?.tari_deno ??
                  item?.TARI_DENO ??
                  item?.descripcion ??
                  item?.DESCRIPCION ??
                  ''
                ).trim();

                const descripcionResuelta =
                  descripcionCatalogo ||
                  descripcionValores ||
                  this.resolverDescripcionTarifaColectivo(
                    resultado.fila,
                    codigo
                  ) ||
                  codigo;

                const nombreTarifa =
                  descripcionResuelta
                    .replace(codigo, '')
                    .trim() || codigo;

                const descripcionCompleta =
                  nombreTarifa !== codigo
                    ? `${nombreTarifa} (${codigo})`
                    : codigo;

                const valorRaw =
                  item?.valor_iva ??
                  item?.VALOR_IVA ??
                  item?.valor ??
                  item?.VALOR ??
                  item?.valorMensualIva ??
                  item?.valorMensualBase;

                const valor = Number(valorRaw);

                console.log(
                  `[Colectivo-Tarifas] Tarifa procesada`,
                  {
                    codigo,
                    nombreTarifa,
                    valorRaw,
                    valor,
                    esValida:
                      !!codigo &&
                      Number.isFinite(valor) &&
                      valor > 0
                  }
                );

                if (
                  !codigo ||
                  !Number.isFinite(valor) ||
                  valor <= 0
                ) {
                  return;
                }

                tarifas.push({
                  tarifa: codigo,
                  descripcion: descripcionCompleta,
                  description: descripcionCompleta,
                  programa_grupo: planCodigo,
                  codigo_programa_grupo: planCodigo,
                  programa: planCodigo,
                  valorMensualBase: valor,
                  valorMensualIva: valor,
                  porcentajeIva: Number(
                    item?.porcentaje_iva ??
                    item?.PORCENTAJE_IVA ??
                    0
                  ),
                  esTarifaAsociado: false
                } as IListTarifa);
              });
            });

            const tarifasUnicas =
              this.deduplicarTarifas(tarifas);

            console.log(
              `[Colectivo-Tarifas] Lista final`,
              tarifasUnicas
            );

            if (
              (ps as any).__lastTarifaRequestId !== requestId
            ) {
              return;
            }

            this.aplicarTarifasAColectivo(
              ps,
              tarifasUnicas
            );
          },
          error: error => {
            if (
              (ps as any).__lastTarifaRequestId !== requestId
            ) {
              return;
            }
            
            console.error(
              `[Colectivo-Tarifas] Error procesando tarifas`,
              error
            );

            this.aplicarTarifasAColectivo(ps, []);
          }
        });
  }

  /*
    private fallbackTarifasColectivoDesdeActivos(ps: ProgramaSeleccionado, planCodigo: string, subctaCodeSelected: string, cuentaActual: string): void {
      const filasTarifa = (this.datosColectivoGA || []).filter((row: any) => {
        const rowPlan = (row.plan_codi ?? row.PLAN_CODI ?? '').toString().trim().toUpperCase();
        const rowSub = (row.subcta ?? row.SUBCTA ?? '').toString().trim();
        const rowCuenta = String(row.cuenta ?? row.CUENTA ?? '').trim();
        return rowPlan === planCodigo && (!subctaCodeSelected || rowSub === subctaCodeSelected) && (!cuentaActual || rowCuenta === cuentaActual);
      });
  
      const tarifasFallback: IListTarifa[] = filasTarifa.map((row: any) => {
        const tCodigo = (row.tari ?? row.TARI ?? '').toString().trim();
        const tDenoRaw = (row.tari_deno ?? row.TARI_DENO ?? '').toString().trim();
        const cleanDesc = tDenoRaw.replace(tCodigo, '').trim() || tDenoRaw || 'TARIFA COLECTIVA';
        const valorTarifa = Number(row.valor_tari ?? row.VALOR_TARI ?? 0);
  
        const displayLabel = `${cleanDesc} (${tCodigo})`;
  
        return {
          tarifa: displayLabel,
          descripcion: cleanDesc,
          description: cleanDesc,
          programa_grupo: planCodigo,
          codigo_programa_grupo: planCodigo,
          programa: planCodigo,
          valorMensualBase: valorTarifa,
          valorMensualIva: valorTarifa,
          porcentajeIva: 0,
          esTarifaAsociado: false
        };
      });
  
      this.aplicarTarifasAColectivo(ps, tarifasFallback);
    }
  
  */
  private resolverDescripcionTarifaColectivo(row: any, tCodigo: string): string {
    if (!row) return '';
    const tDenoRaw = (row?.tari_deno ?? row?.TARI_DENO ?? '').toString().trim();
    const planDeno = (row?.plan_deno ?? row?.PLAN_DENO ?? '').toString().trim();
    const fantasia = (row?.nombre_fantasia ?? row?.NOMBRE_FANTASIA ?? '').toString().trim();

    // Limpiamos el código técnico si venía embebido en tari_deno
    let cleanDesc = tDenoRaw.replace(tCodigo, '').trim();

    // Si queda vacío, es muy corto (ej: "ORO") o es igual a nombre_fantasia, usamos plan_deno
    if (!cleanDesc || cleanDesc.length <= 3 || cleanDesc.toUpperCase() === fantasia.toUpperCase()) {
      if (planDeno) {
        cleanDesc = planDeno;
      } else if (tDenoRaw) {
        cleanDesc = tDenoRaw;
      }
    }
    return cleanDesc || 'TARIFA COLECTIVA';
  }

  //  Asigna las tarifas al objeto visual y dispara campañas y anexos
  private aplicarTarifasAColectivo(ps: ProgramaSeleccionado, tarifas: IListTarifa[]): void {
    (ps as any).__loadingTarifasColectivo = false;
    ps.tarifasDisponibles = tarifas;
    ps.tarifasConsultaRealizada = true;

    const tarifaPrevia = (ps.tarifa || '').toString().trim();
    const codigoPrevio = this.extraerCodigoTarifaLimpio(
      tarifaPrevia,
      (ps as any).__tarifaCodigoLimpio
    ).toUpperCase();

    if (ps.tarifasDisponibles.length === 1) {
      ps.tarifa = ps.tarifasDisponibles[0].tarifa;
      const limpio = this.extraerCodigoTarifaLimpio(ps.tarifa, (ps as any).__tarifaCodigoLimpio);
      if (limpio) (ps as any).__tarifaCodigoLimpio = limpio;
      console.log(`[Colectivo-Tarifas]  Auto-seleccionada única tarifa para '${ps.id}': ${ps.tarifa}`);
    } else if (tarifaPrevia) {
      const match = ps.tarifasDisponibles.find((t) => {
        const tTarifa = (t?.tarifa || '').toString().trim();
        const tCode = this.extraerCodigoTarifaLimpio(tTarifa).toUpperCase();
        return tTarifa === tarifaPrevia
          || (!!codigoPrevio && (tCode === codigoPrevio || tTarifa.toUpperCase().includes(codigoPrevio)));
      });
      if (match) {
        ps.tarifa = match.tarifa;
        const limpio = this.extraerCodigoTarifaLimpio(match.tarifa, (ps as any).__tarifaCodigoLimpio);
        if (limpio) (ps as any).__tarifaCodigoLimpio = limpio;
      } else {
        console.log(`[Colectivo-Tarifas]  Tarifa previa '${ps.tarifa}' no está en la lista de Valores. Limpiando.`);
        ps.tarifa = '';
      }
    }

    this.cargarCampaniasParaPrograma(ps);
    this.consultarAnexosPrograma(ps);
    this.actualizarProgramasContratanteLocalStorage();
    this.cdr.detectChanges();
  }

  /**
   * Extrae código técnico de tarifa desde display "NOMBRE (CODIGO)" o valor ya limpio.
   * Nunca toma la primera palabra de una descripción (ej. "PREFERENTE ...").
   */
  private extraerCodigoTarifaLimpio(...candidatos: Array<string | null | undefined>): string {
    for (const raw of candidatos) {
      const s = (raw ?? '').toString().trim();
      if (!s) continue;
      const m = s.match(/\(([^)]+)\)$/);
      if (m?.[1]) return m[1].trim();
      // Código típico colectivo/individual: alfanumérico sin espacios (PREF03860013570, TXYZ...)
      if (/^[A-Z0-9_-]+$/i.test(s) && !s.includes(' ')) return s;
    }
    return '';
  }



  /**
     * Método auxiliar para obtener códigos equivalentes.
     * IMPORTANTE: Asegúrate de que las propiedades programasMedicinaGeneral 
     * y programasSaludOral estén definidas en tu clase.
     */
  private obtenerEquivalentesInclusion(codigo: string): string[] {
    const cd = codigo.trim().toUpperCase();
    return [cd];
  }

  /**
     * Inclusión (tipoSolicitud 2): intersecta programas del afiliado con el catálogo por parámetro y preselecciona.
     * Aplica match elástico para evitar discrepancias entre códigos de carnet y grupos comerciales (ej: OPL vs OPLF).
     */
  private cargarProgramasYPreseleccionInclusion(): void {
    let tipoDoc = (this.tipoDocumento ?? '').trim();
    let numDoc = (this.numeroDocumento ?? '').trim();


    if (!tipoDoc || !numDoc) {
      console.log('[Flujo-Inclusion][Diagnostico] Cancelado: Faltan llaves de identidad del contratante.');
      return;
    }
    this.programasDisponibles = [];
    this.programasSeleccionados = [];
    this.lineasSeleccionadas = [];
    this.inclusionPreferenciasPorPrograma.clear();
    this.spinner.show();
    let tipoPlanActual = this.getTipoPlanActual();
    if (tipoPlanActual === 'NULL' || tipoPlanActual === 'UNDEFINED' || tipoPlanActual === '') tipoPlanActual = 'C';
    console.log('[Flujo-Inclusion][Diagnostico] === INICIO DE ORQUESTRACIÓN PARALELA INCLUSIONES ===', { tipoDoc, numDoc, tipoPlanActual });

    const rawSeleccion = localStorage.getItem('programas_seleccionados_inclusion');
    const permitidos: string[] = rawSeleccion ? JSON.parse(rawSeleccion).map((p: string) => p.trim().toUpperCase()) : [];
    console.log('[Flujo-Inclusion][Diagnostico] Códigos autorizados por el LocalStorage (permitidos):', permitidos);

    const datosCache = (this.consultarLineasService as any).cacheCarnetsInclusion;
    let cacheValida = false;
    if (this.esFlujoInclusion && datosCache) {
      const r = datosCache?.status && Array.isArray(datosCache?.data) ? datosCache.data : (datosCache?.data?.data || []);
      if (r && r.length > 0) {
        cacheValida = true;
      }
    }
    const carnetPorCodigo = new Map<string, any>();
    const extraerCarnetsDeCatalogo = (catalogoRecibido: any): any[] => {
      if (!catalogoRecibido) return [];
      if ((catalogoRecibido as any)?.status && Array.isArray((catalogoRecibido as any)?.data)) {
        return (catalogoRecibido as any).data;
      }
      const nested = (catalogoRecibido as any)?.data?.data;
      return Array.isArray(nested) ? nested : [];
    };
    const grupoCodToLinea = (codGrupo: string): 'MI' | 'SO' | 'CEM' => {
      const cod = (codGrupo ?? '').toString().trim();
      if (cod === '1' || cod === 'MI' || cod === 'SMP') return 'MI';
      if (cod === '2' || cod === 'SO' || cod === 'SAO') return 'SO';
      return 'CEM';
    };

    const obtenerProductosMatchedInclusion = (inclusionResp: any, catalogoReceived: any): any[] => {
      console.log('[Flujo-Inclusion][Diagnostico] -> Ejecutando cruzamiento relacional (obtenerProductosMatchedInclusion)');
      const rawDesc = localStorage.getItem('programas_descripciones_inclusion');
      const descripcionesInclusion = rawDesc ? JSON.parse(rawDesc) : {};
      let mapCambiado = false;
      const cuentaPorPlanMap = new Map<string, string>();
      try {
        const rawContratoRadicado = localStorage.getItem('contrato_radicado');
        if (rawContratoRadicado) {
          const parsedRadicado = JSON.parse(rawContratoRadicado);
          const contratoRows = Array.isArray(parsedRadicado?.contrato) ? parsedRadicado.contrato : [];
          contratoRows.forEach((cRow: any) => {
            const planId = (cRow?.cod_programa_afi || cRow?.COD_PROGRAMA_AFI || '').toString().trim().toUpperCase();
            const accountId = (cRow?.cod_cuenta ?? cRow?.COD_CUENTA ?? '').toString().trim();
            if (planId && accountId) {
              cuentaPorPlanMap.set(planId, accountId);
            }
          });
          console.log('[Flujo-Inclusion] Cuentas cruzadas indexadas localmente con éxito:', Array.from(cuentaPorPlanMap.entries()));
        }
      } catch (err) {
        console.error('[Flujo-Inclusion] Error extrayendo cod_cuenta desde contrato_radicado:', err);
      }
      const rows = inclusionResp?.status ? (Array.isArray(inclusionResp?.data) ? inclusionResp.data : (inclusionResp?.data?.jsonRespuesta || inclusionResp?.data?.JSONRESPUESTA || inclusionResp?.jsonRespuesta || [])) : [];
      const rowsArray = Array.isArray(rows) ? rows : [];
      console.log('[Flujo-Inclusion][Diagnostico] Filas de inclusiones normalizadas:', rowsArray.length);
      const carnets = extraerCarnetsDeCatalogo(catalogoReceived);
      carnets.forEach((c: any) => {
        const code = String(c?.code || c?.codigo || c?.id || '').trim().toUpperCase();
        if (code && !carnetPorCodigo.has(code)) {
          carnetPorCodigo.set(code, c);
        }
      });

      const rowsAProcesar = rowsArray;

      const listMatched: any[] = [];
      const seen = new Set<string>();
      for (const row of rowsAProcesar) {
        const codPlan = (row?.codigo_plan || row?.plan_codi || '').toString().trim().toUpperCase();
        if (!codPlan) continue;
        const codLineaRaw = row?.cod_linea ?? row?.COD_LINEA ?? row?.linea_negocio ?? row?.LINEA_NEGOCIO ?? '';
        const codigoLinea = grupoCodToLinea(codLineaRaw.toString());
        const key = `${codPlan}:${codigoLinea}`;
        if (seen.has(key)) continue;
        seen.add(key);
        const carnet = carnetPorCodigo.get(codPlan);
        const tarifaPref = (row?.tarifa ?? row?.TARIFA ?? '').toString().trim() || null;
        const nombreTarifaPref = (row?.nombre_tarifa ?? row?.NOMBRE_TARIFA ?? '').toString().trim() || null;
        const campanaPref = (row?.campana ?? row?.CAMPANA ?? row?.campaña ?? row?.CAMPAÑA ?? '').toString().trim() || null;
        const codCuentaPref = cuentaPorPlanMap.get(codPlan) || null;
        const subcuentaPref = (row?.subcuenta ?? row?.subcta ?? row?.cod_subcuenta ?? row?.codigo_subcuenta ?? '').toString().trim() || null;
        this.inclusionPreferenciasPorPrograma.set(codPlan, { tarifa: tarifaPref, campana: campanaPref, nombreTarifa: nombreTarifaPref, codCuenta: codCuentaPref, subcuenta: subcuentaPref });
        console.log(`[Flujo-Inclusion][Diagnostico][Mapeo-cuentas-subcuentas] Vinculando preferencia: ${codPlan} -> Tarifa: ${tarifaPref} | Cuenta: ${codCuentaPref}  | Subcuenta: ${subcuentaPref}`);
        const nombrePlanInclusion = (row?.planes || row?.PLANES || '').toString().trim();
        const nombreProgramaFinal = nombrePlanInclusion || descripcionesInclusion[codPlan] || (carnet?.program || carnet?.programa || codPlan).toString().trim();
        const programaFinal = { ...(carnet || {}), codigo: codPlan, code: codPlan, programa: nombreProgramaFinal, file: carnet?.file || carnet?.carnet?.file || '' };
        if (descripcionesInclusion[codPlan] !== nombreProgramaFinal) {
          descripcionesInclusion[codPlan] = nombreProgramaFinal;
          mapCambiado = true;
        }
        listMatched.push({ programa: programaFinal, codigoLinea, row });
      }
      if (mapCambiado) {
        localStorage.setItem('programas_descripciones_inclusion', JSON.stringify(descripcionesInclusion));
      }
      return listMatched;
    };

    const dibujarUI = (matchedFinal: any[]) => {

      let filtrados = matchedFinal;
      if (permitidos && permitidos.length > 0) {
        filtrados = matchedFinal.filter(({ programa }) => {
          const pId = (programa.codigo || programa.code || programa.id || '').toString().trim().toUpperCase();
          return permitidos.includes(pId);
        });
      }
      console.log(`[Flujo-Inclusion][Diagnostico] -> Dibujando UI con ${filtrados.length} carnets admitidos.`);


      this.programasDisponibles = filtrados.map(({ programa, codigoLinea }) => ({ id: (programa.codigo || programa.code || programa.id || '').toString().trim(), codigo: (programa.codigo || programa.code || programa.id || '').toString().trim(), nombre: programa.programa, lineaNegocio: codigoLinea, color: this.obtenerColorPorLinea(codigoLinea), imagen: programa.file || programa.carnet?.file, carnet: programa.file || programa.carnet?.file, grupoPrograma: this.extraerGrupoPrograma(programa) }));
      this.lineasSeleccionadas = [...new Set(this.programasDisponibles.map((p: any) => p.lineaNegocio))] as any;

      const tieneSeleccionGuardada = permitidos.length > 0;
      const persistidosEdicion = this.obtenerPersistidosEdicionInclusionPorCodigo();
      this.programasSeleccionados = this.programasDisponibles
        .filter((p: any) => !tieneSeleccionGuardada || permitidos.includes(p.id.trim().toUpperCase()))
        .map((p: any) => {
          const persistido = persistidosEdicion.get((p.id || '').toString().trim().toUpperCase());
          const anexoCodigo = (persistido?.anexoCodigo ?? persistido?.tarifaAnexo ?? '').toString().trim();
          const tarifaAnexo = (persistido?.tarifaAnexo ?? persistido?.anexoCodigo ?? '').toString().trim();
          const nombreAnexo = (persistido?.nombreAnexo ?? '').toString().trim();
          const requiereRaw = (persistido?.requiereAnexo ?? '').toString().trim().toLowerCase();
          let requiereAnexo: 'si' | 'no' | null = null;
          // NC 1078: en edición, evidencia de anexo (código/id) manda sobre 'no' heredado de programa.esAnexo.
          const idAnexoPersistido = Number(persistido?.idCotizacionTarifaAnexo ?? persistido?.__idCotizacionTarifaAnexo ?? 0);
          if (anexoCodigo || tarifaAnexo || idAnexoPersistido > 0) {
            requiereAnexo = 'si';
          } else if (requiereRaw === 'si' || requiereRaw === 's' || requiereRaw === 'true' || persistido?.requiereAnexo === true) {
            requiereAnexo = 'si';
          } else if (requiereRaw === 'no' || requiereRaw === 'n' || requiereRaw === 'false' || persistido?.requiereAnexo === false) {
            requiereAnexo = 'no';
          }
          const subctaSeed = (persistido?.subcta ?? '').toString().trim();
          // Edición: sembrar campaña persistida (iniciar-edicion). Alta: vacía — el SP / catálogo define.
          let campanaSeed = '';
          if (this.esEditModeActivo && persistido) {
            campanaSeed = (
              persistido?.campana
              ?? persistido?.campania
              ?? persistido?.campaniaDetalle?.codCampComercial
              ?? persistido?.codCampComercial
              ?? ''
            ).toString().trim();
            if (campanaSeed.toLowerCase() === 'null') {
              campanaSeed = '';
            }
          }
          return {
            id: p.id,
            nombre: p.nombre,
            subcuenta: subctaSeed,
            tarifa: '',
            campana: campanaSeed,
            anexoCodigo,
            tarifaAnexo,
            nombreAnexo,
            requiereAnexo,
            anexosDisponibles: [],
            subcuentasDisponibles: [],
            subcuentasConsultaRealizada: false,
            tarifasDisponibles: [],
            tarifasConsultaRealizada: false,
            campaniasDisponibles: [],
            campaniasConsultaRealizada: false
          };
        });

      console.log('[Flujo-Inclusion][Diagnostico] Modelos de selección construidos. Gatillando cascada de liquidación financiera.');
      // Inclusión + precarga: UI CEM oculta (*ngIf !esPrecargaIncompleta) → espejo VN FAEM (L4406).
      // Evita deadlock GUARDAR disabled sin poder emitir coberturaValidaChange. VN no entra (esFlujoInclusion).
      if (this.esPrecargaIncompleta && this.hayProgramaCemSeleccionado) {
        this.coberturaCemValida = true;
      }
      this.programasSeleccionados.forEach((ps: any) => {
        console.log(`[Flujo-Inclusion][Diagnostico] >> Lanzando hilos de red para programa: ${ps.id}`);
        this.cargarTarifasParaPrograma(ps);
        this.cargarCampaniasParaPrograma(ps);
        this.consultarAnexosPrograma(ps);
      });
      this.spinner.hide();
    };

    this.consultarProgramasInclusionService.consultarProgramasInclusion(tipoDoc, numDoc)
      .pipe(
        concatMap((inclusion: any) => {
          const rows = inclusion?.status ? (Array.isArray(inclusion?.data) ? inclusion.data : (inclusion?.data?.jsonRespuesta || inclusion?.data?.JSONRESPUESTA || inclusion?.jsonRespuesta || [])) : [];
          const rowsArray = Array.isArray(rows) ? rows : [];
          if (rowsArray.length === 0) {
            console.warn('[Flujo-Inclusion][Diagnostico] El servicio de inclusión devolvió un arreglo vacío.');
            return of({ inclusion, catalogos: [] });
          }

          const rowsFiltradasPorControl = rowsArray;

          if (rowsFiltradasPorControl.length === 0) {
            console.warn('[Flujo-Inclusion][Diagnostico] Control Activo: Ningún programa superó el filtro de permitidos.');
            return of({ inclusion, catalogos: [] });
          }
          const programasPorLineaMap = new Map<string, string[]>();
          rowsFiltradasPorControl.forEach((row: any) => {
            const codPlan = (row?.codigo_plan || row?.plan_codi || '').toString().trim().toUpperCase();
            const codLineaRaw = (row?.cod_linea || row?.linea_negocio || '').toString().trim().toUpperCase();
            let lineaHomologada = 'MI';
            if (codLineaRaw === '2' || codLineaRaw === 'SO' || codLineaRaw === 'SAO') lineaHomologada = 'SAO';
            else if (codLineaRaw === '3' || codLineaRaw === 'CEM') lineaHomologada = 'CEM';
            if (codPlan) {
              if (!programasPorLineaMap.has(lineaHomologada)) {
                programasPorLineaMap.set(lineaHomologada, []);
              }
              if (!programasPorLineaMap.get(lineaHomologada)!.includes(codPlan)) {
                programasPorLineaMap.get(lineaHomologada)!.push(codPlan);
              }
            }
          });
          const llamadasCatalogos$ = Array.from(programasPorLineaMap.entries()).map(([linea, planes]) => {
            console.log(`[Flujo-Inclusion][Diagnostico] Despachando consulta HTTP para Línea: ${linea} -> Planes:`, planes);
            return this.consultarLineasService.consultarCarnets({ lineaNegocio: [linea], tipoPlan: tipoPlanActual, programas: planes, edad: this.obtenerEdadContratante(), tipoSolicitud: '2' }).pipe(catchError((err) => {
              console.error(`[Flujo-Inclusion][Diagnostico] Falló el catálogo de la línea ${linea}:`, err);
              return of(null);
            }));
          });
          return forkJoin(llamadasCatalogos$).pipe(
            map((catalogos) => ({ inclusion, catalogos: catalogos.filter(Boolean) }))
          );
        }),
        catchError(err => {
          console.error('[Flujo-Inclusion][Diagnostico] Error crítico orquestando llamadas paralelas:', err);
          this.spinner.hide();
          return throwError(() => err);
        })
      ).subscribe({
        next: ({ inclusion, catalogos }) => {
          this.inclusionPreferenciasPorPrograma.clear();
          const catalogoConsolidado = {
            status: true, data: catalogos.flatMap((cat: any) => {
              if (!cat) return [];
              if (cat?.status && Array.isArray(cat?.data)) return cat.data;
              return cat?.data?.data || [];
            })
          };
          console.log('[Flujo-Inclusion][Diagnostico] Catálogos consolidados con éxito. Iniciando empaquetado final.');
          const matched = obtenerProductosMatchedInclusion(inclusion, catalogoConsolidado);
          if (matched.length === 0) {
            console.warn('[Flujo-Inclusion][Diagnostico] No se consolidaron coincidencias. Abortando renderizado.');
            this.spinner.hide();
            return;
          }
          // NC0090: en edición, el SP suele traer campaña null; rellenar huecos desde iniciar-edicion.
          this.enriquecerPreferenciasInclusionDesdeEdicion();
          dibujarUI(matched);
        },
        error: () => this.spinner.hide()
      });
  }

  /**
   * NC0090 — Solo Inclusión + editMode.
   * Mapa de programas del titular persistidos en iniciar-edicion / contexto del modal.
   */
  private obtenerPersistidosEdicionInclusionPorCodigo(): Map<string, any> {
    const map = new Map<string, any>();
    if (!this.esEditModeActivo) {
      return map;
    }

    let lista: any[] = [];
    if (Array.isArray(this.data?.programasContratantePersistidos)
      && this.data.programasContratantePersistidos.length > 0) {
      lista = this.data.programasContratantePersistidos;
    } else {
      try {
        const rawPrec = localStorage.getItem(this.KEY_COTIZACION_PRECARGADA);
        const prec = rawPrec ? JSON.parse(rawPrec) : null;
        if (Array.isArray(prec?.programasContratantePersistidos)
          && prec.programasContratantePersistidos.length > 0) {
          lista = prec.programasContratantePersistidos;
        }
      } catch (_) { /* ignore */ }
    }

    if (lista.length === 0) {
      try {
        const rawInc = localStorage.getItem('programas_contratante_inclusiones');
        const parsedInc = rawInc ? JSON.parse(rawInc) : null;
        const arrInc = Array.isArray(parsedInc) ? parsedInc : (parsedInc?.programas ?? []);
        if (Array.isArray(arrInc) && arrInc.length > 0) {
          lista = arrInc;
        }
      } catch (_) { /* ignore */ }
    }

    lista.forEach((detalle: any) => {
      const codigo = (detalle?.programa ?? detalle?.id ?? detalle?.codigo ?? detalle?.code ?? '')
        .toString()
        .trim()
        .toUpperCase();
      if (codigo && !map.has(codigo)) {
        map.set(codigo, detalle);
      }
    });
    return map;
  }

  /**
   * NC0090 — Solo Inclusión + editMode.
   * Rellena preferencias vacías del SP (campaña/tarifa/subcta) con snapshot de edición.
   * No pisa valores que el SP sí trajo. Alta nueva no entra (gate esEditModeActivo).
   */
  private enriquecerPreferenciasInclusionDesdeEdicion(): void {
    if (!this.esFlujoInclusion || !this.esEditModeActivo) {
      return;
    }
    const persistidos = this.obtenerPersistidosEdicionInclusionPorCodigo();
    if (persistidos.size === 0 || this.inclusionPreferenciasPorPrograma.size === 0) {
      return;
    }

    this.inclusionPreferenciasPorPrograma.forEach((pref, codigo) => {
      const det = persistidos.get(codigo);
      if (!det) {
        return;
      }
      const tarifaDet = (det.tarifa ?? det.tarifaDetalle?.tari ?? '').toString().trim();
      const nombreTarifaDet = (det.nombreTarifa ?? det.tarifaDetalle?.nombreTarifa ?? '').toString().trim();
      const campanaDet = (
        det.campana
        ?? det.campania
        ?? det.campaniaDetalle?.codCampComercial
        ?? det.codCampComercial
        ?? ''
      ).toString().trim();
      const subctaDet = (det.subcta ?? '').toString().trim();

      if (!(pref.tarifa ?? '').toString().trim() && tarifaDet) {
        pref.tarifa = tarifaDet;
      }
      if (!(pref.nombreTarifa ?? '').toString().trim() && nombreTarifaDet) {
        pref.nombreTarifa = nombreTarifaDet;
      }
      // SP a menudo trae null/"null"; tratar como vacío y rellenar desde persistidos.
      const prefCampanaRaw = (pref.campana ?? '').toString().trim();
      const prefCampanaVacia = !prefCampanaRaw || prefCampanaRaw.toLowerCase() === 'null';
      if (prefCampanaVacia && campanaDet && campanaDet.toLowerCase() !== 'null') {
        pref.campana = campanaDet;
      }
      if (!(pref.subcuenta ?? '').toString().trim() && subctaDet) {
        pref.subcuenta = subctaDet;
      }
    });

    console.log('[NC0090][Inclusion-Edicion] Preferencias enriquecidas desde persistidos:',
      Array.from(this.inclusionPreferenciasPorPrograma.entries()).map(([k, v]) => ({
        programa: k,
        tarifa: v.tarifa,
        campana: v.campana,
        subcuenta: v.subcuenta
      }))
    );
  }
  /*
  private cargarProgramasYPreseleccionInclusion(): void {
    const tipoDoc = (this.tipoDocumento ?? '').trim();
    const numDoc = (this.numeroDocumento ?? '').trim();
    if (!tipoDoc || !numDoc) return;

    this.programasDisponibles = [];
    this.programasSeleccionados = [];
    this.lineasSeleccionadas = [];
    this.inclusionPreferenciasPorPrograma.clear();
    this.spinner.show();
    
    let tipoPlanActual = this.getTipoPlanActual();
    if (tipoPlanActual === 'NULL' || tipoPlanActual === 'UNDEFINED' || tipoPlanActual === '') tipoPlanActual = 'C';

    forkJoin({
      inclusion: this.consultarProgramasInclusionService.consultarProgramasInclusion(tipoDoc, numDoc),
      catalogo: this.consultarLineasService.consultarProgramasCompletosPorParametro(true, tipoPlanActual)
    }).pipe(
      catchError(err => { this.spinner.hide(); return throwError(() => err); })
    ).subscribe({
      next: ({ inclusion, catalogo }) => {
        this.spinner.hide();
        
        const rawSeleccion = localStorage.getItem('programas_seleccionados_inclusion');
        const permitidos: string[] = rawSeleccion ? JSON.parse(rawSeleccion).map((p: string) => p.trim().toUpperCase()) : [];
        const todosLosProgramasCatalogo: ProgramaCompleto[] = (catalogo.grupos || []).flatMap((g: any) => g.programas || []);
        
        const matched: { programa: ProgramaCompleto; codigoLinea: 'MI' | 'SO' | 'CEM' }[] = [];
        const seen = new Set<string>();
        const groupCodToLinea = (codGrupo: string): 'MI' | 'SO' | 'CEM' => codGrupo === '1' ? 'MI' : codGrupo === '2' ? 'SO' : 'CEM';

        permitidos.forEach((codigoRequerido: string) => {
          const equivalentes = this.obtenerEquivalentesInclusion(codigoRequerido);
          
          const programaEncontrado = todosLosProgramasCatalogo.find(p => {
            const codCat = (p.codigo || '').trim().toUpperCase();
            return equivalentes.includes(codCat);
          });

          if (programaEncontrado) {
            const codigoLinea: 'MI' | 'SO' | 'CEM' = (programaEncontrado as any).lineaNegocio || 'MI';
            const key = `${programaEncontrado.codigo}:${codigoLinea}`;
            
            if (!seen.has(key)) {
              seen.add(key);
              matched.push({ programa: programaEncontrado, codigoLinea });
            }
          }
        });

        this.programasDisponibles = matched.map(({ programa, codigoLinea }) => ({
          id: (programa.codigo ?? '').trim(),
          codigo: (programa.codigo ?? '').trim(),
          nombre: programa.programa,
          lineaNegocio: codigoLinea,
          color: this.obtenerColorPorLinea(codigoLinea),
          imagen: programa.carnet?.file,
          carnet: programa.carnet?.file,
          grupoPrograma: this.extraerGrupoPrograma(programa)
        }));

        this.lineasSeleccionadas = [...new Set(this.programasDisponibles.map(p => p.lineaNegocio))];
        this.lineasNegocioDisponibles = this.lineasNegocioDisponibles.filter(l => this.lineasSeleccionadas.includes(l.codigo));

        this.programasSeleccionados = this.programasDisponibles.map(p => ({
          id: p.id, nombre: p.nombre, subcuenta: '', tarifa: '', campana: '', 
          anexoCodigo: '', tarifaAnexo: '', nombreAnexo: '', requiereAnexo: null, 
          anexosDisponibles: [], subcuentasDisponibles: [], subcuentasConsultaRealizada: false, tarifasDisponibles: [], 
          tarifasConsultaRealizada: false, campaniasDisponibles: [], campaniasConsultaRealizada: false 
        }));

        this.programasSeleccionados.forEach(ps => {
          this.cargarTarifasParaPrograma(ps);
          this.cargarCampaniasParaPrograma(ps);
        });
      },
      error: () => this.spinner.hide()
    });
  }
*/

  /**
   * Toggle selección de línea de negocio (permite múltiples selecciones)
   */
  toggleLinea(linea: 'MI' | 'SO' | 'CEM'): void {
    if (this.esPrecargaVisualFAEM) return;
    if (this.ocultarLineasNoMiVentaNueva && linea !== 'MI') return;
    const index = this.lineasSeleccionadas.indexOf(linea);
    if (index >= 0) {
      // Ya está seleccionada, la quitamos
      this.lineasSeleccionadas.splice(index, 1);
      // Se mantienen en programasDisponibles (catálogo), pero se deseleccionan
      // programas/subcuentas/tarifas/anexos/campañas de esa línea
      this.limpiarSeleccionPorLinea(linea);
      this.actualizarProgramasContratanteLocalStorage();
      this.cdr.detectChanges();
    } else {
      // No está seleccionada, la agregamos
      this.lineasSeleccionadas.push(linea);

      // En flujo C/GA/AG los programas ya vienen filtrados por intersección (colectivo/GA).
      // En inclusión, igual: catálogo ya viene de la intersección afiliado + parámetro.
      // No se debe cargar el catálogo completo por línea al hacer click en los tabs/botones.
      if (this.esFlujoColectivoOGA || this.esFlujoInclusion) {
        return;
      }

      // Obtener el código numérico de la línea desde lineasNegocioDisponibles
      const lineaDisponible = this.lineasNegocioDisponibles.find(l => l.codigo === linea);
      if (lineaDisponible && lineaDisponible.lineaOriginal) {
        const codigoLinea = lineaDisponible.lineaOriginal.cod;
        // Cargar programas para esta línea (el servicio manejará el caché)
        this.cargarProgramasPorLinea(codigoLinea, linea);
      }
    }
  }

  /**
   * Quita de la selección los programas de una línea de negocio
   * (subcuenta, tarifas, anexos y campañas van con el ítem del programa).
   */
  private limpiarSeleccionPorLinea(linea: 'MI' | 'SO' | 'CEM'): void {
    const idsDeLinea = new Set(
      (this.programasDisponibles || [])
        .filter(p => p.lineaNegocio === linea)
        .map(p => (p.id || '').toString().trim().toUpperCase())
    );

    const removidos = (this.programasSeleccionados || []).filter(ps => {
      const idNorm = (ps.id || '').toString().trim().toUpperCase();
      if (idsDeLinea.has(idNorm)) return true;
      const base = this.programasDisponibles.find(p =>
        (p.id || '').toString().trim().toUpperCase() === idNorm
      );
      return base?.lineaNegocio === linea;
    });

    if (!removidos.length) return;

    const idsRemovidos = new Set(removidos.map(ps => ps.id));
    this.programasSeleccionados = this.programasSeleccionados.filter(ps => !idsRemovidos.has(ps.id));

    for (const ps of removidos) {
      this.mapaDenoASubctaPorPrograma.delete(ps.id);
      this.mapaDenoAPlanGrupoPorPrograma.delete(ps.id);
      this.mapaDenoALabelPorPrograma.delete(ps.id);
    }

    if (linea === 'CEM' && !this.hayProgramaCemSeleccionado) {
      this.coberturaCemValida = false;
    }
  }

  /**
   * Verificar si una línea está seleccionada
   */
  esLineaSeleccionada(linea: 'MI' | 'SO' | 'CEM'): boolean {
    return this.lineasSeleccionadas.includes(linea);
  }

  /**
   * Indica si hay al menos un programa CEM seleccionado.
   * Se usa para mostrar la sección de validación de cobertura.
   */
  get hayProgramaCemSeleccionado(): boolean {
    return this.programasSeleccionados.some(ps => {
      const programa = this.programasDisponibles.find(p => p.id === ps.id);
      return programa?.lineaNegocio === 'CEM';
    });
  }

  /** true cuando se abrió el modal desde el flujo de edición (mis-cotizaciones → iniciar-edicion). */
  get esEditModeActivo(): boolean {
    if (this.data?.editMode === true) return true;
    try {
      const raw = localStorage.getItem(this.KEY_COTIZACION_PRECARGADA);
      return raw ? JSON.parse(raw)?.editMode === true : false;
    } catch { return false; }
  }

  private actualizarContextoCotizacionPrecargada(
    cambios: Partial<CotizacionPrecargadaContexto>
  ): void {
    let anterior: Partial<CotizacionPrecargadaContexto> | null = null;
    try {
      const raw = localStorage.getItem(this.KEY_COTIZACION_PRECARGADA);
      anterior = raw ? JSON.parse(raw) : null;
    } catch (_) { }

    const contexto = combinarContextoCotizacionPrecargada(
      anterior,
      {
        ...cambios,
        ...(this.data?.pasoActual != null ? { pasoActual: Number(this.data.pasoActual) } : {}),
        ...(this.data?.idTipoSolicitud !== undefined
          ? { idTipoSolicitud: this.data.idTipoSolicitud }
          : {}),
        ...(this.data?.tieneProgramasContratantePersistidos !== undefined
          ? { tieneProgramasContratantePersistidos: this.data.tieneProgramasContratantePersistidos }
          : {}),
        ...(Array.isArray(this.data?.programasContratantePersistidos)
          ? { programasContratantePersistidos: this.data.programasContratantePersistidos }
          : {})
      },
      this.data?.editMode === true
    );

    localStorage.setItem(this.KEY_COTIZACION_PRECARGADA, JSON.stringify(contexto));
  }

  /** true cuando la UI está en modo precarga (cotizacion_precargada) */
  get esPrecargaIncompleta(): boolean {
    try {
      const raw = localStorage.getItem(this.KEY_COTIZACION_PRECARGADA);
      if (!raw) return false;
      const prec = JSON.parse(raw);
      return prec?.precargada === true;
    } catch {
      return false;
    }
  }

  /** true solo cuando precargamos programas para F/A/EM (no C/GA/AG). */
  get esPrecargaVisualFAEM(): boolean {
    if (!this.esPrecargaIncompleta || this.esFlujoColectivoOGA) return false;
    try {
      const raw = localStorage.getItem(this.KEY_COTIZACION_PRECARGADA);
      if (!raw) return false;
      const prec = JSON.parse(raw);
      const pasoActual = Number(prec?.pasoActual ?? 0);
      return Number.isFinite(pasoActual) && pasoActual > 2;
    } catch {
      return false;
    }
  }

  /** IDs (códigos) de programas precargados para mostrar solo esos cards. */
  private idsProgramasPrecargadosVisual: Set<string> = new Set();

  /**
   * Deselecciona el programa CEM cuando la cobertura es inválida.
   */
  deseleccionarProgramaCem(): void {
    this.coberturaCemValida = false;
    const idsCem = this.programasDisponibles
      .filter(p => p.lineaNegocio === 'CEM')
      .map(p => p.id);
    this.programasSeleccionados = this.programasSeleccionados.filter(
      ps => !idsCem.includes(ps.id)
    );
  }

  /**
   * Obtener programas agrupados por línea de negocio seleccionada
   * Cada línea tiene su propio grid interno de 3 columnas
   */
  get programasAgrupadosPorLinea(): { linea: 'MI' | 'SO' | 'CEM', nombre: string, programas: Programa[] }[] {
    const grupos: { linea: 'MI' | 'SO' | 'CEM', nombre: string, programas: Programa[] }[] = [];

    // Usar las líneas dinámicas en lugar del orden fijo
    this.lineasNegocioDisponibles.forEach(lineaDisponible => {
      if (this.lineasSeleccionadas.includes(lineaDisponible.codigo)) {
        const programas = this.programasDisponibles.filter(p =>
          p.lineaNegocio === lineaDisponible.codigo &&
          (!this.esPrecargaVisualFAEM || this.idsProgramasPrecargadosVisual.has(p.id))
        );
        if (programas.length > 0) {
          grupos.push({
            linea: lineaDisponible.codigo,
            nombre: lineaDisponible.nombre,
            programas: programas
          });
        }
      }
    });

    return grupos;
  }

  /**
   * Verificar si un programa está seleccionado
   */
  esProgramaSeleccionado(programaId: string): boolean {
    return this.programasSeleccionados.some(p => p.id === programaId);
  }

  private hasAnexosDisponibles(programaSel: ProgramaSeleccionado): boolean {
    const lista = Array.isArray(programaSel?.anexosDisponibles) ? programaSel.anexosDisponibles : [];
    return lista.some((an) =>
      !!(an?.planCod1 || '').toString().trim() &&
      !!(an?.nombre || '').toString().trim() &&
      (!!(an?.tari || '').toString().trim() || !!(an?.valor || '').toString().trim())
    );
  }

  shouldShowRequiereAnexo(programaSel: ProgramaSeleccionado): boolean {
    return this.hasAnexosDisponibles(programaSel);
  }

  shouldShowTarifaAnexo(programaSel: ProgramaSeleccionado): boolean {
    return this.shouldShowRequiereAnexo(programaSel) && programaSel.requiereAnexo === 'si';
  }

  onRequiereAnexoChange(programaSel: ProgramaSeleccionado): void {
    if (!this.shouldShowRequiereAnexo(programaSel)) {
      programaSel.requiereAnexo = null;
      programaSel.anexoCodigo = '';
      programaSel.tarifaAnexo = '';
      programaSel.nombreAnexo = '';
      this.actualizarProgramasContratanteLocalStorage();
      return;
    }

    if (programaSel.requiereAnexo !== 'si') {
      programaSel.requiereAnexo = 'no';
      programaSel.anexoCodigo = '';
      programaSel.tarifaAnexo = '';
      programaSel.nombreAnexo = '';
      this.actualizarProgramasContratanteLocalStorage();
      return;
    }

    if ((programaSel.anexosDisponibles?.length ?? 0) === 0) {
      this.consultarAnexosPrograma(programaSel);
      return;
    }

    this.syncAnexoSeleccionado(programaSel);
    this.actualizarProgramasContratanteLocalStorage();
  }

  /** Clave única del anexo para select/guardado (plan_codi_adi; si falta, plan_codi|tari). */
  claveAnexoOption(an: AnexoProgramaOption): string {
    const adi = (an.planCod2 || '').trim();
    if (adi) return adi;
    const cod1 = (an.planCod1 || '').trim();
    const tari = (an.tari || '').trim();
    return cod1 && tari ? `${cod1}|${tari}` : cod1 || tari;
  }

  /** Formato legacy del beneficiario: planCod1|tari|valor */
  anexoClaveCompuesta(an: AnexoProgramaOption): string {
    const cod1 = (an.planCod1 || '').trim();
    const tari = (an.tari || '').trim();
    const valor = (an.valor || '').trim();
    if (cod1 && tari) return `${cod1}|${tari}|${valor}`;
    return cod1 || tari || valor;
  }

  private normalizarAnexoSel(value: unknown): string {
    return (value ?? '').toString().trim().toUpperCase();
  }

  /** Acepta clave modal, clave compuesta del beneficiario o códigos cortos (plan_codi_adi). */
private matchAnexoSeleccion(an: AnexoProgramaOption, selected: unknown): boolean {
  const sel = (selected ?? '').toString().trim().toUpperCase();
  if (!sel) return false;
  
  const planCod1 = (an?.planCod1 ?? '').toString().trim().toUpperCase();
  const planCod2 = (an?.planCod2 ?? '').toString().trim().toUpperCase();
  const tari = (an?.tari ?? '').toString().trim().toUpperCase();
  const nombre = (an?.nombre ?? '').toString().trim().toUpperCase();
  const keyFull = this.claveAnexoOption(an).toUpperCase().trim();
  
  // Función local para normalizar textos sin depender de métodos de la clase
  const localNorm = (s: any) => (s ?? '').toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toUpperCase();
  const selNorm = localNorm(sel);

  console.log('[ANEXO-DEBUG-MATCH] Evaluando anexo opción:', {
    sel, planCod1, planCod2, tari, keyFull
  });

  if (selNorm && keyFull && (selNorm === keyFull || selNorm === localNorm(planCod2) || selNorm === localNorm(tari))) {
    return true;
  }

  if (sel.includes('|')) {
    const partes = sel.split('|').map(p => p.trim().toUpperCase());
    const selPlan = partes[0] || '';
    const selTari = partes[1] || '';
    if (selTari) {
      const planOk = !selPlan || selPlan === planCod1 || selPlan === planCod2;
      return planOk && !!tari && selTari === tari;
    }
    return !!selPlan && (selPlan === planCod1 || selPlan === planCod2);
  }

  if (tari && (selNorm === tari || selNorm.includes(tari) || tari.includes(selNorm))) return true;
  if (planCod2 && (selNorm === planCod2 || selNorm.includes(planCod2) || planCod2.includes(selNorm))) return true;
  if (planCod1 && (selNorm === planCod1 || selNorm.includes(planCod1) || planCod1.includes(selNorm))) return true;
  if (nombre && (selNorm === localNorm(nombre) || selNorm.includes(localNorm(nombre)) || localNorm(nombre).includes(selNorm))) return true;

  return false;
}

  private findAnexoEnOpciones(
  opciones: AnexoProgramaOption[],
  valorSeleccionado: unknown
): AnexoProgramaOption | undefined {
  const seleccionado = this.normalizarAnexoSel(
    valorSeleccionado
  );

  if (!seleccionado) {
    return undefined;
  }

  return opciones.find(anexo => {
    const claveCompuesta = this.normalizarAnexoSel(
      this.anexoClaveCompuesta(anexo)
    );

    const claveAlterna = this.normalizarAnexoSel(
      this.claveAnexoOption(anexo)
    );

    const planCod1 = this.normalizarAnexoSel(
      anexo.planCod1
    );

    const planCod2 = this.normalizarAnexoSel(
      anexo.planCod2
    );

    const tarifa = this.normalizarAnexoSel(
      anexo.tari
    );

    return (
      seleccionado === claveCompuesta ||
      seleccionado === claveAlterna ||
      seleccionado === planCod1 ||
      seleccionado === planCod2 ||
      seleccionado === tarifa ||
      claveCompuesta.includes(`|${seleccionado}|`) ||
      claveCompuesta.endsWith(`|${seleccionado}`)
    );
  });
}

  private matchAnexoCodigos(a: unknown, b: unknown): boolean {
    const sa = (a ?? '').toString().trim();
    const sb = (b ?? '').toString().trim();
    if (!sa || !sb) return false;
    if (sa === sb) return true;
    if (this.normalizarAnexoSel(sa) === this.normalizarAnexoSel(sb)) return true;

    const partesA = sa.split('|').map(p => p.trim()).filter(Boolean);
    const partesB = sb.split('|').map(p => p.trim()).filter(Boolean);
    return partesA.some(pA => partesB.some(pB =>
      this.normalizarAnexoSel(pA) === this.normalizarAnexoSel(pB)
    ));
  }

  /** Una fila por plan_codi_adi; varios anexos comparten plan_codi pero no plan_codi_adi. */
  private deduplicarAnexosPorClave(anexos: AnexoProgramaOption[]): AnexoProgramaOption[] {
    const vistos = new Set<string>();
    const resultado: AnexoProgramaOption[] = [];
    for (const an of anexos) {
      const clave = this.claveAnexoOption(an);
      if (!clave || vistos.has(clave)) {
        continue;
      }
      vistos.add(clave);
      resultado.push(an);
    }
    return resultado;
  }

  private limpiarSuscripcionAnexosSiEsLaActual(programaId: string, sub: Subscription): void {
    if (this.consultarAnexosSubscriptionPorPrograma.get(programaId) === sub) {
      this.consultarAnexosSubscriptionPorPrograma.delete(programaId);
    }
  }

  private consultarAnexosPrograma(programaSel: ProgramaSeleccionado): void {
    const tipoPlan = this.getTipoPlanActual();

    // ──   VENTA NUEVA COLECTIVO / OGA ──
    // NC 0079: el carnet usa plan C (OPLC) pero activo trae F/A (OPLF) sin plan_grupo;
    // el fallback a lineaNegocio (MI) deja anexos vacíos. Resolver grupo comercial real solo aquí.
    if (this.esFlujoColectivoOGA && !this.esFlujoInclusion) {
      const planCodiNorm = (programaSel.id || '').trim().toUpperCase();
      const aCodigoComercialC = (codigo: string): string => {
        const c = (codigo || '').toString().trim().toUpperCase();
        if (c.endsWith('F') || c.endsWith('A')) {
          return c.substring(0, c.length - 1) + 'C';
        }
        return c;
      };
      const esLineaNegocioNoGrupo = (valor: string): boolean => {
        const u = (valor || '').toString().trim().toUpperCase();
        return !u || u === 'MI' || u === 'SO' || u === 'CEM' || u === '1' || u === '2' || u === '3';
      };

      const cuentaColectivo = String(
        this.cuentaColectivoGA ?? this.datosColectivoGA?.[0]?.cuenta ?? '1'
      ).trim();

      const filaCol: any = (this.datosColectivoGA || []).find((r: any) => {
        const rowPlan = aCodigoComercialC(r?.plan_codi ?? r?.PLAN_CODI ?? '');
        const rowCuenta = String(r?.cuenta ?? r?.CUENTA ?? '').trim();
        return rowPlan === planCodiNorm && (!cuentaColectivo || rowCuenta === cuentaColectivo);
      });

      const planOriginal = (filaCol?.plan_codi ?? filaCol?.PLAN_CODI ?? '').toString().trim().toUpperCase();

      const deno = (programaSel.subcuenta || '').trim();
      let subctaColectivo = (this.mapaDenoASubctaPorPrograma.get(programaSel.id)?.get(deno) || '').trim();
      if (!subctaColectivo) {
        subctaColectivo = (filaCol?.subcta ?? filaCol?.SUBCTA ?? (programaSel as any).__subctaCodeSeleccionada ?? '').toString().trim();
      }

      let planGrupoColectivo = (this.mapaDenoAPlanGrupoPorPrograma.get(programaSel.id)?.get(deno) || '').trim();
      if (esLineaNegocioNoGrupo(planGrupoColectivo)) {
        planGrupoColectivo = (
          filaCol?.plan_grupo ??
          filaCol?.PLAN_GRUPO ??
          filaCol?.grupo_programa ??
          filaCol?.GRUPO_PROGRAMA ??
          ''
        ).toString().trim();
      }
      // No usar programaInfo.grupoPrograma (suele ser MI/SO/CEM = línea, no grupo comercial).

      const abortAnexosColectivo = (planGrupoLog: string) => {
        this.traceAnexo('consultarAnexos: abort (params incompletos colectivo)', {
          programaId: programaSel.id,
          cuenta: cuentaColectivo,
          subcta: subctaColectivo,
          planGrupo: planGrupoLog
        });
        programaSel.anexosDisponibles = [];
        programaSel.requiereAnexo = null;
        programaSel.tarifaAnexo = '';
        programaSel.nombreAnexo = '';
        this.actualizarProgramasContratanteLocalStorage();
      };

      const dispararAnexosColectivo = (planGrupo: string, subcta: string) => {
        console.log(`[Modal-Colectivo-Anexos]  [COLECTIVO] Consultando Anexos para '${programaSel.id}' -> Cuenta: '${cuentaColectivo}' | SubctaCode: '${subcta}' | PlanGrupo: '${planGrupo}'`);

        let datosContratante: any = null;
        try {
          const raw = localStorage.getItem('datosRQ002_Contratante');
          if (raw) datosContratante = JSON.parse(raw);
        } catch (_) { }

        const edadContratante = datosContratante?.edad ? String(datosContratante.edad) : '0';
        const sexoContratante = datosContratante?.genero || '';

        const request: ConsultarAnexosColectivosGruposRequest = this.consultarAnexosColectivosGruposService.buildRequest({
          tipoPlan,
          cuenta: cuentaColectivo,
          subcuenta: subcta,
          planGrupo,
          planCodi: '',
          edad: edadContratante,
          sexo: sexoContratante
        });

        const programaId = (programaSel.id || '').trim();
        this.consultarAnexosSubscriptionPorPrograma.get(programaId)?.unsubscribe();

        const sub = this.consultarAnexosColectivosGruposService.consultarAnexosColectivosGrupos(request).subscribe({
          next: (resp) => {
            const rows = resp?.data?.jsonRespuesta ?? [];
            const anexos = this.deduplicarAnexosPorClave(
              rows.map((r: any): AnexoProgramaOption => {
                const tariClean = (r?.tari ?? '').toString().trim();
                const denoClean = (r?.deno ?? '').toString().trim();
                const mappedAnexo = {
                  planCod1: (r?.plan_codi ?? '').toString().trim(),
                  planCod2: (r?.plan_codi_adi ?? '').toString().trim(),
                  nombre: denoClean || (tariClean ? `${tariClean} - ANEXO` : 'ANEXO'),
                  tari: tariClean,
                  valor: (r?.valor ?? '0').toString().trim()
                };
                console.log('[ANEXO-DEBUG-MAPEO] Anexo mapeado desde Core:', mappedAnexo);
                return mappedAnexo;
              }).filter(an => !!an.tari && an.tari !== '0' && an.tari !== '0.0000')
            );
            programaSel.anexosDisponibles = anexos;
            if (!anexos.length) {
              programaSel.requiereAnexo = null;
              programaSel.anexoCodigo = '';
              programaSel.tarifaAnexo = '';
              programaSel.nombreAnexo = '';
              this.actualizarProgramasContratanteLocalStorage();
              this.limpiarSuscripcionAnexosSiEsLaActual(programaId, sub);
              return;
            }
            this.syncAnexoSeleccionado(programaSel);
            this.actualizarProgramasContratanteLocalStorage();
            this.limpiarSuscripcionAnexosSiEsLaActual(programaId, sub);
          },
          error: () => {
            programaSel.anexosDisponibles = [];
            programaSel.requiereAnexo = null;
            programaSel.anexoCodigo = '';
            programaSel.tarifaAnexo = '';
            programaSel.nombreAnexo = '';
            this.actualizarProgramasContratanteLocalStorage();
            this.limpiarSuscripcionAnexosSiEsLaActual(programaId, sub);
          }
        });
        this.consultarAnexosSubscriptionPorPrograma.set(programaId, sub);
      };

      if (!cuentaColectivo || !subctaColectivo) {
        abortAnexosColectivo(planGrupoColectivo);
        return;
      }

      if (!esLineaNegocioNoGrupo(planGrupoColectivo)) {
        dispararAnexosColectivo(planGrupoColectivo, subctaColectivo);
        return;
      }

      if (!planOriginal) {
        abortAnexosColectivo(planGrupoColectivo);
        return;
      }

      this.consultarSubcuentasService.consultarSubcuentas(planOriginal).subscribe({
        next: (response: any) => {
          const rows: any[] = response?.data?.jsonRespuesta || response?.data?.JSONRESPUESTA || [];
          const subNorm = subctaColectivo.toUpperCase();
          const subActivo = (filaCol?.subcta ?? filaCol?.SUBCTA ?? '').toString().trim().toUpperCase();
          let grupoResuelto = '';
          let subctaResuelta = subctaColectivo;

          for (const r of rows) {
            if (String(r?.cuenta ?? r?.CUENTA ?? '').trim() !== cuentaColectivo) {
              continue;
            }
            const g = (r?.plan_grupo ?? r?.PLAN_GRUPO ?? '').toString().trim();
            if (esLineaNegocioNoGrupo(g)) {
              continue;
            }
            const rSub = (r?.subcta ?? r?.SUBCTA ?? '').toString().trim().toUpperCase();
            if (rSub === subNorm) {
              grupoResuelto = g;
              break;
            }
            if (subActivo && rSub === subActivo && !grupoResuelto) {
              grupoResuelto = g;
              subctaResuelta = (r?.subcta ?? r?.SUBCTA ?? subctaColectivo).toString().trim();
            } else if (!grupoResuelto) {
              grupoResuelto = g;
            }
          }

          if (!grupoResuelto) {
            abortAnexosColectivo('');
            return;
          }

          const grupoMap = this.mapaDenoAPlanGrupoPorPrograma.get(programaSel.id) || new Map<string, string>();
          if (deno) {
            grupoMap.set(deno, grupoResuelto);
            this.mapaDenoAPlanGrupoPorPrograma.set(programaSel.id, grupoMap);
          }

          dispararAnexosColectivo(grupoResuelto, subctaResuelta);
        },
        error: () => abortAnexosColectivo('')
      });
      return;
    }

    const esColectivoOAfinidad = this.esFlujoColectivoOGA;
    let cuenta = esColectivoOAfinidad ? (this.cuentaColectivoGA != null ? String(this.cuentaColectivoGA).trim() : '') : this.getCuentaNoColectivoPorTipoPlan();

    if (this.esFlujoInclusion && esColectivoOAfinidad && !cuenta) {
      const prefCuenta = this.inclusionPreferenciasPorPrograma.get(programaSel.id.trim())?.codCuenta;
      if (prefCuenta) {
        cuenta = prefCuenta.toString().trim();
        console.log(`%c [Inclusion-Colectivo-Anexo-Guard] Resolviendo cuenta de contrato para anexo colectivo: ${cuenta}`);
      }
    }

    const deno = (programaSel.subcuenta || '').trim();
    let subcta = esColectivoOAfinidad ? (this.mapaDenoASubctaPorPrograma.get(programaSel.id)?.get(deno) || '') : '';

    if (!subcta) {
      const tipoPlanStr = this.getTipoPlanActual() || '';
      const programaInfo = this.programasDisponibles.find(p => p.id === programaSel.id);
      const lineaCode = programaInfo?.lineaNegocio === 'MI' ? 'SMP' : (programaInfo?.lineaNegocio === 'SO' ? 'SAO' : 'CEM');
      subcta = (tipoPlanStr + lineaCode).trim().toUpperCase();
    }

    let planGrupo = esColectivoOAfinidad ? (this.mapaDenoAPlanGrupoPorPrograma.get(programaSel.id)?.get(deno) || '') : '';

    if (esColectivoOAfinidad) {
      const planCodiNorm = (programaSel.id || '').trim().toUpperCase();
      const filaCol = (this.datosColectivoGA || []).find((r: any) =>
        (r?.plan_codi ?? r?.PLAN_CODI ?? '').toString().trim().toUpperCase() === planCodiNorm
      ) as any;

      if (!cuenta) {
        cuenta = String(filaCol?.cuenta ?? filaCol?.CUENTA ?? this.datosColectivoGA?.[0]?.cuenta ?? '1').trim();
      }
      if (!subcta) {
        subcta = (filaCol?.subcta ?? filaCol?.SUBCTA ?? (programaSel as any).__subctaCodeSeleccionada ?? '').toString().trim();
      }
      if (!planGrupo) {
        planGrupo = (filaCol?.plan_grupo ?? filaCol?.grupo_programa ?? filaCol?.linea_negocio ?? '').toString().trim();
      }
    }

    if (!subcta) {
      const programaInfo = this.programasDisponibles.find(p => p.id === programaSel.id);
      const lineaCode = programaInfo?.lineaNegocio === 'MI' ? 'SMP' : (programaInfo?.lineaNegocio === 'SO' ? 'SAO' : 'CEM');
      subcta = (tipoPlan + lineaCode).trim().toUpperCase();
    }

    if (!planGrupo) {
      const programaInfo = this.programasDisponibles.find(p => p.id === programaSel.id);
      const numLinea = this.mapLineaToNumber(programaInfo?.lineaNegocio as any || 'MI');
      planGrupo = numLinea > 0 ? String(numLinea) : '1';
    }

    const planCodi = (programaSel.id || '').trim();

    if (!cuenta || (esColectivoOAfinidad && (!subcta || !planGrupo)) || (!esColectivoOAfinidad && !planCodi)) {
      this.traceAnexo('consultarAnexos: abort (params incompletos) → persiste store', {
        programaId: programaSel.id,
        anexoCodigoAntes: (programaSel.anexoCodigo || '').trim(),
        cuenta: !!cuenta,
        subcta: !!subcta,
        planGrupo: !!planGrupo,
        planCodi: !!planCodi,
      });
      programaSel.anexosDisponibles = [];
      programaSel.requiereAnexo = null;
      programaSel.tarifaAnexo = '';
      programaSel.nombreAnexo = '';
      this.actualizarProgramasContratanteLocalStorage();
      return;
    }

    let datosContratante: any = null;
    try {
      const raw = localStorage.getItem('datosRQ002_Contratante');
      if (raw) {
        datosContratante = JSON.parse(raw);
      }
    } catch (_) { }

    const edadContratante = datosContratante?.edad ? String(datosContratante.edad) : "0";
    const sexoContratante = datosContratante?.genero || "";

    const request: ConsultarAnexosColectivosGruposRequest = this.consultarAnexosColectivosGruposService.buildRequest({
      tipoPlan,
      cuenta,
      subcuenta: subcta,
      planGrupo,
      planCodi,
      edad: edadContratante,
      sexo: sexoContratante
    });

    const programaId = (programaSel.id || '').trim();
    this.consultarAnexosSubscriptionPorPrograma.get(programaId)?.unsubscribe();

    const sub = this.consultarAnexosColectivosGruposService.consultarAnexosColectivosGrupos(request).subscribe({
      next: (resp) => {
        const rows = resp?.data?.jsonRespuesta ?? [];
        const anexos = this.deduplicarAnexosPorClave(
          rows
            .map((r: any): AnexoProgramaOption => ({
              planCod1: (r?.plan_codi ?? '').toString().trim(),
              planCod2: (r?.plan_codi_adi ?? '').toString().trim(),
              nombre: (r?.deno ?? '').toString().trim(),
              tari: (r?.tari ?? '').toString().trim(),
              valor: (r?.valor ?? '').toString().trim()
            }))
            .filter(an => !!this.claveAnexoOption(an) && !!an.nombre && (!!an.tari || !!an.valor))
        );
        programaSel.anexosDisponibles = anexos;
        if (!anexos.length) {
          // NC 1078: en edición, no borrar anexo ya persistido si el catálogo viene vacío.
          const tieneAnexoPersistido = !!(programaSel.anexoCodigo || programaSel.tarifaAnexo || '').toString().trim()
            || programaSel.requiereAnexo === 'si';
          if (this.esEditModeActivo && tieneAnexoPersistido) {
            this.syncAnexoSeleccionado(programaSel);
            this.actualizarProgramasContratanteLocalStorage();
            this.limpiarSuscripcionAnexosSiEsLaActual(programaId, sub);
            return;
          }
          this.traceAnexo('consultarAnexos: HTTP ok pero 0 anexos → LIMPIA anexoCodigo y persiste', {
            programaId: programaSel.id,
            anexoCodigoAntes: (programaSel.anexoCodigo || '').trim(),
          });
          programaSel.requiereAnexo = null;
          programaSel.anexoCodigo = '';
          programaSel.tarifaAnexo = '';
          programaSel.nombreAnexo = '';
          this.actualizarProgramasContratanteLocalStorage();
          this.limpiarSuscripcionAnexosSiEsLaActual(programaId, sub);
          return;
        }
        this.syncAnexoSeleccionado(programaSel);
        this.traceAnexo('consultarAnexos: HTTP ok', {
          programaId: programaSel.id,
          cantidad: anexos.length,
          anexoCodigoDespues: (programaSel.anexoCodigo || '').trim(),
        });
        this.actualizarProgramasContratanteLocalStorage();
        this.limpiarSuscripcionAnexosSiEsLaActual(programaId, sub);
      },
      error: () => {
        // NC 1078: en edición, preservar anexo persistido ante error de catálogo.
        const tieneAnexoPersistido = !!(programaSel.anexoCodigo || programaSel.tarifaAnexo || '').toString().trim()
          || programaSel.requiereAnexo === 'si';
        if (this.esEditModeActivo && tieneAnexoPersistido) {
          programaSel.anexosDisponibles = [];
          this.syncAnexoSeleccionado(programaSel);
          this.actualizarProgramasContratanteLocalStorage();
          this.limpiarSuscripcionAnexosSiEsLaActual(programaId, sub);
          return;
        }
        this.traceAnexo('consultarAnexos: HTTP error → LIMPIA anexoCodigo y persiste', {
          programaId: programaSel.id,
          anexoCodigoAntes: (programaSel.anexoCodigo || '').trim(),
        });
        programaSel.anexosDisponibles = [];
        programaSel.requiereAnexo = null;
        programaSel.anexoCodigo = '';
        programaSel.tarifaAnexo = '';
        programaSel.nombreAnexo = '';
        this.actualizarProgramasContratanteLocalStorage();
        this.limpiarSuscripcionAnexosSiEsLaActual(programaId, sub);
      }
    });
    this.consultarAnexosSubscriptionPorPrograma.set(programaId, sub);
  }

  onTarifaAnexoChange(
  programaSel: ProgramaSeleccionado,
  valorSeleccionado: string
): void {
  const valorNuevo = (
    valorSeleccionado || ''
  ).toString().trim();

  programaSel.anexoCodigo = valorNuevo;

  if (!valorNuevo) {
    programaSel.tarifaAnexo = '';
    programaSel.nombreAnexo = '';

    this.actualizarProgramasContratanteLocalStorage();
    return;
  }

  this.syncAnexoSeleccionado(programaSel);
  this.actualizarProgramasContratanteLocalStorage();
}

private syncAnexoSeleccionado(
  programaSel: ProgramaSeleccionado
): void {
  
  const candidatosPersistidos = [
    programaSel.anexoCodigo,
    programaSel.tarifaAnexo,
    programaSel.nombreAnexo
  ]
    .map(value => (value || '').toString().trim())
    .filter(
      (value, index, values) =>
        !!value && values.indexOf(value) === index
    );

  const codSel = candidatosPersistidos[0] ?? '';

  if (!this.shouldShowTarifaAnexo(programaSel)) {
    
    if (codSel) {
      return;
    }

    programaSel.anexoCodigo = '';
    programaSel.tarifaAnexo = '';
    programaSel.nombreAnexo = '';
    return;
  }

  const opciones = Array.isArray(programaSel.anexosDisponibles)
    ? programaSel.anexosDisponibles
    : [];

  let hit: AnexoProgramaOption | undefined;

  for (const candidato of candidatosPersistidos) {
    const encontrada = this.findAnexoEnOpciones(
      opciones,
      candidato
    );

    if (encontrada) {
      hit = encontrada;
      break;
    }
  }

  if (
    !hit &&
    programaSel.requiereAnexo === 'si' &&
    opciones.length === 1
  ) {
    hit = opciones[0];
  }

  if (
    !hit &&
    this.esEditModeActivo &&
    programaSel.requiereAnexo === 'si' &&
    codSel
  ) {
    const clavePersistida = (
      programaSel.anexoCodigo ||
      programaSel.tarifaAnexo ||
      codSel
    ).toString().trim();

    const partesClave = clavePersistida
      .split('|')
      .map(parte => parte.trim());

    const tarifaAnexoPersistida = (
      programaSel.tarifaAnexo || ''
    ).toString().trim();

    const partesTarifaAnexo = tarifaAnexoPersistida
      .split('|')
      .map(parte => parte.trim());

    const esValorNumerico = (valor: string): boolean =>
      /^\d+(\.\d+)?$/.test(valor);

    const tarifaPersistida = (
      partesTarifaAnexo.length >= 2
        ? partesTarifaAnexo[1]
        : tarifaAnexoPersistida &&
          !esValorNumerico(tarifaAnexoPersistida)
          ? tarifaAnexoPersistida
          : partesClave[1] || partesClave[0] || ''
    ).trim();

    const valorPersistido = (
      partesTarifaAnexo.length >= 3
        ? partesTarifaAnexo[2]
        : partesClave.length >= 3
          ? partesClave[2]
          : esValorNumerico(tarifaAnexoPersistida)
            ? tarifaAnexoPersistida
            : ''
    ).trim();

    const opcionPersistida: AnexoProgramaOption = {
      planCod1: (
        partesClave[0] ||
        programaSel.id ||
        ''
      ).trim(),

      planCod2:
        partesClave.length === 1
          ? clavePersistida
          : '',

      tari: tarifaPersistida,

      nombre: (
        programaSel.nombreAnexo ||
        tarifaPersistida ||
        clavePersistida
      ).trim(),

      valor: valorPersistido
    };

    const claveOpcionPersistida =
      this.anexoClaveCompuesta(opcionPersistida);

    const yaExiste = opciones.some(
      opcion =>
        this.normalizarAnexoSel(
          this.anexoClaveCompuesta(opcion)
        ) ===
        this.normalizarAnexoSel(claveOpcionPersistida)
    );

    if (!yaExiste) {
      opciones.push(opcionPersistida);
    }

    hit = opcionPersistida;

    this.traceAnexo(
      'syncAnexo: opción persistida incorporada al catálogo de edición',
      {
        programaId: programaSel.id,
        clavePersistida,
        tarifaPersistida,
        valorPersistido
      }
    );
  }

  if (!hit) {
    console.warn(
      '[ANEXO] Sin coincidencia; se preserva selección',
      {
        programaId: programaSel.id,
        anexoCodigo: codSel,
        clavesDisponibles: opciones.map(anexo =>
          this.anexoClaveCompuesta(anexo)
        )
      }
    );

    // no limpiar anexoCodigo ni tarifaAnexo, se conserva la selecion previa del usuario
    return;
  }
  
  // los valores deben de coincidir
  const claveFinal = this.anexoClaveCompuesta(hit);

  programaSel.anexoCodigo = claveFinal;
  programaSel.tarifaAnexo = claveFinal;
  programaSel.nombreAnexo = (
    hit.nombre || ''
  ).trim();
}

  /**
   * Toggle selección de programa (agregar/quitar)
   */
  toggleProgramaSeleccion(programa: Programa): void {
    if (this.esPrecargaVisualFAEM) return;
    const index = this.programasSeleccionados.findIndex(p => p.id === programa.id);

    if (index >= 0) {
      // Ya está seleccionado, lo quitamos
      this.programasSeleccionados.splice(index, 1);
    } else {
      // No está seleccionado, lo agregamos con configuración por defecto
      const nuevoPrograma: ProgramaSeleccionado = {
        id: programa.id,
        nombre: programa.nombre,
        grupoPrograma: programa.grupoPrograma,
        subcuenta: '',
        tarifa: '',
        campana: '',
        anexoCodigo: '',
        tarifaAnexo: '',
        nombreAnexo: '',
        requiereAnexo: null,
        anexosDisponibles: [],
        subcuentasDisponibles: [],
        subcuentasConsultaRealizada: false,
        tarifasDisponibles: [],
        tarifasConsultaRealizada: false,
        campaniasDisponibles: [],
        campaniasConsultaRealizada: false
      };
      this.programasSeleccionados.push(nuevoPrograma);

      if (this.esFlujoColectivoOGA && !this.esFlujoInclusion) {
        this.cargarSubcuentasColectivo(nuevoPrograma);
        this.actualizarProgramasContratanteLocalStorage();
        return;
      }


      const codigoPrograma = programa.codigo.trim();

      if (!this.esFlujoColectivoOGA || this.esFlujoInclusion) {
        this.cargarTarifasParaPrograma(nuevoPrograma);
        this.cargarCampaniasParaPrograma(nuevoPrograma);
        this.consultarAnexosPrograma(nuevoPrograma);
        this.actualizarProgramasContratanteLocalStorage();

        return;
      }

      this.consultarSubcuentasService.consultarSubcuentas(codigoPrograma).subscribe({
        next: (response) => {
          const programaSel = this.programasSeleccionados.find(p => p.id === programa.id);
          if (!programaSel) return;
          if (response.status && response.data?.jsonRespuesta?.length > 0) {
            if (this.esFlujoInclusion) {
              const pref = this.inclusionPreferenciasPorPrograma.get(programa.id.trim());
              const codCuentaInclusion = pref?.codCuenta || '';
              const subcuentaInclusionCode = (pref?.subcuenta ?? '').trim().toUpperCase();

              let rowsFiltradas = response.data.jsonRespuesta;

              if (codCuentaInclusion) {
                rowsFiltradas = rowsFiltradas.filter((r: any) =>
                  (r?.cuenta ?? r?.CUENTA ?? '').toString().trim() === codCuentaInclusion
                );
              }

              this.procesarSubcuentasRespuesta(programaSel, codigoPrograma, rowsFiltradas, { filtrarColectivoGA: this.esFlujoColectivoOGA });

              const matchSubcAsignadaCore = rowsFiltradas.find((r: any) =>
                (r?.subcta ?? '').toString().trim().toUpperCase() === subcuentaInclusionCode
              );

              if (matchSubcAsignadaCore) {
                programaSel.subcuenta = matchSubcAsignadaCore.deno;
                console.log(`[Inclusion-Toggle-Guard] Forzando  dinámico en toggle: ${programaSel.subcuenta}`);
              }

              this.cargarTarifasParaPrograma(programaSel);
              this.cargarCampaniasParaPrograma(programaSel);
              this.consultarAnexosPrograma(programaSel);
              this.actualizarProgramasContratanteLocalStorage();

              this.cdr.detectChanges();

            } else {
              this.procesarSubcuentasRespuesta(programaSel, codigoPrograma, response.data.jsonRespuesta, {
                filtrarColectivoGA: this.esFlujoColectivoOGA
              });
            }
          } else {
            this.marcarSubcuentasConsultaSinResultados(programaSel);
            this.cargarTarifasParaPrograma(programaSel);
          }
        },
        error: (err) => {
          console.error('Error al consultar subcuentas:', err);
          const programaSel = this.programasSeleccionados.find(p => p.id === programa.id);
          if (programaSel) {
            this.marcarSubcuentasConsultaSinResultados(programaSel);
          }
        }
      });
    }
  }

  /**
   * Actualiza la key programas_contratante en localStorage al seleccionar/deseleccionar o cambiar subcuenta/tarifa/campaña.
   */
  actualizarProgramasContratanteLocalStorage(): void {

   if (this.esFlujoInclusion) {
      const payload = this.programasSeleccionados.map(ps => {
        const programa = this.programasDisponibles.find(p => p.id === ps.id);
        const esCem = programa?.lineaNegocio === 'CEM';
        const campaniaSeleccionada = (ps.campaniasDisponibles || []).find(c => (c.codigo_campania ?? '').toString().trim() === (ps.campana ?? '').toString().trim());
        const tarifaSeleccionada = this.buscarTarifaDisponibleSeleccionada(ps) || ((ps.tarifasDisponibles && ps.tarifasDisponibles.length > 0) ? ps.tarifasDisponibles[0] : undefined);
        const nombreTarifaReal = tarifaSeleccionada?.descripcion || tarifaSeleccionada?.description || ps.tarifa || '';
        let codigoTarifa = (ps as any).__tarifaInclusionOriginal || this.inclusionPreferenciasPorPrograma.get(ps.id.trim())?.tarifa || '';
        if (!codigoTarifa && ps.tarifa) {
          codigoTarifa = ps.tarifa.includes(' - ') ? ps.tarifa.split(' - ')[0].trim() : ps.tarifa;
        }
        codigoTarifa = (codigoTarifa || '').toString().trim();
        const campRef = campaniaSeleccionada || (ps.campaniasDisponibles && ps.campaniasDisponibles.length > 0 ? ps.campaniasDisponibles[0] : null);
        const cAny = campRef as any;
        let fechaInicioReal = campRef?.inicio_vigencia || cAny?.inicioVigencia || cAny?.INICIO_VIGENCIA || cAny?.vigen_desde || cAny?.vigenDesde || (ps as any).inicioVigencia || (ps as any).inicio_vigencia;
        let fechaFinReal = campRef?.fin_vigencia || cAny?.finVigencia || cAny?.FIN_VIGENCIA || cAny?.vigen_hasta || cAny?.vigenHasta || (ps as any).finVigencia || (ps as any).fin_vigencia;
        if (!fechaInicioReal && tarifaSeleccionada) {
          fechaInicioReal = (tarifaSeleccionada as any).vigen_desde || (tarifaSeleccionada as any).vigenDesde || (tarifaSeleccionada as any).inicio_vigencia || (tarifaSeleccionada as any).inicioVigencia;
        }

        const tarifaDet = tarifaSeleccionada || this.buscarTarifaDisponibleSeleccionada(ps) || ((ps.tarifasDisponibles && ps.tarifasDisponibles.length > 0) ? ps.tarifasDisponibles[0] : null);
        const vIvaInclusion = Number(
          tarifaDet?.valorMensualIva ?? tarifaDet?.valorMensualBase ?? (ps as any)?.valorMensualIva ?? (ps as any)?.valorMensualBase ?? (ps as any)?.valor_mensual_iva ?? (ps as any)?.valor_mensual_base ?? (ps as any)?.valor_tari ?? (ps as any)?.VALOR_TARI ?? (ps as any)?.valor ?? (ps as any)?.VALOR ?? 0
        );
        const vBaseInclusion = Number(
          tarifaDet?.valorMensualBase ?? tarifaDet?.valorMensualIva ?? (ps as any)?.valorMensualBase ?? vIvaInclusion
        );

        const prefInclusion = this.inclusionPreferenciasPorPrograma.get(ps.id.trim());
        const subctaInclusionCode = (prefInclusion?.subcuenta ?? '').trim();
        let subctaTecnica = ((ps as any).__subctaCodeSeleccionada || (ps as any).__subcuentaInclusionOriginal || subctaInclusionCode || '').toString().trim();
        if (!subctaTecnica || !/^\d+$/.test(subctaTecnica)) {
          const mapDeno = this.mapaDenoASubctaPorPrograma.get(ps.id);
          if (mapDeno && ps.subcuenta) {
            const fromMap = mapDeno.get(ps.subcuenta.trim());
            if (fromMap && /^\d+$/.test(fromMap)) subctaTecnica = fromMap;
          }
        }
        let nombreSubcuentaDeno = ps.subcuenta || '';
        // Resolver deno→código numérico desde catálogo raw (Inclusión suele traer carnet ACEMN/ASMP en preferencias)
        if ((!subctaTecnica || !/^\d+$/.test(subctaTecnica)) && (ps as any).__subcuentasRaw) {
          const rawList: any[] = (ps as any).__subcuentasRaw || [];
          const denoKey = (nombreSubcuentaDeno || subctaTecnica || '').toString().trim().toUpperCase();
          const byDeno = rawList.find((r: any) => {
            const deno = (r?.deno ?? r?.DENO ?? '').toString().trim().toUpperCase();
            const code = (r?.subcta ?? r?.SUBCTA ?? '').toString().trim();
            return denoKey && deno === denoKey && /^\d+$/.test(code);
          });
          if (byDeno) {
            subctaTecnica = (byDeno.subcta ?? byDeno.SUBCTA ?? '').toString().trim();
            if (byDeno.deno || byDeno.DENO) {
              nombreSubcuentaDeno = (byDeno.deno || byDeno.DENO).toString().trim();
              ps.subcuenta = nombreSubcuentaDeno;
            }
          }
        }
        if ((!nombreSubcuentaDeno || nombreSubcuentaDeno === subctaTecnica || /^\d+$/.test(nombreSubcuentaDeno)) && (ps as any).__subcuentasRaw) {
          const rawList: any[] = (ps as any).__subcuentasRaw || [];
          const match = rawList.find((r: any) => (r?.subcta ?? r?.SUBCTA ?? '').toString().trim() === subctaTecnica);
          if (match?.deno || match?.DENO) {
            nombreSubcuentaDeno = (match.deno || match.DENO).toString().trim();
            ps.subcuenta = nombreSubcuentaDeno;
          }
        }
        // Nunca envenenar programas_contratante.subcta con carnet/deno (rompe guardarSubcuentas @Size max=4)
        if (subctaTecnica && !/^\d+$/.test(subctaTecnica)) {
          if (!nombreSubcuentaDeno) nombreSubcuentaDeno = subctaTecnica;
          if (!ps.subcuenta) ps.subcuenta = subctaTecnica;
          subctaTecnica = '';
        }

        const codAnexoSel = (ps.tarifaAnexo || ps.anexoCodigo || '').toString().trim();
        // NC 0015: el select guarda planCod1|tari|valor. No usar find naive ni caer al primer anexo (APREFB=0).
        const anexoMatch = this.findAnexoEnOpciones(ps.anexosDisponibles || [], ps.anexoCodigo)
          || this.findAnexoEnOpciones(ps.anexosDisponibles || [], ps.tarifaAnexo)
          || this.findAnexoEnOpciones(ps.anexosDisponibles || [], codAnexoSel);

        let codTarifaAnexo = (anexoMatch?.tari || (codAnexoSel && !/^\d+(\.\d+)?$/.test(codAnexoSel) ? codAnexoSel : '')).toString().trim();
        if (codTarifaAnexo.includes('|')) {
          codTarifaAnexo = codTarifaAnexo.split('|')[1] || codTarifaAnexo.split('|')[0];
        }

        const nombreAnexoResuelto = (anexoMatch?.nombre || (ps as any).nombreAnexo || '').toString().trim();
        const nombreTarifaAnexoFinal = nombreAnexoResuelto 
          ? (nombreAnexoResuelto.includes(codTarifaAnexo) ? nombreAnexoResuelto : `${codTarifaAnexo} - ${nombreAnexoResuelto}`)
          : codTarifaAnexo;

        const valorCatalogo = (anexoMatch?.valor ?? '').toString().trim();
        const valDesdeMatch = valorCatalogo === '' ? NaN : Number(valorCatalogo);
        const partesClaveAnexo = (ps.anexoCodigo || ps.tarifaAnexo || '').toString().split('|').map(p => p.trim());
        const valDesdeClave = partesClaveAnexo.length >= 3 ? Number(partesClaveAnexo[2]) : NaN;
        let valAnexoNum = Number.isFinite(valDesdeMatch)
          ? valDesdeMatch
          : (Number.isFinite(valDesdeClave) ? valDesdeClave : 0);

        if (!anexoMatch && (!Number.isFinite(valDesdeMatch) && !Number.isFinite(valDesdeClave))) {
          try {
            const prevStore = this.programaSeleccionStore.cargar();
            const prevAnexo = (prevStore?.programas || []).find(p =>
              (p.programa || '').toString().trim().toUpperCase() === ((programa?.codigo ?? ps.id) || '').toString().trim().toUpperCase()
            )?.anexoDetalle;
            const prevTari = (prevAnexo?.tari || '').toString().trim().toUpperCase();
            const prevValor = Number(prevAnexo?.valorMensualIva ?? prevAnexo?.valorMensualBase);
            if (prevTari && prevTari === codTarifaAnexo.toUpperCase() && Number.isFinite(prevValor)) {
              valAnexoNum = prevValor;
            }
          } catch {
            // no-op: se conserva valAnexoNum ya resuelto
          }
        }

        const anexoDetalle: any = (codTarifaAnexo && codTarifaAnexo !== '0' && codTarifaAnexo !== '0.0000') ? {
          clave: (anexoMatch ? this.claveAnexoOption(anexoMatch) : codAnexoSel),
          tari: codTarifaAnexo,
          nombreTarifa: nombreTarifaAnexoFinal,
          valorMensualIva: Number.isFinite(valAnexoNum) ? valAnexoNum : 0,
          valorMensualBase: Number.isFinite(valAnexoNum) ? valAnexoNum : 0,
          porcentajeIva: null,
          esTarifaAsociado: null,
          fueSeleccionada: true,
          esAnexo: true,
        } : null;

        console.log(`[INCLUSION-ANEXO-TITULAR-DEBUG] [Modal] Carnet: "${ps.id}" | Código Anexo: "${codTarifaAnexo}" | Nombre Anexo: "${nombreTarifaAnexoFinal}" | Valor: ${valAnexoNum}`);

        const grupoProgramaInclusion =
          this.resolverGrupoPrograma(ps, programa);

        const item: any = {
          lineaNegocio: this.lineaNegocioParaPersistir(programa?.lineaNegocio),
          grupo: this.esFlujoColectivoOGA ? (programa?.grupoPrograma ?? '') : (programa?.grupoPrograma || String(this.mapLineaToNumber(programa?.lineaNegocio as any || ''))),
          grupoPrograma: grupoProgramaInclusion,
          programa: programa?.codigo ?? ps.id,
          nombrePrograma: programa?.nombre ?? ps.nombre ?? '',
          idBenPrograma: Number((ps as any).__idBenPrograma || (ps as any).idBenPrograma || 0) || undefined,
          idSubcuenta: Number((ps as any).__idSubcuenta || (ps as any).idSubcuenta || 0) || undefined,
          idCotizacionTarifa: Number((ps as any).__idCotizacionTarifa || (ps as any).idCotizacionTarifa || 0) || undefined,
          idCotizacionTarifaAnexo: Number((ps as any).__idCotizacionTarifaAnexo || (ps as any).idCotizacionTarifaAnexo || 0) || undefined,
          idCotizacionCampania: Number((ps as any).__idCotizacionCampania || (ps as any).idCotizacionCampania || 0) || undefined,
          subcta: subctaTecnica,
          subcuenta: nombreSubcuentaDeno || ps.subcuenta || '',
          nombreSubcuenta: nombreSubcuentaDeno || ps.subcuenta || '',
          tarifa: codigoTarifa,
          nombreTarifa: nombreTarifaReal,
          valorMensualBase: vBaseInclusion > 0 ? vBaseInclusion : undefined,
          valorMensualIva: vIvaInclusion > 0 ? vIvaInclusion : undefined,
          porcentajeIva: tarifaSeleccionada?.porcentajeIva ?? (ps as any)?.porcentajeIva ?? undefined,
          tarifaDetalle: { tari: codigoTarifa, nombreTarifa: nombreTarifaReal, valorMensualBase: vBaseInclusion > 0 ? vBaseInclusion : null, valorMensualIva: vIvaInclusion > 0 ? vIvaInclusion : null, porcentajeIva: tarifaSeleccionada?.porcentajeIva ?? (ps as any)?.porcentajeIva ?? null, esTarifaAsociado: tarifaSeleccionada?.esTarifaAsociado ?? false, fueSeleccionada: true, esAnexo: false },
          campana: ps.campana ?? '',
          campanaNombre: (campaniaSeleccionada?.nombre ?? '').toString().trim(),
          inicioVigencia: fechaInicioReal || undefined,
          finVigencia: fechaFinReal || undefined,
          inicio_vigencia: fechaInicioReal || undefined,
          fin_vigencia: fechaFinReal || undefined,
          anexoCodigo: codTarifaAnexo || ps.anexoCodigo || '',
          tarifaAnexo: codTarifaAnexo || ps.tarifaAnexo || '',
          nombreAnexo: nombreTarifaAnexoFinal || ps.nombreAnexo || '',
          anexoDetalle: anexoDetalle,
          requiereAnexo: ps.requiereAnexo ?? null
        };
        if (esCem) {
          item.coberturaValida = this.coberturaCemValida;
        }
        return item;
      });
      console.log('[Flujo-Inclusion][Contratante-Storage] Sincronizando programas_contratante:', payload);
      localStorage.setItem(this.KEY_PROGRAMAS_CONTRATANTE, JSON.stringify(payload));
      try {
        this.beneficiarioLocalStorage.sincronizarProgramasDesdeContratante(payload as any);
      } catch {
        // no-op
      }
      return;
    }

    const idCotizacion = this.getIdCotizacionEnCurso() ?? 0;
    const storedPrev = this.programaSeleccionStore.cargar();

    const programas: ProgramaItemStore[] = this.programasSeleccionados.map(ps => {
      const programaBase = this.programasDisponibles.find(p => p.id === ps.id);
      const esCem = programaBase?.lineaNegocio === 'CEM';
      const codPrograma = (programaBase?.codigo ?? ps.id).toString().trim();

      // ── Tarifa principal ────────────────────────────────────────────────
      const tarifaDet = this.buscarTarifaDisponibleSeleccionada(ps);
      // Extrae el código limpio (ej. "PREF038...") del valor de display "Desc (PREF038...)"
      const tarifaRaw = (ps.tarifa || '').trim();
      const codigoTarifa = this.extraerCodigoTarifaLimpio(
        (ps as any).__tarifaCodigoLimpio,
        tarifaRaw,
        tarifaDet?.tarifa,
        (tarifaDet as any)?.tarifa_codigo
      );


      const nombreTarifaResuelta = tarifaDet?.descripcion ?? (tarifaDet as any)?.description ?? null;
      const vBaseVal = tarifaDet?.valorMensualBase ??
        (ps as any)?.valorMensualBase ??
        (ps as any)?.valor_tari ??
        (ps as any)?.VALOR_TARI ??
        null;

      const vIvaVal = tarifaDet?.valorMensualIva ??
        (ps as any)?.valorMensualIva ??
        vBaseVal;

      if (this.esFlujoColectivoOGA && !this.esFlujoInclusion) {
        console.log(`[Modal-Colectivo-StorageSave]  Evaluando tarifa Titular para '${ps.id}':`, {
          tarifaRaw,
          codigoTarifa,
          nombreTarifaResuelta,
          valorBase: vBaseVal,
          valorIva: vIvaVal
        });
      }

      const tarifaDetalle: ProgramaTarifaDetalle | null = codigoTarifa ? {
        tari: codigoTarifa,
        nombreTarifa: nombreTarifaResuelta,
        valorMensualBase: vBaseVal,
        valorMensualIva: vIvaVal,
        porcentajeIva: tarifaDet?.porcentajeIva ?? null,
        esTarifaAsociado: tarifaDet?.esTarifaAsociado ?? null,
        fueSeleccionada: true,
        esAnexo: false,
        tariTipo: tarifaDet?.tariTipo ?? null, // RQ004.2: Capturar tipo I/C
      } : null;

      // ── Subcuenta (código interno para guardarSubcuentas.subcta) ────────
      const deno = (ps.subcuenta || '').trim();
      const subcta = this.mapaDenoASubctaPorPrograma.get(ps.id)?.get(deno) || '';

      // ── Campaña seleccionada ────────────────────────────────────────────
      const codigoCampana = (ps.campana || '').trim();
      const campSel = (ps.campaniasDisponibles || []).find(
        c => (c.codigo_campania ?? '').toString().trim() === codigoCampana
      );
      const campaniaDetalle: ProgramaCampaniaDetalle | null = campSel ? {
        codCampComercial: (campSel.codigo_campania ?? '').toString().trim(),
        nombreCampania: (campSel.nombre ?? '').toString().trim(),
        fueSeleccionada: true,
        idCampania: campSel.id_campania,
        tipoCampania: campSel.tipo_campania,
        modalidad: campSel.modalidad,
        cuenta: campSel.cuenta,
        subcuenta: campSel.subcuenta,
        tipoPlan: campSel.tipo_plan,
        parentesco: campSel.parentesco,
        edadDesde: campSel.edad_desde,
        edadHasta: campSel.edad_hasta,
        cantBenefDesde: campSel.cant_benef_desde,
        cantBenefHasta: campSel.cant_benef_hasta,
        acumulable: campSel.acumulable,
        pagoDebitoAuto: campSel.pago_debito_auto,
        aplicaProntoPago: campSel.aplica_pronto_pago,
        observaciones: campSel.observaciones,
        usuarioActualizacion: (campSel as any).usuario_actualizacion ?? '',
        lineaNegocio: campSel.linea_negocio,
        grupoPrograma: campSel.grupo_programa,
        programa: campSel.programa,
        inicioVigencia: campSel.inicio_vigencia,
        finVigencia: campSel.fin_vigencia,
        estado: campSel.estado,
      } : null;

      // ── Anexo seleccionado ──────────────────────────────────────────────
      const codAnexoSel = (ps.tarifaAnexo || ps.anexoCodigo || '').trim();
      const anexoDet = codAnexoSel ? this.findAnexoEnOpciones(ps.anexosDisponibles || [], codAnexoSel) : undefined;

      let codTarifaAnexo = (anexoDet?.tari || codAnexoSel).toString().trim();
      if (codTarifaAnexo.includes('|')) {
        codTarifaAnexo = codTarifaAnexo.split('|')[1] || codTarifaAnexo.split('|')[0];
      }

      const nombreAnexoResuelto = (anexoDet?.nombre || (ps as any).nombreAnexo || '').toString().trim();
      const nombreTarifaAnexoFinal = nombreAnexoResuelto 
        ? (nombreAnexoResuelto.includes(codTarifaAnexo) ? nombreAnexoResuelto : `${codTarifaAnexo} - ${nombreAnexoResuelto}`)
        : codTarifaAnexo;

      const claveAnexoPersist = anexoDet ? this.claveAnexoOption(anexoDet) : codAnexoSel;
      const valorAnexoNumRaw = Number(anexoDet?.valor ?? (ps as any).tarifaAnexoVal ?? 0);
      const valorAnexoNum = Number.isFinite(valorAnexoNumRaw) ? valorAnexoNumRaw : 0;

      let anexoDetalle: any = null;
      if (codTarifaAnexo && codTarifaAnexo !== '0' && codTarifaAnexo !== '0.0000') {
        anexoDetalle = {
          clave: claveAnexoPersist,
          tari: codTarifaAnexo,
          nombreTarifa: nombreTarifaAnexoFinal,
          valorMensualIva: valorAnexoNum,
          valorMensualBase: valorAnexoNum,
          porcentajeIva: null,
          esTarifaAsociado: null,
          fueSeleccionada: true,
          esAnexo: true,
        };
      }

      console.log(`[ANEXO-DEBUG-CORRECCION] [Modal-Seleccion-Programas] Anexo procesado -> Código: "${codTarifaAnexo}", Nombre: "${nombreTarifaAnexoFinal}", Valor: ${valorAnexoNum}`, {
        ps,
        anexoDet,
        programaSeleccionStore: JSON.parse(localStorage.getItem('programas_contratante') || '{}')
      });

      const prevProg = storedPrev?.programas?.find(
        p => (p.programa || '').trim() === codPrograma
      );
      const prevCodAnexo = (prevProg?.anexoCodigo || prevProg?.anexoDetalle?.clave || '').trim();

      // Fallback: si tarifas/campañas sincronizan antes que anexosDisponibles,
      // preservar anexoDetalle del store para no perderlo en la race condition.
      if (!anexoDetalle && storedPrev?.programas && prevProg?.anexoDetalle) {
        const codCoincide = !codAnexoSel
          || prevCodAnexo === codAnexoSel
          || this.matchAnexoCodigos(prevCodAnexo, codAnexoSel);
        if (codCoincide) {
          anexoDetalle = prevProg.anexoDetalle;
        }
      }

      if (!anexoDetalle && (codAnexoSel || storedPrev?.programas?.find(
        p => (p.programa || '').trim() === codPrograma
      )?.anexoDetalle)) {
        this.traceAnexo('persist: anexoDetalle quedará NULL', {
          programa: codPrograma,
          anexoCodigoUI: codAnexoSel,
          anexosDisponibles: (ps.anexosDisponibles || []).length,
          teniaDetallePrevio: !!storedPrev?.programas?.find(
            p => (p.programa || '').trim() === codPrograma
          )?.anexoDetalle,
          requiereAnexo: ps.requiereAnexo,
        });
      }

      const grupoPrograma =
        this.resolverGrupoPrograma(ps, programaBase);

      if (!grupoPrograma) {
        console.error(
          '[GRUPO-PROGRAMA] No fue posible resolver el grupo',
          {
            tipoPlan: localStorage.getItem('tipoPlan'),
            programa: programaBase?.codigo ?? ps.id,
            nombrePrograma: programaBase?.nombre ?? ps.nombre,
            lineaNegocio: programaBase?.lineaNegocio,
            programaSeleccionado: ps,
            programaBase: programaBase
          }
        );
      }

      // ── Item final ──────────────────────────────────────────────────────
      const item: ProgramaItemStore = {
        lineaNegocio: this.lineaNegocioParaPersistir(programaBase?.lineaNegocio),
        grupo: this.esFlujoColectivoOGA
          ? (programaBase?.grupoPrograma ?? '')
          : (programaBase?.grupoPrograma || String(this.mapLineaToNumber(programaBase?.lineaNegocio as any || ''))),
        grupoPrograma,
        programa: programaBase?.codigo ?? ps.id,
        nombrePrograma: programaBase?.nombre ?? ps.nombre ?? '',

        subcuenta: deno,
        subcta,

        tarifa: codigoTarifa,
        tarifaDetalle,
        tariTipo: tarifaDetalle?.tariTipo ?? null, // RQ004.2: Tipo de tarifa a nivel de item

        anexoCodigo: anexoDet ? claveAnexoPersist : codAnexoSel,
        anexoDetalle,
        requiereAnexo: ps.requiereAnexo ?? null,

        campana: codigoCampana,
        campaniaDetalle,
      };

      if (this.esFlujoColectivoOGA) {
        (item as any).nombreTarifa = nombreTarifaResuelta || '';
        (item as any).valorMensualBase = vBaseVal ?? undefined;
        (item as any).valorMensualIva = vIvaVal ?? undefined;
        (item as any).porcentajeIva = tarifaDet?.porcentajeIva ?? undefined;
      }


      if (esCem) {
        item.coberturaValida = this.coberturaCemValida;
      }

      if (prevProg) {
        this.preservarIdsPersistenciaProgramaEnStore(item, prevProg);
      }



      return item;
    });

    // RQ004.2: Preparar datos del contratante para recálculo dinámico de tarifas tipo I
    let datosRecalculo: ProgramasContratanteStore['datosRecalculo'] = undefined;
    try {
      const raw = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
      if (raw) {
        const datos = JSON.parse(raw);
        const edad = (datos?.edad ?? '0').toString();
        const genero = (datos?.genero ?? 'M').toString().trim().toUpperCase();
        const sexo = genero === 'F' || genero.slice(0, 1) === 'F' || genero === '2' ? 'F' : 'M';
        datosRecalculo = {
          edad,
          sexo,
          parentesco: 'T', // T = Titular (siempre para contratante)
          cuenta: datos?.cuenta ?? undefined,
          tipoPlan: datos?.tipoPlan ?? undefined,
        };
      }
    } catch {
      // Si no se puede leer, datosRecalculo queda undefined
    }

    const storeData: ProgramasContratanteStore = {
      idCotizacion,
      tipoDocumento: (this.tipoDocumento || '').trim(),
      numeroDocumento: (this.numeroDocumento || '').trim(),
      savedAt: new Date().toISOString(),
      programas,
      datosRecalculo, // RQ004.2: Datos para recálculo
    };

    if (this.esFlujoInclusion) {
      console.log('[Inclusion-Store] Sincronizando programas_contratante:', storeData);
    }

    const resumenFinal = programas.map(p => ({
      programa: p.programa,
      anexoCodigo: p.anexoCodigo,
      tieneAnexoDetalle: !!p.anexoDetalle,
    }));
    const huboPerdida = resumenFinal.some(r => {
      if (r.tieneAnexoDetalle) return false;
      const prev = storedPrev?.programas?.find(sp => (sp.programa || '').trim() === r.programa);
      return !!(prev?.anexoDetalle || (r.anexoCodigo || '').trim());
    });
    if (huboPerdida) {
      this.traceAnexo('persist store (guardado)', { idCotizacion, resumenFinal });
    }

    this.programaSeleccionStore.guardar(storeData);
    try {
      this.beneficiarioLocalStorage.sincronizarProgramasDesdeContratante(programas);
    } catch {
      // no-op
    }
  }

  /** Conserva IDs persistidos en BD al re-guardar programas desde contratante. */
  private preservarIdsPersistenciaProgramaEnStore(item: ProgramaItemStore, prevProg: ProgramaItemStore): void {
    const idBeneficiario = Number((prevProg as any)?.idBeneficiario || 0);
    if (idBeneficiario > 0) {
      (item as any).idBeneficiario = idBeneficiario;
    }

    const camposId = [
      'idBenPrograma',
      'idSubcuenta',
      'idCotizacionTarifa',
      'idCotizacionTarifaAnexo',
      'idCotizacionCampania',
      'idBenCampania',
    ] as const;

    camposId.forEach((campo) => {
      const id = Number((prevProg as any)?.[campo] || 0);
      if (id > 0) {
        (item as any)[campo] = id;
      }
    });

    if ((prevProg as any)?.guardadoEnBd === true) {
      (item as any).guardadoEnBd = true;
    }
  }

  /** SO es código interno de UI; al persistir (BD/localStorage) siempre SAO. */
  private lineaNegocioParaPersistir(code: unknown): string {
    const c = (code ?? '').toString().trim().toUpperCase();
    if (c === 'SO') return 'SAO';
    return c;
  }

  /** SAO (persistido) → SO (UI interna). */
  private lineaNegocioParaUI(code: unknown): 'MI' | 'SO' | 'CEM' | '' {
    const c = (code ?? '').toString().trim().toUpperCase();
    if (c === 'SAO') return 'SO';
    if (c === 'MI' || c === 'SO' || c === 'CEM') return c;
    return '';
  }

  /** MI=1, SO=2, CEM=3 (igual que dialog-beneficiary). */
  private mapLineaToNumber(code: 'MI' | 'SO' | 'CEM'): number {
    switch (code) {
      case 'MI': return 1;
      case 'SO': return 2;
      case 'CEM': return 3;
      default: return 0;
    }
  }

  private getTipoPlanActual(): string {
    return (localStorage.getItem(this.KEY_TIPO_PLAN) ?? '').toString().trim().toUpperCase();
  }

  /** Individual: cuenta 1 = Asociado, cuenta 2 = Familiar / Empleado. */
  private getCuentaNoColectivoPorTipoPlan(): string {
    const tipoPlan = this.getTipoPlanActual();
    if (tipoPlan === 'A') return '1';
    if (tipoPlan === 'F' || tipoPlan === 'E' || tipoPlan === 'EM') return '2';
    return '2';
  }

  /**
   * Si el servicio de inclusión trajo tarifa y existe en el catálogo consultado, preselecciona.
   */
  private aplicarTarifaInclusionSiAplica(programaSel: ProgramaSeleccionado): void {
    if (!this.esFlujoInclusion) {
      return;
    }
    programaSel.tarifaBloqueadaPorInclusion = false;
    const pref = this.inclusionPreferenciasPorPrograma.get(programaSel.id.trim());
    const codigo = (pref?.tarifa ?? '').trim();
    if (!codigo) {
      return;
    }

    const cleanCode = (str: string): string => {
      if (!str) return '';
      let s = str.trim();
      if (s.includes(' - ')) return s.split(' - ')[0].trim();
      const m = s.match(/\(([^)]+)\)$/);
      if (m && m[1]) return m[1].trim();
      return s.split(' ')[0].trim();
    };

    const codeToMatch = cleanCode(codigo).toUpperCase();
    const match = (programaSel.tarifasDisponibles || []).find(t => {
      const tTarifa = (t?.tarifa ?? '').toString().trim();
      const tCode = cleanCode(tTarifa).toUpperCase();
      return tCode === codeToMatch || tTarifa.toUpperCase().includes(codeToMatch);
    }) || ((programaSel.tarifasDisponibles && programaSel.tarifasDisponibles.length > 0) ? programaSel.tarifasDisponibles[0] : null);

    if (match) {
      programaSel.tarifa = match.tarifa;
      if (programaSel.tarifasDisponibles && programaSel.tarifasDisponibles.length > 1) {
        programaSel.tarifaBloqueadaPorInclusion = false;
        console.log(`[Flujo-Inclusion] Múltiples tarifas detectadas (${programaSel.tarifasDisponibles.length}) para '${programaSel.id}'. Combo desbloqueado.`);
      } else {
        programaSel.tarifaBloqueadaPorInclusion = true;
      }
      this.actualizarProgramasContratanteLocalStorage();
    }
  }

  /**
   * Si el servicio de inclusión trajo campaña y existe en el catálogo consultado, preselecciona (por código o nombre).
   * En edición (Mis Cotizaciones): preselecciona desde preferencias/persistidos sin bloquear el combo.
   * En alta: si hay match con SP, preselecciona y bloquea (comportamiento inclusión).
   */
  private aplicarCampanaInclusionSiAplica(programaSel: ProgramaSeleccionado): void {
    if (!this.esFlujoInclusion) {
      return;
    }
    programaSel.campanaBloqueadaPorInclusion = false;
    const pref = this.inclusionPreferenciasPorPrograma.get(programaSel.id.trim());
    let raw = (pref?.campana ?? '').trim();
    if (raw.toLowerCase() === 'null') {
      raw = '';
    }
    // Edición: si el SP no trajo campaña usable, usar la ya sembrada / persistida.
    if (!raw && this.esEditModeActivo) {
      raw = (programaSel.campana || '').toString().trim();
      if (raw.toLowerCase() === 'null') {
        raw = '';
      }
      if (!raw) {
        const persistido = this.obtenerPersistidosEdicionInclusionPorCodigo()
          .get((programaSel.id || '').toString().trim().toUpperCase());
        raw = (
          persistido?.campana
          ?? persistido?.campania
          ?? persistido?.campaniaDetalle?.codCampComercial
          ?? persistido?.codCampComercial
          ?? ''
        ).toString().trim();
        if (raw.toLowerCase() === 'null') {
          raw = '';
        }
      }
    }
    if (!raw) {
      return;
    }
    const upper = raw.toUpperCase();
    let match =
      programaSel.campaniasDisponibles?.find(
        c => (c.codigo_campania ?? '').toString().trim().toUpperCase() === upper
      ) ?? null;
    if (!match) {
      match =
        programaSel.campaniasDisponibles?.find(
          c => (c.nombre ?? '').toString().trim().toUpperCase() === upper
        ) ?? null;
    }
    if (match) {
      programaSel.campana = match.codigo_campania;
      // Alta inclusión: bloquear. Edición: solo preseleccionar, combo editable.
      programaSel.campanaBloqueadaPorInclusion = !this.esEditModeActivo;
      this.actualizarProgramasContratanteLocalStorage();
    }
  }

  /** Inclusión: select de tarifa bloqueado cuando hubo match con el servicio de inclusión. */
  isTarifaBloqueadaPorInclusion(programaSel: ProgramaSeleccionado): boolean {
    return this.esFlujoInclusion && !!programaSel.tarifaBloqueadaPorInclusion;
  }

  /** Inclusión: select de campaña bloqueado cuando hubo match con el servicio de inclusión. */
  isCampanaBloqueadaPorInclusion(programaSel: ProgramaSeleccionado): boolean {
    return this.esFlujoInclusion && !!programaSel.campanaBloqueadaPorInclusion;
  }

  /** Construye el request para consultar-tarifas-individuales (solo flujo no colectivo). */
  private buildTarifaRequestFor(programaSel: ProgramaSeleccionado): ConsultarTarifasIndividualesParams | null {
    const programa = this.programasDisponibles.find(p => p.id === programaSel.id);
    if (!programa) return null;
    const lineaNegocioNumero = this.mapLineaToNumber(programa.lineaNegocio);
    if (!lineaNegocioNumero) return null;
    const codigoPrograma = (programaSel.id || programa.codigo || '').trim();
    if (!codigoPrograma) return null;
    return {
      pnu_pagina: '1',
      pnu_tamanoPagina: '1000',
      lineaNegocio: String(lineaNegocioNumero),
      plan: '',
      grupoPrograma: '',
      programa: codigoPrograma,
      planTarifario: '',
      pvc_campoOrden: ''
    };
  }

  /**
   * Carga tarifas individuales: Legacy + Valores. Solo expone tarifas con valor > 0.
   */
  /**
    * Carga tarifas individuales: Legacy + Valores. Solo expone tarifas con valor > 0.
    * Modificado: Consulta y mapea de forma secuencial las subcuentas maestras de la BD para alimentar la UI en Inclusiones.
    */
  cargarTarifasParaPrograma(programaSel: ProgramaSeleccionado): void {
    console.log(`[Flujo-Inclusion][Diagnostico] >>> Entrada a cargarTarifasParaPrograma para carnet: ${programaSel?.id} <<<`);

    const tipoPlanRaw = this.getTipoPlanActual();
    const tipoPlanFiltro = tipoPlanRaw.trim().toUpperCase();
    const datosTarifa = this.obtenerEdadSexoContratanteParaTarifa();

    if (this.esFlujoInclusion) {
      console.log(`[Flujo-Inclusion][Diagnostico] Evaluando carnet '${programaSel.id}' bajo la compuerta de Inclusiones.`);

      const pref = this.inclusionPreferenciasPorPrograma.get(programaSel.id.trim());
      const codigoTarifaInclusion = (pref?.tarifa ?? '').trim();
      const nombreTarifaInclusion = (pref?.nombreTarifa ?? '').trim();
      const subcuentaInclusionCode = (pref?.subcuenta ?? '').trim();

      console.log(`[Flujo-Inclusion][Diagnostico] Preferencias en memoria para '${programaSel.id}':`, { codigoTarifaInclusion, nombreTarifaInclusion, subcuentaInclusionCode });

      const planCodigoInclusion = programaSel.id.trim().toUpperCase();

      const ejecutarConsultaValoresTarifa = (codigoSubcuentaEfectivo: string) => {
        console.log(`[Flujo-Inclusion][Diagnostico] Lanzando consulta de valores con Subcuenta Técnica: '${codigoSubcuentaEfectivo}'`);
        this.consultarTarifasIndividualesService.consultarTarifasIndividualesValores({
          prm_cuenta: this.getCuentaNoColectivoPorTipoPlan(),
          prm_plan_codi: planCodigoInclusion,
          prm_tari: codigoTarifaInclusion,
          prm_subcta: codigoSubcuentaEfectivo,
          prm_paren: 'T',
          prm_edad: datosTarifa.edad,
          prm_sexo: datosTarifa.sexo,
          prm_inte_tipo: 'I'
        }).subscribe({
          next: (valResp) => {
            const items = Array.isArray(valResp?.data?.jsonRespuesta) ? valResp.data!.jsonRespuesta! : (Array.isArray(valResp?.data?.respuesta) ? valResp.data!.respuesta as any[] : []);
            console.log(`[Flujo-Inclusion][Valores-Resp] Respuesta del servicio para '${planCodigoInclusion}':`, items);

            const it = items.find((x: any) => (x?.tari ?? x?.TARI ?? '').toString().trim() === codigoTarifaInclusion) || items[0];
            if (it) {
              const valorReal = it?.valor ?? it?.VALOR;
              const valorIvaReal = it?.valor_iva ?? it?.VALOR_IVA ?? it?.valorMensualIva;
              const porcentajeIvaReal = it?.porcentaje_iva ?? it?.PORCENTAJE_IVA ?? it?.porcentajeIva;
              const valorIva = this.resolverValorMonetarioTarifa(valorReal, valorIvaReal);

              if (valorIva > 0) {
                const valorRaw = Number(valorReal);
                const valBaseDefinitivo = Number.isFinite(valorRaw) && valorRaw > 0 ? valorRaw : valorIva;

                (programaSel as any).valorMensualBase = valBaseDefinitivo;
                (programaSel as any).valorMensualIva = valorIva;
                (programaSel as any).porcentajeIva = this.resolverPorcentajeIvaTarifa(porcentajeIvaReal);

                console.log(`[Flujo-Inclusion][Valores-OK]  Asignado directamente a programaSel ('${programaSel.id}'): Base = $${valBaseDefinitivo} | IVA = $${valorIva}`);

                const tarifaContratada: IListTarifa = {
                  tarifa: nombreTarifaInclusion || codigoTarifaInclusion,
                  descripcion: nombreTarifaInclusion || (it?.tarifa_nombre ?? it?.TARIFA_NOMBRE ?? '').toString().trim() || codigoTarifaInclusion,
                  description: nombreTarifaInclusion || (it?.tarifa_nombre ?? it?.TARIFA_NOMBRE ?? '').toString().trim() || programaSel.nombre || codigoTarifaInclusion,
                  programa_grupo: planCodigoInclusion,
                  codigo_programa_grupo: planCodigoInclusion,
                  programa: planCodigoInclusion,
                  valorMensualBase: valBaseDefinitivo,
                  valorMensualIva: valorIva,
                  porcentajeIva: this.resolverPorcentajeIvaTarifa(porcentajeIvaReal)
                };
                this.finalizarCargaTarifasPrograma(programaSel, [tarifaContratada], true, true);
                programaSel.tarifa = nombreTarifaInclusion || codigoTarifaInclusion;
                (programaSel as any).__tarifaInclusionOriginal = codigoTarifaInclusion;
                programaSel.tarifaBloqueadaPorInclusion = true;
                this.actualizarProgramasContratanteLocalStorage();
                return;
              } else {
                console.log(`[Flujo-Inclusion][Valores-Warn]  valorIva calculado fue <= 0 para '${planCodigoInclusion}'. Raw:`, { valorReal, valorIvaReal });
              }
            } else {
              console.log(`[Flujo-Inclusion][Valores-Warn]  No se encontró item coincidente para '${planCodigoInclusion}' en el response de valores.`);
            }
            this.finalizarCargaTarifasPrograma(programaSel, [], true, false);
          },
          error: (errVal) => {
            console.error(`[Flujo-Inclusion][Diagnostico] Error liquidando valores individuales para '${programaSel.id}':`, errVal);
            this.finalizarCargaTarifasPrograma(programaSel, [], false, false);
          }
        });
      };

      if (programaSel.subcuentasDisponibles && programaSel.subcuentasDisponibles.length > 0) {

        console.log(`%c  [Inclusion-Performance-Guard] Subcuentas ya cargadas en memoria (${programaSel.subcuentasDisponibles.length}) para '${programaSel.id}'. Omitiendo consulta redundante.`, 'color: #9c27b0; font-weight: bold;');

        const denoAsignada = (programaSel.subcuenta || '').toString().trim().toUpperCase();
        const mapa = this.mapaDenoASubctaPorPrograma.get(programaSel.id);
        const subcuentaTecnicaFinal = (mapa && denoAsignada) ? mapa.get(denoAsignada) || subcuentaInclusionCode : subcuentaInclusionCode;

        ejecutarConsultaValoresTarifa(subcuentaTecnicaFinal);

        // Disparamos la consulta de anexos médicos con las variables seguras que ya están en memoria
        this.consultarAnexosPrograma(programaSel);

      } else {

        // [Escenario B]: Carga inicial del modal (El arreglo está vacío, procedemos con el pipeline estándar)
        programaSel.subcuentasDisponibles = [];
        programaSel.subcuentasConsultaRealizada = false;

        this.consultarSubcuentasService.consultarSubcuentas(planCodigoInclusion).subscribe({
          next: (subResp: any) => {
            const codCuentaInclusion = this.inclusionPreferenciasPorPrograma.get(planCodigoInclusion)?.codCuenta || '';
            let rowsSub = subResp?.data?.jsonRespuesta || subResp?.data?.JSONRESPUESTA || [];
            let subcuentaContratoCode = subcuentaInclusionCode;

            if (!codCuentaInclusion) {
              rowsSub = [];
              console.warn(`[Flujo-Inclusion] No se reportó codCuentaInclusion. Catálogo forzado a vacío.`);
            } else if (subResp?.status && rowsSub.length > 0) {
              rowsSub = rowsSub.filter((r: any) => (r?.cuenta ?? r?.CUENTA ?? '').toString().trim() === codCuentaInclusion);
            }

            if (subResp?.status && rowsSub.length > 0) {
              this.procesarSubcuentasRespuesta(programaSel, planCodigoInclusion, rowsSub);
              const subcuentaUiActual = (programaSel.subcuenta || '').toString().trim().toUpperCase();
              const existeMatchPorDeno = rowsSub.find((r: any) => (r?.deno || '').toString().trim().toUpperCase() === subcuentaUiActual);
              const matchSubcAsignadaCore = rowsSub.find((r: any) => (r?.subcta || '').toString().trim().toUpperCase() === subcuentaInclusionCode.toUpperCase());

              if (matchSubcAsignadaCore) {
                const denoContractual = (matchSubcAsignadaCore.deno || '').toString().trim().toUpperCase();

                if (!programaSel.subcuenta || !existeMatchPorDeno || subcuentaUiActual !== denoContractual) {
                  programaSel.subcuenta = matchSubcAsignadaCore.deno;
                  console.log(`[Inclusion-Subcuenta-Align] Alineando subcuenta visual al contrato: ${programaSel.subcuenta}`);
                }
              } else if (existeMatchPorDeno) {
                programaSel.subcuenta = existeMatchPorDeno.deno;
              } else {
                programaSel.subcuenta = rowsSub[0]?.deno || subcuentaInclusionCode;
              }
            } else {
              programaSel.subcuentasDisponibles = [];
              programaSel.subcuenta = '';
              programaSel.subcuentasConsultaRealizada = true;
            }
            const denoAsignada = (programaSel.subcuenta || '').toString().trim().toUpperCase();
            const rowFinalSeleccionada = rowsSub.find((r: any) => (r?.deno || '').toString().trim().toUpperCase() === denoAsignada);
            const subcuentaTecnicaFinal = rowFinalSeleccionada?.subcta || subcuentaContratoCode || subcuentaInclusionCode;

            ejecutarConsultaValoresTarifa(subcuentaTecnicaFinal);

            // Disparamos la consulta de anexos médicos una vez resueltos el planGrupo y la subcuenta técnica
            this.consultarAnexosPrograma(programaSel);

            this.cdr.detectChanges();
          },
          error: (errSub) => {
            console.warn(`[Flujo-Inclusion][Diagnostico] Falló la consulta de subcuentas en la BD.`, errSub);
            programaSel.subcuentasDisponibles = [];
            programaSel.subcuenta = '';
            programaSel.subcuentasConsultaRealizada = true;
            ejecutarConsultaValoresTarifa(subcuentaInclusionCode);
            this.cdr.detectChanges();
          }
        });
      }
      return;
    }

    // ──  CONVENIOS COLECTIVOS / GA ORDINARIOS ──
    if (this.esFlujoColectivoOGA) {
      console.log(`[Flujo-Inclusion][Diagnostico] Detectado flujo colectivo ordinario para '${programaSel.id}'. Omitiendo consulta individual.`);
      programaSel.tarifasDisponibles = [];
      programaSel.tarifasConsultaRealizada = true;
      programaSel.tarifasLegacyConDatos = false;
      programaSel.tarifasValoresConDatos = false;
      this.actualizarProgramasContratanteLocalStorage();
      return;
    }

    // Flujo tradicional Venta Nueva Familiar ordinario 
    const payload = this.buildTarifaRequestFor(programaSel);
    if (!payload) {
      this.finalizarCargaTarifasPrograma(programaSel, [], false, false);
      return;
    }

    payload.plan = tipoPlanFiltro;
    programaSel.tarifasLegacyConDatos = false;
    programaSel.tarifasValoresConDatos = false;

    this.consultarTarifasIndividualesService.consultarTarifasIndividualesLegacy(payload).pipe(
      concatMap((resp) => {
        const rows = resp?.status && Array.isArray(resp?.data?.jsonRespuesta) ? resp.data!.jsonRespuesta! : [];
        const filtradas = rows.filter(
          (it) => ((it.TIPO_PLAN ?? '').toString().trim().toUpperCase() === tipoPlanFiltro)
        );

        if (!filtradas.length) {
          return of({ data: [] as IListTarifa[], legacyConDatos: false, valoresConDatos: false, resolvedPlanCodi: '' });
        }

        const first = filtradas[0];
        const prmSubcta = (first?.SUBCUENTA ?? '').toString().trim().toUpperCase();
        const prmPlanCodi = (first?.PLAN_CODIGO ?? '').toString().trim().split('|')[0].trim().toUpperCase();
        const grupoPrograma = (first?.GRUPO_PROGRAMA ?? '')
          .toString()
          .split('|')[0]
          .trim()
          .toUpperCase();

        if (grupoPrograma && !this.esLineaNegocioComoGrupo(grupoPrograma)) {
          const codigoPrograma = (
            programaSel.id ||
            prmPlanCodi ||
            ''
          ).toString().trim().toUpperCase();

          this.grupoProgramaPorCodigo.set(
            codigoPrograma,
            grupoPrograma
          );

          if (prmPlanCodi) {
            this.grupoProgramaPorCodigo.set(
              prmPlanCodi,
              grupoPrograma
            );
          }

          programaSel.grupoPrograma = grupoPrograma;

          const programaBase = this.programasDisponibles.find(
            programa =>
              programa.id.trim().toUpperCase() === codigoPrograma
          );

          if (programaBase) {
            programaBase.grupoPrograma = grupoPrograma;
          }
        }

        if (!prmPlanCodi) {
          return of({ data: [] as IListTarifa[], legacyConDatos: true, valoresConDatos: false, resolvedPlanCodi: '' });
        }

        const tarifaNombreByCode: Record<string, string> = {};
        const codigosLegacy = new Set<string>();

        filtradas.forEach((it) => {
          const codigo = (it.TARIFA_CODIGO ?? '').toString().trim();
          const nombre = (it.TARIFA_NOMBRE ?? '').toString().trim();
          if (codigo) {
            codigosLegacy.add(codigo);
            if (nombre) {
              tarifaNombreByCode[codigo] = nombre;
            }
          }
        });

        const codigos = Array.from(codigosLegacy);
        if (!codigos.length) {
          return of({ data: [] as IListTarifa[], legacyConDatos: true, valoresConDatos: false, resolvedPlanCodi: prmPlanCodi });
        }

        const valorCalls = codigos.map((codigoTarifa) =>
          this.consultarTarifasIndividualesService.consultarTarifasIndividualesValores({
            prm_cuenta: this.getCuentaNoColectivoPorTipoPlan(),
            prm_plan_codi: prmPlanCodi,
            prm_tari: codigoTarifa,
            prm_subcta: prmSubcta || undefined,
            prm_paren: 'T',
            prm_edad: datosTarifa.edad,
            prm_sexo: datosTarifa.sexo,
            prm_inte_tipo: 'I'
          }).pipe(
            map((valResp) => ({
              codigo: codigoTarifa,
              items: Array.isArray(valResp?.data?.jsonRespuesta) ? valResp.data!.jsonRespuesta! : (Array.isArray(valResp?.data?.respuesta) ? valResp.data!.respuesta as any[] : [])
            })),
            catchError(() => of({ codigo: codigoTarifa, items: [] as any[] }))
          )
        );

        return forkJoin(valorCalls).pipe(
          map((resultadosValores) => {
            const valoresPorCodigo = new Map<string, { valorBase?: number; valorIva: number; porcentajeIva?: number; }>();
            const tariTipoPorCodigo = new Map<string, 'I' | 'C' | null>(); // RQ004.2: Mapa de tipos de tarifa

            resultadosValores.forEach(({ codigo, items }) => {
              // Sin datos en getTarifasCotizadortrl → no listar tarifa (aunque legacy tenga filas)
              if (!items?.length) {
                return;
              }

              const it = (items ?? []).find((x: any) => (x?.tari ?? x?.TARI ?? '').toString().trim() === codigo) ?? (items ?? [])[0];
              if (!it) {
                return;
              }

              const valorReal = it?.valor ?? it?.VALOR;
              const valorIvaReal = it?.valor_iva ?? it?.VALOR_IVA ?? it?.valorMensualIva;
              const porcentajeIvaReal = it?.porcentaje_iva ?? it?.PORCENTAJE_IVA ?? it?.porcentajeIva;

              const valorIva = this.resolverValorMonetarioTarifa(valorReal, valorIvaReal);
              if (valorIva <= 0) {
                return;
              }

              const valorRaw = Number(valorReal);
              valoresPorCodigo.set(codigo, {
                valorBase: Number.isFinite(valorRaw) && valorRaw > 0 ? valorRaw : undefined,
                valorIva,
                porcentajeIva: this.resolverPorcentajeIvaTarifa(porcentajeIvaReal)
              });
              
              // RQ004.2: Capturar tari_tipo del servicio
              const tariTipo = (it?.tari_tipo ?? it?.TARI_TIPO ?? null) as 'I' | 'C' | null;
              tariTipoPorCodigo.set(codigo, tariTipo);
            });

            const data: IListTarifa[] = [];
            codigosLegacy.forEach((cod) => {
              const valores = valoresPorCodigo.get(cod);
              if (!valores) return;
              const descripcion = (tarifaNombreByCode[cod] || cod).trim();
              const tariTipo = tariTipoPorCodigo.get(cod) ?? null; // RQ004.2: Obtener tipo desde el mapa
              
              data.push({
                tarifa: cod,
                descripcion,
                description: descripcion,
                grupoPrograma,
                programa_grupo: prmPlanCodi,
                codigo_programa_grupo: prmPlanCodi,
                programa: prmPlanCodi,
                valorMensualBase: valores.valorBase,
                valorMensualIva: valores.valorIva,
                porcentajeIva: valores.porcentajeIva,
                tariTipo // RQ004.2: Tipo de tarifa (I/C)
              });
            });

            return { data, legacyConDatos: true, valoresConDatos: data.length > 0, resolvedPlanCodi: prmPlanCodi };
          }),
          catchError(() => of({ data: [] as IListTarifa[], legacyConDatos: true, valoresConDatos: false, resolvedPlanCodi: prmPlanCodi }))
        );
      }),
      catchError(() => of({ data: [] as IListTarifa[], legacyConDatos: false, valoresConDatos: false, resolvedPlanCodi: '' }))
    ).subscribe({
      next: ({ data, legacyConDatos, valoresConDatos }) => {
        this.finalizarCargaTarifasPrograma(programaSel, data, legacyConDatos, valoresConDatos);
      },
      error: () => this.finalizarCargaTarifasPrograma(programaSel, [], false, false)
    });
  }

  private finalizarCargaTarifasPrograma(
    programaSel: ProgramaSeleccionado,
    data: IListTarifa[],
    legacyConDatos: boolean,
    valoresConDatos: boolean
  ): void {
    const grupoPrograma = (
      data.find((tarifa: any) =>
        (
          tarifa?.grupoPrograma ||
          tarifa?.grupo_programa ||
          tarifa?.GRUPO_PROGRAMA ||
          ''
        ).toString().trim() !== ''
      ) as any
    );

    const codigoGrupo = (
      grupoPrograma?.grupoPrograma ||
      grupoPrograma?.grupo_programa ||
      grupoPrograma?.GRUPO_PROGRAMA ||
      ''
    )
      .toString()
      .split('|')[0]
      .trim()
      .toUpperCase();

    if (codigoGrupo) {
      programaSel.grupoPrograma = codigoGrupo;

      const programaBase = this.programasDisponibles.find(
        programa => programa.id === programaSel.id
      );

      if (programaBase) {
        programaBase.grupoPrograma = codigoGrupo;
      }
    }

    programaSel.tarifasDisponibles = data;
    programaSel.tarifasConsultaRealizada = true;
    programaSel.tarifasLegacyConDatos = legacyConDatos;
    programaSel.tarifasValoresConDatos = valoresConDatos;

    if (data.length === 1) {
      programaSel.tarifa = data[0].tarifa;
      // Inclusión ya consultó campañas al dibujar el programa. onTarifaChange las volvería a pedir
      // y, junto con aplicarTarifaInclusionSiAplica, duplicaba getCampaniaCtz.
      if (!this.esFlujoInclusion) {
        setTimeout(() => this.onTarifaChange(programaSel));
      }
    } else if (!valoresConDatos) {
      programaSel.tarifa = '';
    }

    this.aplicarTarifaInclusionSiAplica(programaSel);
    this.actualizarProgramasContratanteLocalStorage();
  }

  private obtenerEdadSexoContratanteParaTarifa(): { edad: string; sexo: string } {
    try {
      const raw = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
      if (!raw) {
        return { edad: '', sexo: 'M' };
      }
      const datos = JSON.parse(raw);
      const edad = Number(datos?.edad ?? 0).toString();
      const sexoRaw = (datos?.genero ?? 'M').toString().trim().toUpperCase();
      const sexo = sexoRaw === 'F' || sexoRaw.slice(0, 1) === 'F' || sexoRaw === '2' ? 'F' : 'M';
      return { edad, sexo };
    } catch {
      return { edad: '', sexo: 'M' };
    }
  }

  private resolverValorMonetarioTarifa(valorRaw: unknown, valorIvaRaw: unknown): number {
    const valorIva = Number(valorIvaRaw);
    if (Number.isFinite(valorIva) && valorIva > 0) {
      return valorIva;
    }
    const valor = Number(valorRaw);
    return Number.isFinite(valor) && valor > 0 ? valor : 0;
  }

  private resolverPorcentajeIvaTarifa(valorRaw: unknown): number | undefined {
    const pct = Number(valorRaw);
    return Number.isFinite(pct) ? pct : undefined;
  }

  private buscarTarifaDisponibleSeleccionada(ps: ProgramaSeleccionado): IListTarifa | undefined {
    const tarifaRaw = (ps.tarifa || '').trim();
    if (!tarifaRaw) return undefined;

    const codeToMatch = this.extraerCodigoTarifaLimpio(
      (ps as any).__tarifaCodigoLimpio,
      tarifaRaw
    ).toUpperCase();

    const encontrada = (ps.tarifasDisponibles || []).find((t: any) => {
      const tTarifa = (t?.tarifa ?? '').toString().trim();
      const tDesc = (t?.descripcion ?? t?.description ?? '').toString().trim();
      const tCode = this.extraerCodigoTarifaLimpio(tTarifa, t?.tarifa_codigo).toUpperCase();
      return (!!codeToMatch && tCode === codeToMatch)
        || tTarifa === tarifaRaw
        || (!!codeToMatch && tTarifa.toUpperCase().includes(codeToMatch))
        || (!!codeToMatch && tDesc.toUpperCase().includes(codeToMatch));
    });

    if (encontrada) return encontrada;

    // Fallback de seguridad: si hay una sola tarifa disponible en la lista, la toma directamente
    if (ps.tarifasDisponibles && ps.tarifasDisponibles.length === 1) {
      return ps.tarifasDisponibles[0];
    }

    return undefined;
  }

  /**
   * Se llama al cambiar la subcuenta: limpia tarifa y campaña, carga tarifas y campañas del servicio y actualiza localStorage.
   */
  public onSubcuentaChange(programaSel: ProgramaSeleccionado): void {
    programaSel.tarifaBloqueadaPorInclusion = false;
    programaSel.campanaBloqueadaPorInclusion = false;
    programaSel.tarifa = '';
    programaSel.tarifasDisponibles = [];
    programaSel.tarifasConsultaRealizada = false;
    programaSel.tarifasLegacyConDatos = false;
    programaSel.tarifasValoresConDatos = false;
    programaSel.campana = '';
    programaSel.campaniasDisponibles = [];
    programaSel.campaniasConsultaRealizada = false;
    programaSel.anexoCodigo = '';
    programaSel.tarifaAnexo = '';
    programaSel.nombreAnexo = '';
    programaSel.anexosDisponibles = [];
    programaSel.requiereAnexo = null;

    if (this.esFlujoInclusion) {
      this.cargarTarifasParaPrograma(programaSel);
      this.cargarCampaniasParaPrograma(programaSel);
      this.consultarAnexosPrograma(programaSel);
      this.actualizarProgramasContratanteLocalStorage();
      return;
    }

    if (this.esFlujoColectivoOGA) {
      /*
      * La subcuenta cambió manualmente.
      * Se invalidan las referencias de la consulta anterior.
      */
      (programaSel as any).__lastTarifaRequestKey = null;
      (programaSel as any).__lastTarifaRequestId = null;
      (programaSel as any).__loadingTarifasColectivo = false;

      this.cargarTarifasColectivoDesdeActivosLocal(
        programaSel
      );

      this.actualizarProgramasContratanteLocalStorage();
      return;
    }

    this.cargarTarifasParaPrograma(programaSel);
    this.cargarCampaniasParaPrograma(programaSel);
    this.consultarAnexosPrograma(programaSel);
    this.actualizarProgramasContratanteLocalStorage();
  }
  /**
   * Deshabilita el select de tarifa si requiere subcuenta y no está elegida, o si la consulta devolvió sin tarifas.
   */
  isTarifaSelectDisabled(programaSel: ProgramaSeleccionado): boolean {
    if (!this.esFlujoColectivoOGA) return false;
    const requiereSubcuenta = (programaSel.subcuentasDisponibles?.length ?? 0) > 0;
    return requiereSubcuenta && !programaSel.subcuenta;
  }

  /**
   * Mensaje de hint (azul) debajo del select de tarifa.
   * Colectivo (C) se deja sin hint (NC0070: ese flujo ya funciona).
   * En GA, si valores no trae filas, se informa al asesor.
   */
  getTarifaHintMessage(programaSel: ProgramaSeleccionado): string | null {
    if (this.esFlujoColectivoOGA && !this.esFlujoGruposAfinidad) return null;
    if (this.esFlujoGruposAfinidad) {
      const requiereSubcuenta = (programaSel?.subcuentasDisponibles?.length ?? 0) > 0;
      if (requiereSubcuenta && !programaSel?.subcuenta) return 'Seleccione primero una subcuenta';
      if (programaSel?.tarifasConsultaRealizada && (programaSel?.tarifasDisponibles?.length ?? 0) === 0) {
        return 'No existen valores de tarifas para la subcuenta seleccionada';
      }
      return null;
    }
    if (this.isTarifaBloqueadaPorInclusion(programaSel)) {
      return 'Tarifa definida por el programa de inclusión (no modificable).';
    }
    if (programaSel.tarifasConsultaRealizada && (programaSel.tarifasDisponibles?.length ?? 0) === 0) {
      if (programaSel.tarifasLegacyConDatos && !programaSel.tarifasValoresConDatos) {
        return 'No se encontraron valores de tarifas para los programas disponibles';
      }
      return 'No se encontraron tarifas disponibles para este programa.';
    }
    return null;
  }

  /** Construye el request para consultar-campanas-nuevo desde localStorage y programaSel. */
  private buildCampaniaRequestFor(programaSel: ProgramaSeleccionado): any {
    const programa = this.programasDisponibles.find(p => p.id === programaSel.id);
    if (!programa) return null;
    const datosStr = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
    if (!datosStr) return null;
    let datosContratante: any;
    try {
      datosContratante = JSON.parse(datosStr);
    } catch {
      return null;
    }
    const edad = Number(datosContratante?.edad ?? 0).toString();
    const sexoRaw = (datosContratante?.genero ?? 'M').toString().trim().toUpperCase();
    const sexo = sexoRaw === 'F' || sexoRaw.slice(0, 1) === 'F' || sexoRaw === '2' ? 'F' : 'M';
    const tipoPlan = this.getTipoPlanActual();
    const lineaNegocioNumero = this.mapLineaToNumber(programa.lineaNegocio);
    if (!lineaNegocioNumero) return null;

    const denoTxt = (programaSel.subcuenta || '').toString().trim();
    const esColectivo = tipoPlan === 'C' || tipoPlan === 'GA' || tipoPlan === 'AG' || tipoPlan.includes('COLECTIV') || tipoPlan.includes('AFINIDAD');
    const cuenta = esColectivo ? (
      this.cuentaColectivoGA != null && Number.isFinite(this.cuentaColectivoGA) && this.cuentaColectivoGA > 0 ? String(this.cuentaColectivoGA) : '1'
    ) : this.getCuentaNoColectivoPorTipoPlan();

    let subcuentaFinal = esColectivo ? (this.mapaDenoASubctaPorPrograma.get(programaSel.id)?.get(denoTxt) || '') : '';

    if (!subcuentaFinal) {
      const subctaPasada = ((programaSel as any).__subctaCodeSeleccionada || programaSel.subcuenta || '').toString().trim().toUpperCase();
      const subcuentasValidas = ['ASMP', 'EMSMP', 'FSMP', 'ASAO', 'FSAO', 'EMSAO', 'ACEMN', 'EMCMN', 'FCEMN'];

      if (subctaPasada && subcuentasValidas.includes(subctaPasada)) {
        subcuentaFinal = subctaPasada;
      } else {
        const planCodi = (programaSel.id || programa.codigo || '').toString().trim().toUpperCase();

        // 1. Identificar Línea de Negocio real por código del plan
        let linea = 'SMP';
        if (planCodi.startsWith('DE') || planCodi.includes('SAO') || planCodi.includes('SO')) {
          linea = 'SAO';
        } else if (planCodi.includes('CEM')) {
          linea = 'CEM';
        }

        //  Tipo de Plan (A, F, E)
        let tipo = 'F';
        if (tipoPlan === 'A' || tipoPlan === 'AS' || tipoPlan.includes('ASOCIADO')) tipo = 'A';
        else if (tipoPlan === 'E' || tipoPlan === 'EMP' || tipoPlan.includes('EMPLEADO')) tipo = 'E';

        const matrizSubcuentas: Record<string, Record<string, string>> = {
          'SMP': { 'A': 'ASMP', 'F': 'FSMP', 'E': 'EMSMP' },
          'SAO': { 'A': 'ASAO', 'F': 'FSAO', 'E': 'EMSAO' },
          'CEM': { 'A': 'ACEMN', 'F': 'FCEMN', 'E': 'EMCMN' }
        };
        subcuentaFinal = matrizSubcuentas[linea]?.[tipo] || 'FSMP';
      }
    }

    const planGrupo = esColectivo ? (this.mapaDenoAPlanGrupoPorPrograma.get(programaSel.id)?.get(denoTxt) || '').toString().trim() : '';
    const tarifaRaw = (programaSel.tarifa || '').toString().trim();
    const tarifaCodigo = tarifaRaw.match(/\(([^)]+)\)$/)?.[1]?.trim() || tarifaRaw;
    // Inclusión: igual que el beneficiario, getCampaniaCtz no filtra por tarifa.
    const vcCodTarifa = this.esFlujoInclusion ? '' : (tarifaCodigo || '');
    const uiPrograma = (programaSel.id || programa.codigo || '').trim();
    const vcPrograma = esColectivo
      ? this.resolverPlanCodiActivoAcParaCampania(uiPrograma, subcuentaFinal, cuenta)
      : uiPrograma;

    return {
      nu_pagina: '1',
      nu_tamanoPagina: '1000',
      vc_codigoCampana: '',
      vc_nombreComercial: '',
      vc_lineaNegocio: String(lineaNegocioNumero),
      vc_cuenta: cuenta,
      vc_subcuenta: subcuentaFinal, // Código homologado bajo la matriz core
      vc_grupoPrograma: esColectivo ? planGrupo : '',
      vc_programa: vcPrograma,
      vc_tipoPlan: tipoPlan,
      fe_inicioVig: '',
      fe_finVig: '',
      nu_acumulable: '',
      nu_debitoAuto: '',
      nu_prontoPago: '',
      vc_genero: sexo + ',A',
      vc_edad: edad,
      vc_parentesco: 'T',
      vc_cod_tarifa: vcCodTarifa
    };
  }

  private campaniaBooleanFromSN(value: unknown): boolean {
    const v = (value ?? '').toString().trim().toUpperCase();
    return v === 'S' || v === 'SI' || v === 'TRUE' || v === '1';
  }

  private campaniaSafeNumber(value: unknown, defaultValue = 0): number {
    const n = Number(value);
    return Number.isFinite(n) ? n : defaultValue;
  }

  private campaniaNormalizeDate(value: unknown): string {
    const raw = (value ?? '').toString().trim();
    if (!raw || raw.toUpperCase() === 'NULL') return '';

    const ymd = raw.match(/^(\d{4})[-\/](\d{2})[-\/](\d{2})$/);
    if (ymd) return `${ymd[1]}-${ymd[2]}-${ymd[3]}`;

    const dmy = raw.match(/^(\d{2})[-\/](\d{2})[-\/](\d{4})$/);
    if (dmy) return `${dmy[3]}-${dmy[2]}-${dmy[1]}`;

    if (/^\d{8}$/.test(raw)) {
      if (raw.startsWith('19') || raw.startsWith('20')) {
        return `${raw.slice(0, 4)}-${raw.slice(4, 6)}-${raw.slice(6, 8)}`;
      }
      return '';
    }

    if (/^\d+$/.test(raw)) return '';
    return raw;
  }

  private campaniaMesesMora(value: unknown): string {
    const raw = (value ?? '').toString().trim();
    if (!raw || raw.toLowerCase() === 'null') return '';
    return raw;
  }

  /** Mapea fila getCampaniaCtz → detalle (misma lógica que bucarCampa en beneficiario.service). */
  private mapCampaniaNuevoItemToDetalle(it: CampaniaNuevoItem | Record<string, unknown>): CampaniaDetalleItem {
    const row = it as Record<string, unknown>;
    const nombre = (row['NOMBRE_CAMPANIA'] ?? '').toString().trim();
    return {
      modalidad: (row['MODALIDAD'] ?? '').toString().trim(),
      nombre,
      tarifa: (row['TARIFA'] ?? '').toString().trim(),
      descripcionTarifa: nombre,
      cuenta: this.campaniaSafeNumber(row['CUENTA'], 0),
      subcuenta: (row['SUBCUENTA'] ?? '').toString().trim(),
      codigo_campania: (row['COD_CAMP_COMERCIAL'] ?? '').toString().trim(),
      tipo_campania: (row['TIPO_CAMPANIA'] ?? '').toString().trim(),
      solo_nuevos: (row['SOLO_NUEVOS'] ?? '').toString().trim(),
      ingresa_moroso: (row['INGRESA_MOROSO'] ?? '').toString().trim(),
      meses_mora_permitidos: this.campaniaMesesMora(row['MESES_MORA_PERMITIDOS']),
      bonifica_moroso: (row['BONIFICA_MOROSO'] ?? '').toString().trim(),
      id_campania: this.campaniaSafeNumber(row['ID_CAMPANIA'], 0),
      linea_negocio: (row['LINEA_NEGOCIO'] ?? '').toString().trim(),
      grupo_programa: (row['GRUPO_PROGRAMA'] ?? '').toString().trim(),
      programa: (row['PROGRAMA'] ?? '').toString().trim(),
      tipo_plan: (row['TIPO_PLAN'] ?? '').toString().trim(),
      parentesco: (row['PARENTESCO'] ?? '').toString().trim(),
      edad_desde: this.campaniaSafeNumber(row['EDAD_DESDE'], 0),
      edad_hasta: this.campaniaSafeNumber(row['EDAD_HASTA'], 0),
      cant_benef_desde: this.campaniaSafeNumber(row['CANT_BENEF_DESDE'], 0),
      cant_benef_hasta: this.campaniaSafeNumber(row['CANT_BENEF_HASTA'], 0),
      acumulable: this.campaniaBooleanFromSN(row['ACUMULABLE']),
      pago_debito_auto: this.campaniaBooleanFromSN(row['PAGO_DEBITO_AUTO']),
      aplica_pronto_pago: this.campaniaBooleanFromSN(row['APLICA_PRONTO_PAGO']),
      observaciones: (row['OBSERVACIONES'] ?? '').toString().trim(),
      usuario_actualizacion: '',
      inicio_vigencia: this.campaniaNormalizeDate(row['INICIO_VIGENCIA']),
      fin_vigencia: this.campaniaNormalizeDate(row['FIN_VIGENCIA']),
      estado: this.campaniaBooleanFromSN(row['ESTADO']),
      genero: (row['GENERO'] ?? '').toString().trim()
    };
  }

  /**
   * Carga campañas desde el servicio para un programa (al cambiar subcuenta).
   */
  cargarCampaniasParaPrograma(programaSel: ProgramaSeleccionado): void {
    const request = this.buildCampaniaRequestFor(programaSel);
    if (!request) {
      programaSel.campaniasDisponibles = [];
      programaSel.campaniasConsultaRealizada = true;
      this.actualizarProgramasContratanteLocalStorage();
      return;
    }
    this.consultarCampanasNuevoService.consultarCampanas(request).subscribe({
      next: (resp) => {
        const rows = resp?.status && Array.isArray(resp?.data?.jsonRespuesta) ? resp.data!.jsonRespuesta! : [];
        // const data: CampaniaDetalleItem[] = rows.map((it: CampaniaNuevoItem) =>
        //   this.mapCampaniaNuevoItemToDetalle(it)
        // );

        const data: CampaniaDetalleItem[] = rows.map((it: CampaniaNuevoItem) => {
          const mapped = this.mapCampaniaNuevoItemToDetalle(it);

          if (this.esFlujoInclusion) {
            const raw = it as any;

            mapped.inicio_vigencia = raw.INICIO_VIGENCIA || raw.inicio_vigencia || mapped.inicio_vigencia;
            mapped.fin_vigencia = raw.FIN_VIGENCIA || raw.fin_vigencia || mapped.fin_vigencia;

            (mapped as any).codigo_campania = raw.COD_CAMP_COMERCIAL || raw.codigo_campania || (mapped as any).codigo_campania;
            (mapped as any).codigoCampania = raw.COD_CAMP_COMERCIAL || raw.codigoCampania || (mapped as any).codigoCampania;
            (mapped as any).codCampComercial = raw.COD_CAMP_COMERCIAL || raw.codCampComercial || (mapped as any).codCampComercial;
            (mapped as any).nombre = raw.NOMBRE_CAMPANIA || raw.nombre || (mapped as any).nombre;
          }

          return mapped;
        });

        programaSel.campaniasDisponibles = data;
        programaSel.campaniasConsultaRealizada = true;
        this.aplicarCampanaInclusionSiAplica(programaSel);
        // Rehidratación VN/colectivo/edición: si ya había campaña guardada, mantenerla si sigue en el catálogo.
        let campanaPrev = (programaSel.campana || '').toString().trim();
        if (campanaPrev.toLowerCase() === 'null') {
          campanaPrev = '';
          programaSel.campana = '';
        }
        if (data.length === 1) {
          const unica = data[0];
          programaSel.campana = (unica.codigo_campania || (unica as any).codigoCampania || '').toString().trim();
        } else if (campanaPrev && data.length) {
          const hit = data.find((c: any) => {
            const cod = (c?.codigo_campania || c?.codigoCampania || c?.codCampComercial || '').toString().trim();
            const nom = (c?.nombre || '').toString().trim();
            return cod === campanaPrev || nom === campanaPrev
              || cod.toUpperCase() === campanaPrev.toUpperCase()
              || nom.toUpperCase() === campanaPrev.toUpperCase();
          });
          if (hit) {
            programaSel.campana = (hit.codigo_campania || (hit as any).codigoCampania || campanaPrev).toString().trim();
          }
        }
        this.actualizarProgramasContratanteLocalStorage();
      },
      error: () => {
        programaSel.campaniasDisponibles = [];
        programaSel.campaniasConsultaRealizada = true;
        this.actualizarProgramasContratanteLocalStorage();
      }
    });
  }

  /**
   * Deshabilita el select de campaña si requiere subcuenta y no está elegida, o si la consulta devolvió sin campañas.
   */
  isCampanaSelectDisabled(programaSel: ProgramaSeleccionado): boolean {
    if (!this.esFlujoColectivoOGA) return false;
    const requiereSubcuenta = (programaSel.subcuentasDisponibles?.length ?? 0) > 0;
    return requiereSubcuenta && !programaSel.subcuenta;
  }

  /**
   * Mensaje de hint debajo del select de campaña.
   * C/GA: subcuenta y mensaje si no hay campañas para la subcuenta.
   * Individual e inclusión: mismo criterio que tarifas (sin mencionar subcuenta).
   */
  getCampanaHintMessage(programaSel: ProgramaSeleccionado): string | null {
    if (this.isCampanaBloqueadaPorInclusion(programaSel)) {
      return 'Campaña definida por el programa de inclusión (no modificable).';
    }
    if (this.esFlujoColectivoOGA) {
      const requiereSubcuenta = (programaSel.subcuentasDisponibles?.length ?? 0) > 0;
      if (requiereSubcuenta && !programaSel.subcuenta) return 'Seleccione primero una subcuenta';
      if (programaSel.campaniasConsultaRealizada && (programaSel.campaniasDisponibles?.length ?? 0) === 0) {
        return 'No se encontraron campañas para la subcuenta seleccionada';
      }
      return null;
    }
    if (programaSel.campaniasConsultaRealizada && (programaSel.campaniasDisponibles?.length ?? 0) === 0) {
      return 'No se encontraron campañas disponibles para este programa.';
    }
    return null;
  }

  private getCampaniaSeleccionada(programaSel: ProgramaSeleccionado): CampaniaDetalleItem | null {
    if (!programaSel?.campana) return null;
    return programaSel.campaniasDisponibles?.find(
      c => (c.codigo_campania || '').trim() === (programaSel.campana || '').trim()
    ) ?? null;
  }

  private normalizarValorTooltip(value: unknown): string {
    const raw = (value ?? '').toString().trim();
    if (!raw || raw.toLowerCase() === 'null' || raw.toLowerCase() === 'undefined') return 'N/A';
    return raw;
  }

  private formatSN(value: unknown): string {
    const v = this.normalizarValorTooltip(value).toUpperCase();
    if (v === 'S') return 'Si';
    if (v === 'N') return 'No';
    return v;
  }

  getCampaniaTooltip(programaSel: ProgramaSeleccionado): string {
    const c = this.getCampaniaSeleccionada(programaSel);
    if (!c) return 'Seleccione una campaña para ver observaciones.';
    return this.normalizarValorTooltip(c.observaciones);
  }

  /**
   * Carga los programas disponibles para el contratante
   * Este método ya no se usa directamente, los programas se cargan cuando se selecciona una línea
   * Se mantiene por compatibilidad pero ahora está vacío
   */
  cargarProgramasDisponibles(): void {
    // Los programas se cargan dinámicamente cuando se selecciona una línea de negocio
    // Ver método cargarProgramasPorLinea()
  }

  /**
   * Cargar programas completos (con carnets) para una línea de negocio específica
   * El servicio maneja el caché automáticamente
   * @param onCargado Callback opcional cuando terminó la carga (para sincronizar precarga desde localStorage).
   */
  cargarProgramasPorLinea(lineaCodigo: number, codigoLinea: 'MI' | 'SO' | 'CEM', onCargado?: () => void): void {
    // En flujo C/GA/AG no se deben cargar programas adicionales por línea.
    // En inclusión, igual.
    // Solo se muestran los precargados/permitidos por el colectivo.
    if (this.esFlujoColectivoOGA || this.esFlujoInclusion) {
      onCargado?.();
      return;
    }
    if (this.ocultarLineasNoMiVentaNueva && codigoLinea !== 'MI') {
      onCargado?.();
      return;
    }

    // Verificar si ya tenemos los programas cargados en programasDisponibles
    const programasExistentes = this.programasDisponibles.filter(p => p.lineaNegocio === codigoLinea);

    if (programasExistentes.length > 0) {
      onCargado?.();
      return;
    }

    // Si no están en memoria, cargar desde el servicio (que usará caché si está disponible)
    this.spinner.show();

    // Nuevo
    let tipoPlanActual = this.getTipoPlanActual();

    if (tipoPlanActual === 'NULL' || tipoPlanActual === 'UNDEFINED' || tipoPlanActual === '') {
      tipoPlanActual = 'C';
    }

    this.consultarLineasService.consultarProgramasCompletosPorParametroPorLinea(lineaCodigo, false, tipoPlanActual, this.obtenerEdadContratante()).subscribe({ // Nuevo
      next: (response) => {
        // Procesar los grupos y programas recibidos
        const nuevosProgramas: Programa[] = [];

        response.grupos.forEach(grupo => {
          grupo.programas.forEach(programaCompleto => {
            // Mapear a la estructura de Programa
            const programa: Programa = {
              id: programaCompleto.codigo.trim(),
              codigo: programaCompleto.codigo.trim(),
              nombre: programaCompleto.programa,
              lineaNegocio: codigoLinea,
              color: this.obtenerColorPorLinea(codigoLinea),
              imagen: programaCompleto.carnet?.file, // Imagen base64 del carnet
              carnet: programaCompleto.carnet?.file,
              //imagen: programaCompleto.carnet?.file ? 'data:image/png;base64,' + programaCompleto.carnet.file : undefined, // Nuevo
              //carnet: programaCompleto.carnet?.file ? 'data:image/png;base64,' + programaCompleto.carnet.file : undefined, // Nuevo
              grupoPrograma: grupo.codigo
            };

            nuevosProgramas.push(programa);
          });
        });

        // Agregar los nuevos programas a los disponibles (filtrar duplicados por id)
        const codigosExistentes = new Set(this.programasDisponibles.map(p => p.id));
        const programasNuevos = nuevosProgramas.filter(p => !codigosExistentes.has(p.id));
        this.programasDisponibles = [...this.programasDisponibles, ...programasNuevos];

        this.spinner.hide();
        onCargado?.();
      },
      error: (error) => {
        console.error('Error al cargar programas por línea:', error);
        this.spinner.hide();
        onCargado?.();
      }
    });
  }

  /**
   * Precarga visual (F/A/EM):
   * - Obtiene programas del contratante por idCotizacion (GET)
   * - Carga catálogo por línea solo para conservar imagen del carnet
   * - Filtra el grid para mostrar únicamente los programas precargados
   * - No modifica subcuentas/tarifas/campañas (UI abajo se oculta en precarga)
   */
  private cargarProgramasPrecargadosVisualFAEM(): void {
    const idCotizacion = this.getIdCotizacionEnCurso();
    if (!idCotizacion) return;

    this.programasDisponibles = [];
    this.programasSeleccionados = [];
    this.lineasSeleccionadas = [];
    this.idsProgramasPrecargadosVisual = new Set();
    this.coberturaCemValida = false;

    this.consultarProgramasContratanteService.consultarProgramasContratante(idCotizacion).subscribe({
      next: (resp) => {
        const items: ConsultarProgramasContratanteItem[] = resp?.data ?? [];
        if (items.length === 0) return;

        const ids = items.map(i => (i?.programa ?? '').toString().trim()).filter(Boolean);
        this.idsProgramasPrecargadosVisual = new Set(ids);

        const lineas = [...new Set(
          items.map(i => this.lineaNegocioParaUI(i?.lineaNegocio)).filter(Boolean)
        )] as ('MI' | 'SO' | 'CEM')[];
        this.lineasSeleccionadas = [...lineas];

        // Si viene CEM en la precarga, marcamos como válida para permitir guardar si por error se invoca.
        this.coberturaCemValida = items.some(i => this.lineaNegocioParaUI(i?.lineaNegocio) === 'CEM');

        // Preselección visual para overlay (lo de abajo se oculta)
        this.programasSeleccionados = items.map(i => {
          const id = (i?.programa ?? '').toString().trim();
          return {
            id,
            nombre: id,
            subcuenta: '',
            tarifa: '',
            campana: '',
            anexoCodigo: '',
            tarifaAnexo: '',
            nombreAnexo: '',
            requiereAnexo: null,
            anexosDisponibles: [],
            subcuentasDisponibles: [],
            subcuentasConsultaRealizada: false,
            tarifasDisponibles: [],
            tarifasConsultaRealizada: false,
            campaniasDisponibles: [],
            campaniasConsultaRealizada: false
          } as ProgramaSeleccionado;
        });

        // Mostrar tab de programas
        if (!this.procesoBloqueadoPorHistorial) {
          this.tabSeleccionadoIndex = 1;
        }

        // Cargar catálogo por línea para conservar imágenes/carnets en el grid
        let pending = lineas.length;
        if (pending === 0) return;

        const checkDone = () => {
          pending--;
          // sin-op: cuando termine, el getter ya filtrará por ids
        };

        lineas.forEach(linea => {
          const lineaDisponible = this.lineasNegocioDisponibles.find(l => l.codigo === linea);
          const cod = lineaDisponible?.lineaOriginal?.cod;
          if (cod != null) {
            this.cargarProgramasPorLinea(Number(cod), linea, checkDone);
          } else {
            checkDone();
          }
        });
      },
      error: () => { }
    });
  }

  /**
   * Precarga editable (F/A/EM):
   * - Obtiene programas del contratante por idCotizacion (GET)
   * - Carga catálogo por línea para conservar imágenes/carnets
   * - Preselecciona programas ya guardados, pero mantiene UI editable
   */
  private cargarProgramasPrecargadosEditableFAEM(): void {
    const idCotizacion = this.getIdCotizacionEnCurso();
    if (!idCotizacion) return;

    this.traceAnexo('precarga editable FAEM: consultando BD', {
      idCotizacion,
      storeAntes: this.resumenAnexoEnStore(),
      cotizacion_precargada: (() => {
        try {
          return JSON.parse(localStorage.getItem(this.KEY_COTIZACION_PRECARGADA) || 'null');
        } catch { return null; }
      })(),
    });

    this.consultarProgramasContratanteService.consultarProgramasContratante(idCotizacion).subscribe({
      next: (resp) => {
        const items: ConsultarProgramasContratanteItem[] = resp?.data ?? [];
        if (items.length === 0) {
          this.traceAnexo('precarga editable FAEM: BD vacía → fallback LS');
          this.intentarPrecargarProgramasDesdeLocalStorage();
          return;
        }

        this.traceAnexo('precarga editable FAEM: BD devolvió programas (SIN anexo) → aplicarPreseleccion', {
          cantidad: items.length,
          programas: items.map(i => i.programa),
        });

        const lineas = [...new Set(
          items.map(i => this.lineaNegocioParaUI(i?.lineaNegocio)).filter(Boolean)
        )] as ('MI' | 'SO' | 'CEM')[];
        if (lineas.length === 0) {
          this.intentarPrecargarProgramasDesdeLocalStorage();
          return;
        }

        this.lineasSeleccionadas = [...lineas];
        if (!this.procesoBloqueadoPorHistorial) {
          this.tabSeleccionadoIndex = 1;
        }

        const detallesDesdeEdicion = Array.isArray(this.data?.programasContratantePersistidos)
          ? this.data.programasContratantePersistidos
          : [];
        const detallesLocalesCoincidentes = this.programaSeleccionStore.cargarParaCotizacion(
          idCotizacion,
          (this.numeroDocumento || '').trim()
        ) ?? [];
        const detallesPersistidos = detallesDesdeEdicion.length > 0
          ? detallesDesdeEdicion
          : detallesLocalesCoincidentes;
        const detallePorPrograma = new Map<string, any>();
        detallesPersistidos.forEach((detalle: any) => {
          const codigo = (detalle?.programa ?? detalle?.id ?? detalle?.codigo ?? detalle?.code ?? '')
            .toString()
            .trim()
            .toUpperCase();
          if (codigo) detallePorPrograma.set(codigo, detalle);
        });

        // consultar-programas-contratante confirma qué programas siguen en BD,
        // pero solo retorna línea y código. Enriquecerlos con la configuración
        // de iniciar-edicion conserva tarifa, campaña y anexos seleccionados.
        const payloadPrecarga = items.map(i => {
          const programa = (i?.programa ?? '').toString().trim();
          const detalle = detallePorPrograma.get(programa.toUpperCase()) ?? {};
          return {
            ...(i as any),
            ...detalle,
            lineaNegocio: this.lineaNegocioParaUI(i?.lineaNegocio)
              || this.lineaNegocioParaUI(detalle?.lineaNegocio),
            programa
          };
        });

        let pending = lineas.length;
        const checkDone = () => {
          pending--;
          if (pending === 0) {
            this.aplicarPreseleccionProgramas(payloadPrecarga);
          }
        };

        lineas.forEach(linea => {
          const lineaDisponible = this.lineasNegocioDisponibles.find(l => l.codigo === linea);
          const cod = lineaDisponible?.lineaOriginal?.cod;
          if (cod != null) {
            this.cargarProgramasPorLinea(Number(cod), linea, checkDone);
          } else {
            checkDone();
          }
        });
      },
      error: () => {
        this.intentarPrecargarProgramasDesdeLocalStorage();
      }
    });
  }

  /**
   * Intenta precargar la selección de programas desde programas_contratante (localStorage).
   * Se ejecuta después de cargar las líneas; carga programas por línea y luego aplica la preselección.
   */
  private intentarPrecargarProgramasDesdeLocalStorage(): void {

    if (this.esFlujoInclusion) {
      const raw = localStorage.getItem(this.KEY_PROGRAMAS_CONTRATANTE);
      if (!raw) return;
      let payload: any[];
      try {
        payload = JSON.parse(raw);
      } catch (_) { return; }

      if (!Array.isArray(payload) || payload.length === 0) return;

      const lineas = [...new Set(
        payload.map((p: any) => this.lineaNegocioParaUI(p.lineaNegocio)).filter(Boolean)
      )] as ('MI' | 'SO' | 'CEM')[];
      if (lineas.length === 0) return;

      let pending = lineas.length;
      const checkDone = () => {
        pending--;
        if (pending === 0) {
          this.aplicarPreseleccionProgramas(payload);
        }
      };

      lineas.forEach(l => (this as any).cargarProgramasPorLinea(this.mapLineaToNumber(l as any), checkDone));
      return;
    }

    const idCotizacionActual = this.getIdCotizacionEnCurso();
    const docActual = (this.numeroDocumento || '').trim();

    if (!idCotizacionActual) {
      this.traceAnexo('precarga LS: abort (sin idCotizacion)', { docActual });
      return;
    }

    let programasGuardados = this.programaSeleccionStore.cargarParaCotizacion(
      idCotizacionActual,
      docActual
    );

    // Fallback: tras la flecha a veces queda array plano (legacy) o envelope sin match estricto.
    // Sin esto el modal abre vacío aunque programas_contratante tenga Oro/Plata.
    if (!programasGuardados) {
      programasGuardados = this.leerProgramasContratanteFallbackPrecarga(idCotizacionActual, docActual);
    }

    if (!programasGuardados) {
      this.traceAnexo('precarga LS: abort (store sin match id/doc)', {
        idCotizacionActual,
        docActual,
        storeRaw: this.resumenAnexoEnStore(),
      });
      return;
    }

    this.traceAnexo('precarga LS: OK', {
      idCotizacion: idCotizacionActual,
      programas: programasGuardados.map(p => ({
        programa: p.programa,
        anexoCodigo: p.anexoCodigo,
        tieneAnexoDetalle: !!p.anexoDetalle,
      })),
    });

    // Convertir ProgramaItemStore al formato que consume aplicarPreseleccionProgramas
    const payloadLegacy = programasGuardados.map((item: ProgramaItemStore) => ({
      lineaNegocio: item.lineaNegocio,
      programa: item.programa,
      nombrePrograma: item.nombrePrograma,
      grupoPrograma:
      item.grupoPrograma ??
      item.grupo ??
      '',
      grupo:
      item.grupoPrograma ??
      item.grupo ??
      '',
      subcuenta: item.subcuenta,
      tarifa: item.tarifa,
      nombreTarifa: item.tarifaDetalle?.nombreTarifa ?? '',
      campana: item.campana,
      campanaNombre: item.campaniaDetalle?.nombreCampania ?? '',
      anexoCodigo: item.anexoCodigo,
      tarifaAnexo: item.anexoDetalle ? String(item.anexoDetalle.valorMensualIva ?? '') : '',
      nombreAnexo: item.anexoDetalle?.nombreTarifa ?? '',
      requiereAnexo: item.requiereAnexo,
      coberturaValida: item.coberturaValida,
    }));

    const lineas = [...new Set(
      payloadLegacy.map((p: any) => this.lineaNegocioParaUI(p.lineaNegocio)).filter(Boolean)
    )] as ('MI' | 'SO' | 'CEM')[];
    if (lineas.length === 0) return;

    this.lineasSeleccionadas = [...lineas];
    let pending = lineas.length;
    const checkDone = () => {
      pending--;
      if (pending === 0) {
        this.aplicarPreseleccionProgramas(payloadLegacy);
      }
    };

    lineas.forEach(linea => {
      const lineaDisponible = this.lineasNegocioDisponibles.find(l => l.codigo === linea);
      const cod = lineaDisponible?.lineaOriginal?.cod;
      if (cod != null) {
        this.cargarProgramasPorLinea(cod, linea, checkDone);
      } else {
        checkDone();
      }
    });
  }

  /**
   * Lee programas_contratante aunque venga como array plano o envelope parcial,
   * para no perder la preselección al reabrir Consultar tras la flecha.
   */
  private leerProgramasContratanteFallbackPrecarga(
    idCotizacionActual: number,
    docActual: string
  ): ProgramaItemStore[] | null {
    try {
      const raw = localStorage.getItem(this.KEY_PROGRAMAS_CONTRATANTE);
      if (!raw) return null;
      const parsed = JSON.parse(raw);

      let items: any[] = [];
      if (Array.isArray(parsed)) {
        items = parsed;
      } else if (parsed && typeof parsed === 'object' && Array.isArray(parsed.programas)) {
        const idGuardado = Number(parsed.idCotizacion || 0);
        const docGuardado = (parsed.numeroDocumento || '').toString().trim();
        const idOk = !(idGuardado > 0) || idGuardado === Number(idCotizacionActual);
        const docOk = !docGuardado || !docActual || docGuardado === docActual;
        if (!idOk || !docOk) return null;
        items = parsed.programas;
      }

      const normalizados = (items || [])
        .map((p: any) => ({
          ...p,
          programa: (p?.programa || p?.id || '').toString().trim(),
          lineaNegocio: (p?.lineaNegocio || '').toString().trim(),
          nombrePrograma: (p?.nombrePrograma || p?.nombre || '').toString().trim(),
          grupoPrograma: (
            p?.grupoPrograma ??
            p?.grupo ??
            ''
          ).toString().trim()
        }))
        .filter((p: any) => !!p.programa);

      return normalizados.length ? (normalizados as ProgramaItemStore[]) : null;
    } catch {
      return null;
    }
  }

  /**
   * Aplica la preselección: arma programasSeleccionados desde el payload de programas_contratante
   * y restaura coberturaCemValida si hay CEM. Carga subcuentas y tarifas para cada programa.
   * En flujo C/GA la preselección ya se hizo en cargarProgramasYPreseleccionColectivoGA.
   */
  private aplicarPreseleccionProgramas(payload: any[]): void {
    if (this.esFlujoColectivoOGA) return;
    const tieneCemConCobertura = payload.some(
      (p: any) => this.lineaNegocioParaUI(p.lineaNegocio) === 'CEM' && p.coberturaValida === true
    );
    if (tieneCemConCobertura) {
      this.coberturaCemValida = true;
    }

    this.programasSeleccionados = [];
    payload.forEach((item: any) => {
      const linea = this.lineaNegocioParaUI(item.lineaNegocio);
      const codigoPrograma = (item.programa || '').trim();
      if (!linea || !codigoPrograma) return;

      const programa = this.programasDisponibles.find(
        p => p.lineaNegocio === linea && (p.codigo || p.id || '').trim() === codigoPrograma
      );
      if (!programa) return;

      const programaSel: ProgramaSeleccionado = {
        id: programa.id,
        nombre: programa.nombre,
        subcuenta: (item.subcuenta || '').trim(),
        tarifa: (item.tarifa || '').trim(),
        campana: (item.campana || '').trim(),
        anexoCodigo: (item.anexoCodigo || '').trim(),
        tarifaAnexo: (item.tarifaAnexo || '').trim(),
        nombreAnexo: (item.nombreAnexo || '').trim(),
        requiereAnexo: null,
        anexosDisponibles: [],
        subcuentasDisponibles: [],
        subcuentasConsultaRealizada: false,
        tarifasDisponibles: [],
        tarifasConsultaRealizada: false,
        campaniasDisponibles: [],
        campaniasConsultaRealizada: false
      };
      const reqAnexoGuardado = item.requiereAnexo ?? item.requiereAnexoTESA;
      if (reqAnexoGuardado === 'si' || reqAnexoGuardado === 'no') {
        programaSel.requiereAnexo = reqAnexoGuardado;
      } else if ((item.anexoCodigo || '').trim()) {
        programaSel.requiereAnexo = 'si';
      }
      this.programasSeleccionados.push(programaSel);

      const codigo = programa.codigo.trim();
      if (!this.esFlujoColectivoOGA) {
        this.cargarTarifasParaPrograma(programaSel);
        this.cargarCampaniasParaPrograma(programaSel);
        this.consultarAnexosPrograma(programaSel);
        return;
      }

      this.consultarSubcuentasService.consultarSubcuentas(codigo).subscribe({
        next: (response) => {
          const sel = this.programasSeleccionados.find(p => p.id === programa.id);
          if (!sel) return;
          if (response.status && response.data?.jsonRespuesta?.length > 0) {
            this.procesarSubcuentasRespuesta(sel, codigo, response.data.jsonRespuesta);
          } else {
            this.marcarSubcuentasConsultaSinResultados(sel);
          }
          this.cargarTarifasParaPrograma(sel);
          this.cargarCampaniasParaPrograma(sel);
          if (sel.requiereAnexo === 'si') {
            this.consultarAnexosPrograma(sel);
          }
        },
        error: () => {
          const sel = this.programasSeleccionados.find(p => p.id === programa.id);
          if (sel) {
            this.marcarSubcuentasConsultaSinResultados(sel);
          }
        }
      });
    });
  }

  /**
   * Método auxiliar para obtener color por línea de negocio
   */
  private obtenerColorPorLinea(linea: 'MI' | 'SO' | 'CEM'): string {
    const colores: { [key: string]: string } = {
      'MI': 'linear-gradient(135deg, #4a90e2 0%, #357abd 100%)',
      'SO': 'linear-gradient(135deg, #00bfff 0%, #1e90ff 100%)',
      'CEM': 'linear-gradient(135deg, #0372b9 0%, #025a8f 100%)'
    };
    return colores[linea] || colores['MI'];
  }

  /**
   * Crea la cotización en BD (primera vez, sin idCotizacion), persiste el response en localStorage y ejecuta onSuccess.
   * Si falla, muestra popup de error y llama onError.
   */
  private guardarCotizacionEnBD(
    validacionesPayload: { items: ItemValidacion[] },
    onSuccess: () => void,
    onError: (err: unknown) => void
  ): void {
    const datosStr = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
    const tipoSolicitud = localStorage.getItem(this.KEY_TIPO_SOLICITUD) ?? '1';
    const tipoPlan = localStorage.getItem(this.KEY_TIPO_PLAN) ?? 'F';
    if (!datosStr) {
      onError(new Error('No se encontraron datos del contratante'));
      return;
    }
    let datosContratante: any;
    try {
      datosContratante = JSON.parse(datosStr);
    } catch {
      onError(new Error('Datos del contratante inválidos'));
      return;
    }
    const request = this.crearCotizacionContratanteService.buildRequestFromStorage(
      datosContratante,
      validacionesPayload,
      tipoSolicitud,
      tipoPlan
    );
    this.crearCotizacionContratanteService.crearDesdePasoContratante(request).subscribe({
      next: (response) => {
        const data = (response as any)?.data;
        const id = Number(data?.idCotizacion);
        const idContratante = Number(data?.idContratante);
        this.idCotizacionActual = Number.isFinite(id) && id > 0 ? id : this.idCotizacionActual;
        // Normalizar ids en raíz y en data: el update lee ambos paths.
        const guardado = {
          ...response,
          idCotizacion: Number.isFinite(id) && id > 0 ? id : undefined,
          idContratante: Number.isFinite(idContratante) && idContratante > 0 ? idContratante : undefined,
          idsValidaciones: Array.isArray(data?.idsValidaciones) ? data.idsValidaciones : undefined,
          tipoDocumento: this.tipoDocumento,
          numeroDocumento: this.numeroDocumento
        };
        localStorage.setItem(KEY_COTIZACION_CREADA_DESDE_CONTRATANTE, JSON.stringify(guardado));
        // Visita activa: bloqueo de documento solo mientras exista esta flag (muere con F5).
        sessionStorage.setItem(KEY_COTIZACION_CONTRATANTE_SESION_ACTIVA, '1');
        // Cotización nueva: no reutilizar beneficiarios locales de una cotización anterior.
        localStorage.removeItem('datosRQ003_Beneficiarios');
        localStorage.removeItem('datosRQ003_Beneficiario');
        localStorage.removeItem('programas_beneficiario');
        // Actualizar cotizacion_precargada también para que cotizacionGuardadaEnModalParaDocumentoActual() lo encuentre
        this.actualizarContextoCotizacionPrecargada({
          precargada: false,
          idCotizacion: id,
          tipoDocumento: this.tipoDocumento,
          numeroDocumento: this.numeroDocumento,
          fecha: new Date().toISOString()
        });
        console.log('[GUARDAR] ✓ Nueva cotización creada y guardada en LS:', {
          idCotizacion: id,
          tipoDocumento: this.tipoDocumento,
          numeroDocumento: this.numeroDocumento
        });
        // Snapshot del formulario ya persistido en BD (evita update innecesario).
        this.cotizacionesIncompletasService.marcarDatosContratanteSincronizados(datosContratante);
        onSuccess();
      },
      error: (err) => onError(err)
    });
  }

  /**
   * Guardar (Tab Resultados). Persiste en validaciones_contratante todas las tarjetas visibles (ADRES + Historial).
   * Preserva bloquea_proceso en los ítems de historial si ya estaba guardado.
   * Si no hay idCotizacion, crea la cotización en BD y guarda el response en localStorage.
   */
  guardar(): void {
    if (this.esPrecargaVisualFAEM) return;
    const idContratante = this.numeroDocumento.trim();
    const items: ItemValidacion[] = [];

    let tieneBloqueoEnHistorial = false;
    try {
      const existing = localStorage.getItem(this.KEY_VALIDACIONES_CONTRATANTE);
      if (existing) {
        const parsed = JSON.parse(existing);
        if (Array.isArray(parsed?.items)) {
          tieneBloqueoEnHistorial = parsed.items.some((i: ItemValidacion) => i.bloquea_proceso === true);
        }
      }
    } catch (_) { }

    this.estadoEPS.forEach(t => {
      items.push({ fuente: 'ADRES', descripcion: t.mensaje, fechaEvento: '', tipo: t.tipo });
    });
    this.historialCliente.forEach(t => {
      items.push({
        fuente: 'Historial Afilmed',
        descripcion: t.mensaje,
        fechaEvento: '',
        tipo: t.tipo,
        ...(tieneBloqueoEnHistorial ? { bloquea_proceso: true } : {})
      });
    });
    this.condicionAsociado.forEach(c => {
      items.push({ fuente: 'Condición asociado', descripcion: c.mensaje, fechaEvento: '', tipo: c.tipo });
    });
    this.consultasPrevias.forEach(c => {
      items.push({ fuente: 'Consultas previas', descripcion: c.mensaje, fechaEvento: '', tipo: c.tipo });
    });

    const validacionesPayload: ValidacionesContratantePayload = {
      tipoDocumento: this.tipoDocumento?.trim() || '',
      idContratante,
      fechaConsulta: new Date().toISOString(),
      items
    };
    localStorage.setItem(this.KEY_VALIDACIONES_CONTRATANTE, JSON.stringify(validacionesPayload));

    const cerrarDialogoGuardar = (): void => {
      if (
        this.esEditModeActivo
        && this.esUsuario === true
        && this.data?.tieneProgramasContratantePersistidos !== true
      ) {
        // La cotización se creó desde Contratante, pero todavía no tiene la
        // cadena beneficiario/programa en BD. Mantener el modal abierto permite
        // completar esa selección sin perder el id de la edición.
        this.data.soloValidaciones = false;
        this.tabSeleccionadoIndex = 1;
        this.cdr.detectChanges();
        return;
      }
      this.dialogRef.close({
        accion: 'guardar',
        esUsuario: this.esUsuario,
        datosContratante: this.data.datosContratante,
        validaciones: {
          historialCliente: this.historialCliente,
          estadoEPS: this.estadoEPS
        }
      });
    };

    const idCotizacion = this.getIdCotizacionEnCurso();
    console.log('[GUARDAR] idCotizacion obtenido:', idCotizacion, '| esEditModeActivo:', this.esEditModeActivo);

    if (idCotizacion != null) {
      console.log('[GUARDAR] RAMA 1: Actualizando cotización existente ID:', idCotizacion);
      // Solo actualiza CotizacionContratante + validaciones si cambió el formulario.
      // No toca programas (viven en LS / se guardan en Beneficiario).
      this.cotizacionesIncompletasService
        .actualizarCotizacionIncompletaContratanteValidaciones(idCotizacion, validacionesPayload)
        .subscribe({
          next: () => {
            // Actualizar cotizacion_precargada para que cotizacionGuardadaEnModalParaDocumentoActual() 
            // encuentre la cotización persistida con el documento actual
            this.actualizarContextoCotizacionPrecargada({
              precargada: false,
              idCotizacion: idCotizacion,
              tipoDocumento: this.tipoDocumento,
              numeroDocumento: this.numeroDocumento,
              fecha: new Date().toISOString()
            });
            sessionStorage.setItem(KEY_COTIZACION_CONTRATANTE_SESION_ACTIVA, '1');
            console.log('[GUARDAR] ✓ Cotización actualizada en LS - cotizacion_precargada:', {
              idCotizacion,
              tipoDocumento: this.tipoDocumento,
              numeroDocumento: this.numeroDocumento
            });
            cerrarDialogoGuardar();
          },
          error: (err) => {
            console.error('[CONTRATANTE] Error al actualizar contratante/validaciones:', err);
            cerrarDialogoGuardar();
          }
        });
    } else if (this.esEditModeActivo) {
      console.log('[GUARDAR] RAMA 2: Edit mode sin idCotizacion, solo cerrando');
      // En editMode sin idCotizacion resolvible: NO crear nuevo registro, solo cerrar.
      cerrarDialogoGuardar();
    } else {
      console.log('[GUARDAR] RAMA 3: Creando nueva cotización en BD');
      this.spinner.show();
      this.guardarCotizacionEnBD(
        validacionesPayload,
        () => {
          this.spinner.hide();
          cerrarDialogoGuardar();
        },
        (err) => {
          this.spinner.hide();
          console.error('Error al crear cotización desde paso contratante:', err);
          this.dialog.open(PopUpMensajeComponent, {
            width: '500px',
            maxWidth: '90vw',
            disableClose: true,
            data: {
              titulo: 'Error',
              texto: (err instanceof Error ? err.message : 'No se pudo guardar la cotización en la base de datos. Intente de nuevo.'),
              tipoIcono: 'error',
              textoBoton: 'ACEPTAR'
            } as PopUpMensajeData
          });
        }
      );
    }
  }

  private extraerGrupoPrograma(origen: any): string {
    const grupo = (
      origen?.GRUPO_PROGRAMA ??
      origen?.grupo_programa ??
      origen?.grupoPrograma ??
      ''
    )
      .toString()
      .split('|')[0]
      .trim()
      .toUpperCase();

    return this.esLineaNegocioComoGrupo(grupo)
      ? ''
      : grupo;
  }

  private esLineaNegocioComoGrupo(valor: string): boolean {
    const grupo = (valor || '')
      .toString()
      .trim()
      .toUpperCase();

    return [
      '',
      'MI',
      'SO',
      'SAO',
      'CEM',
      '1',
      '2',
      '3'
    ].includes(grupo);
  }

  private resolverGrupoPrograma(
    ps: ProgramaSeleccionado,
    programa?: Programa
  ): string {
    const codigoPrograma = (
      programa?.codigo ||
      programa?.id ||
      ps.id ||
      ''
    )
      .toString()
      .trim()
      .toUpperCase();

    /*
    * Colectivo/GA: primero buscar el grupo asociado
    * a la subcuenta seleccionada.
    */
    if (this.esFlujoColectivoOGA && !this.esFlujoInclusion) {
      const denoSubcuenta = (ps.subcuenta || '')
        .toString()
        .trim();

      const mapaGrupo =
        this.mapaDenoAPlanGrupoPorPrograma.get(ps.id);

      const grupoDelMapa = (
        mapaGrupo?.get(denoSubcuenta) ||
        mapaGrupo?.get(denoSubcuenta.toUpperCase()) ||
        ''
      )
        .toString()
        .trim();

      const grupoMapaNormalizado =
        this.extraerGrupoPrograma({
          grupoPrograma: grupoDelMapa
        });

      if (grupoMapaNormalizado) {
        ps.grupoPrograma = grupoMapaNormalizado;

        if (programa) {
          programa.grupoPrograma =
            grupoMapaNormalizado;
        }

        return grupoMapaNormalizado;
      }

      const filaColectivo = (
        this.datosColectivoGA || []
      ).find((fila: any) => {
        const codigoFila = (
          fila?.plan_codi ??
          fila?.PLAN_CODI ??
          ''
        )
          .toString()
          .trim()
          .toUpperCase();

        const coincidePrograma = this.coincidePlanCodiAfinidad(
          codigoFila,
          codigoPrograma
        );

        return (
          coincidePrograma &&
          !!this.extraerGrupoPrograma(fila)
        );
      });

      const grupoColectivo =
        this.extraerGrupoPrograma(filaColectivo);

      if (grupoColectivo) {
        ps.grupoPrograma = grupoColectivo;

        if (programa) {
          programa.grupoPrograma =
            grupoColectivo;
        }

        return grupoColectivo;
      }
    }

    const grupoDelMapa =
      this.extraerGrupoPrograma({
        grupoPrograma:
          this.grupoProgramaPorCodigo.get(
            codigoPrograma
          )
      });

    if (grupoDelMapa) {
      return grupoDelMapa;
    }

    const tarifaConGrupo = (
      ps.tarifasDisponibles || []
    ).find(
      (tarifa: any) =>
        !!this.extraerGrupoPrograma(tarifa)
    );

    const candidatos = [
      this.extraerGrupoPrograma(tarifaConGrupo),
      this.extraerGrupoPrograma(ps),
      this.extraerGrupoPrograma(programa)
    ];

    return candidatos.find(grupo => !!grupo) || '';
  }

  private completarGruposProgramaAntesDeGuardar() {
    const pendientes = (this.programasSeleccionados || []).filter((ps) => {
      const base = this.programasDisponibles.find((p) => p.id === ps.id);
      return !this.resolverGrupoPrograma(ps, base);
    });
    if (!pendientes.length) {
      return of(undefined);
    }

    return forkJoin(pendientes.map((ps) => {
      const codigo = this.codigoProgramaParaGuardar(ps);
      if (!codigo) {
        return of(null);
      }
      return this.consultarCotizacionService.consultarGrupoProgramaXPrograma({ programa: codigo }).pipe(
        map((resp) => {
          const raw = (resp?.data?.jsonRespuesta?.[0]?.grupo_programa ?? '').toString();
          const grupo = this.extraerGrupoPrograma({ grupoPrograma: raw });
          if (!grupo) {
            return null;
          }
          ps.grupoPrograma = grupo;
          const base = this.programasDisponibles.find((p) => p.id === ps.id);
          if (base) {
            base.grupoPrograma = grupo;
          }
          this.grupoProgramaPorCodigo.set((ps.id || '').toString().trim().toUpperCase(), grupo);
          return grupo;
        }),
        catchError(() => of(null))
      );
    })).pipe(map(() => undefined));
  }

  /**
   * Guarda el contratante como beneficiario (titular) en BD y persiste programas,
   * subcuentas, tarifas (con valores) y campañas, siguiendo el mismo flujo que
   * guardarBeneficiarioYTodo del dialog-beneficiary.
   *
   * El spinner ya está activo cuando se llama este método; este método lo apaga al terminar.
   */
  private guardarContratanteComoBeneficiarioEnBD(
    idCotizacion: number,
    onOk: () => void,
    onError: (err: unknown) => void
  ): void {
    const normalizarClave = (value: unknown): string => (value ?? '').toString().trim().toUpperCase();

    const resolverCodigoPrograma = (ps: ProgramaSeleccionado): string => {
      const base = this.programasDisponibles.find(p => p.id === ps.id);
      return (base?.codigo || ps.id || '').toString().trim();
    };

    const resolverCodigoTarifaPrograma = (ps: ProgramaSeleccionado): string => {
      const tarifaRaw = (ps.tarifa || '').toString().trim();
      return ((ps as any).__tarifaCodigoLimpio || tarifaRaw.match(/\(([^)]+)\)$/)?.[1]?.trim() || tarifaRaw || '').toString().trim();
    };

    const resolverCodigoTarifaAnexo = (ps: ProgramaSeleccionado): string => {
      const codAnexoSel = (ps.anexoCodigo ?? '').toString().trim();
      if (!codAnexoSel) return '';
      const anexoDet = this.findAnexoEnOpciones(ps.anexosDisponibles || [], codAnexoSel);
      return (anexoDet?.tari ?? '').toString().trim();
    };

    const resolverCodigoCampania = (ps: ProgramaSeleccionado): string => {
      const codSelRaw = (ps.campana || '').toString().trim();
      const detSel = (ps.campaniasDisponibles || []).find(c => normalizarClave((c as any)?.codigo_campania) === normalizarClave(codSelRaw) || normalizarClave((c as any)?.nombre) === normalizarClave(codSelRaw));
      return ((detSel as any)?.codigo_campania || codSelRaw || '').toString().trim();
    };

    const hidratarIdsTarifaDesdeRespuesta = (response: any): void => {
      const data = response?.data;
      const items = Array.isArray(data) ? data : Array.isArray(data?.tarifas) ? data.tarifas : Array.isArray(data?.items) ? data.items : Array.isArray(data?.programas) ? data.programas.flatMap((p: any) => Array.isArray(p?.tarifas) ? p.tarifas.map((t: any) => ({ ...t, idBenPrograma: t?.idBenPrograma ?? p?.idBenPrograma })) : []) : data ? [data] : [];
      items.forEach((item: any) => {
        const idTarifa = Number(item?.idCotizacionTarifa ?? item?.id_cotizacion_tarifa ?? 0);
        if (!(idTarifa > 0)) return;
        const esAnexo = item?.esAnexo === true;
        const idBenProgramaItem = Number(item?.idBenPrograma ?? item?.id_ben_programa ?? 0);
        const hit = idBenProgramaItem > 0 ? this.programasSeleccionados.find(ps => Number((ps as any).__idBenPrograma || 0) === idBenProgramaItem) : null;
        if (!hit) return;
        if (esAnexo) {
          (hit as any).__idCotizacionTarifaAnexo = idTarifa;
        } else {
          (hit as any).__idCotizacionTarifa = idTarifa;
        }
      });
    };

    const hidratarIdsCampaniaDesdeRespuesta = (response: any): void => {
      const data = response?.data;
      const items = Array.isArray(data) ? data : Array.isArray(data?.campanias) ? data.campanias : Array.isArray(data?.items) ? data.items : Array.isArray(data?.programas) ? data.programas.flatMap((p: any) => Array.isArray(p?.campanias) ? p.campanias.map((c: any) => ({ ...c, idBenPrograma: c?.idBenPrograma ?? p?.idBenPrograma })) : []) : data ? [data] : [];
      items.forEach((item: any) => {
        const idCampania = Number(item?.idCotizacionCampania ?? item?.id_cotizacion_campania ?? 0);
        if (!(idCampania > 0)) return;
        const idBenProgramaItem = Number(item?.idBenPrograma ?? item?.id_ben_programa ?? 0);
        const hit = idBenProgramaItem > 0 ? this.programasSeleccionados.find(ps => Number((ps as any).__idBenPrograma || 0) === idBenProgramaItem) : null;
        if (hit) {
          (hit as any).__idCotizacionCampania = idCampania;
        }
      });
    };

    const guardarIdsCotizacionEnDatosContratante = (): void => {
      try {
        const rawDatos = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
        const datosActuales = rawDatos ? JSON.parse(rawDatos) : {};
        const tarifaPorPrograma: Record<string, number> = {};
        const tarifaAnexoPorPrograma: Record<string, number> = {};
        const campaniaPorPrograma: Record<string, number> = {};
        const tarifaPorIdBenPrograma: Record<string, number> = {};
        const tarifaAnexoPorIdBenPrograma: Record<string, number> = {};
        const campaniaPorIdBenPrograma: Record<string, number> = {};

        (this.programasSeleccionados || []).forEach(ps => {
          const programaKey = resolverCodigoPrograma(ps);
          if (!programaKey) return;
          const idBenPrograma = Number((ps as any).__idBenPrograma || 0);
          const idTarifa = Number((ps as any).__idCotizacionTarifa || 0);
          const idTarifaAnexo = Number((ps as any).__idCotizacionTarifaAnexo || 0);
          const idCampania = Number((ps as any).__idCotizacionCampania || 0);
          if (idTarifa > 0) tarifaPorPrograma[programaKey] = idTarifa;
          if (idTarifaAnexo > 0) tarifaAnexoPorPrograma[programaKey] = idTarifaAnexo;
          if (idCampania > 0) campaniaPorPrograma[programaKey] = idCampania;
          if (idBenPrograma > 0 && idTarifa > 0) tarifaPorIdBenPrograma[String(idBenPrograma)] = idTarifa;
          if (idBenPrograma > 0 && idTarifaAnexo > 0) tarifaAnexoPorIdBenPrograma[String(idBenPrograma)] = idTarifaAnexo;
          if (idBenPrograma > 0 && idCampania > 0) campaniaPorIdBenPrograma[String(idBenPrograma)] = idCampania;
        });

        const firstTarifa = Object.values(tarifaPorPrograma).find(v => Number(v) > 0);
        const firstTarifaAnexo = Object.values(tarifaAnexoPorPrograma).find(v => Number(v) > 0);
        const firstCampania = Object.values(campaniaPorPrograma).find(v => Number(v) > 0);

        const merged = {
          ...(datosActuales || {}),
          ...(Number(firstTarifa || 0) > 0 ? { idCotizacionTarifa: Number(firstTarifa) } : {}),
          ...(Number(firstTarifaAnexo || 0) > 0 ? { idCotizacionTarifaAnexo: Number(firstTarifaAnexo) } : {}),
          ...(Number(firstCampania || 0) > 0 ? { idCotizacionCampania: Number(firstCampania) } : {}),
          idCotizacionTarifaPorPrograma: tarifaPorPrograma,
          idCotizacionTarifaAnexoPorPrograma: tarifaAnexoPorPrograma,
          idCotizacionCampaniaPorPrograma: campaniaPorPrograma,
          idCotizacionTarifaPorIdBenPrograma: tarifaPorIdBenPrograma,
          idCotizacionTarifaAnexoPorIdBenPrograma: tarifaAnexoPorIdBenPrograma,
          idCotizacionCampaniaPorIdBenPrograma: campaniaPorIdBenPrograma,
        };
        localStorage.setItem(this.KEY_DATOS_CONTRATANTE, JSON.stringify(merged));
        this.actualizarProgramasContratanteLocalStorage();
      } catch { }
    };

    let datos: any;
    try {
      const raw = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
      if (!raw) {
        onError(new Error('No se encontraron datos del contratante para guardar el beneficiario.'));
        return;
      }
      datos = JSON.parse(raw);
    } catch {
      onError(new Error('Datos del contratante inválidos en localStorage.'));
      return;
    }

    let fechaNacimiento = '';
    try {
      const fn = (datos.fechaNacimiento ?? '').toString().trim();
      if (fn) {
        const yyyyFirst = fn.match(/^(\d{4})[\/\-](\d{2})[\/\-](\d{2})/);
        if (yyyyFirst) {
          fechaNacimiento = `${yyyyFirst[1]}-${yyyyFirst[2]}-${yyyyFirst[3]}`;
        } else {
          const ddFirst = fn.match(/^(\d{2})[\/\-](\d{2})[\/\-](\d{4})/);
          if (ddFirst) {
            fechaNacimiento = `${ddFirst[3]}-${ddFirst[2]}-${ddFirst[1]}`;
          } else {
            const d = new Date(fn);
            if (!isNaN(d.getTime())) {
              fechaNacimiento = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
            }
          }
        }
      }
    } catch { /* dejar vacío */ }

    const genero = (datos.genero ?? '').toString().trim().toUpperCase();
    const edad = Number(datos.edad ?? 0);
    const b: any = {
      id_cotizacion: idCotizacion,
      es_contratante: true,
      parentesco_id: 'T',
      tipo_documento: (datos.tipoDocumento ?? '').toString().trim(),
      num_documento: (datos.numeroDocumento ?? '').toString().trim(),
      primer_nombre: (datos.primerNombre ?? '').toString().trim(),
      segundo_nombre: (datos.segundoNombre ?? '').toString().trim(),
      primer_apellido: (datos.primerApellido ?? '').toString().trim(),
      segundo_apellido: (datos.segundoApellido ?? '').toString().trim(),
      genero,
      fecha_nacimiento: fechaNacimiento,
      edad
    };

    let idBeneficiarioGuardado = 0;

    this.networkingBeneficiary.guardarDatosBeneficiarios(b).pipe(

      // PASO 1: Extraer idBeneficiario
      concatMap((resp: any) => {
        const candidatos = [resp?.data?.idBeneficiario, resp?.data?.id_beneficiario, resp?.idBeneficiario, resp?.id_beneficiario, Array.isArray(resp?.data) ? resp.data?.[0]?.idBeneficiario : null];
        let idBen = 0;
        for (const v of candidatos) {
          const n = Number(v);
          if (Number.isFinite(n) && n > 0) { idBen = n; break; }
        }
        if (idBen <= 0) {
          const msg = resp?.message || resp?.errorMessage || resp?.data?.message || 'No se obtuvo idBeneficiario del contratante.';
          throw new Error(msg);
        }
        idBeneficiarioGuardado = idBen;
        try {
          const rawDatos = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
          const datosActuales = rawDatos ? JSON.parse(rawDatos) : {};
          const merged = { ...(datosActuales || {}), idBeneficiario: idBen, id_beneficiario_guardado: idBen };
          localStorage.setItem(this.KEY_DATOS_CONTRATANTE, JSON.stringify(merged));
        } catch { }
        return of(idBeneficiarioGuardado);
      }),

      // PASO 2: Guardar Beneficiario–Programas
      concatMap(() => this.completarGruposProgramaAntesDeGuardar()),
      concatMap(() => {
        const items = this.programasSeleccionados.map(ps => {
          const base = this.programasDisponibles.find(p => p.id === ps.id);
          return {
            lineaNegocio: this.lineaNegocioParaPersistir(base?.lineaNegocio),
            programa: this.codigoProgramaParaGuardar(ps),
            nombrePrograma: base?.nombre ?? ps.nombre,
            grupoPrograma: this.resolverGrupoPrograma(ps, base),
            esAnexo: false
          };
        });
        console.log(
          '[GRUPO-PROGRAMA][MODAL] Payload:',
          JSON.stringify(items, null, 2)
        );
        if (!items.length) return of({});
        return this.networkingBeneficiary.guardarBeneficiarioProgramas({ idCotizacion, idBeneficiario: idBeneficiarioGuardado, items });
      }),

      // PASO 3: Guardar Subcuentas (Solo OGA)
      concatMap(() => {
        if (!this.esFlujoColectivoOGA) return of(true);
        const subcuentas = this.programasSeleccionados
          .map(ps => {
            const deno = (ps.subcuenta || '').trim();
            const subcta = this.mapaDenoASubctaPorPrograma.get(ps.id)?.get(deno) || '';
            if (!subcta) return null;
            return { subcta, nombreSubcuenta: deno, planCodi: this.codigoProgramaParaGuardar(ps) };
          })
          .filter(Boolean) as any[];
        if (!subcuentas.length) return of(true);
        return this.networkingBeneficiary.guardarSubcuentas({ idCotizacion, idBeneficiario: idBeneficiarioGuardado, subcuentas });
      }),

      // PASO 4: Consultar idBenPrograma
      concatMap(() => {
        if (!this.programasSeleccionados.length) return of(true);
        const consultas = this.programasSeleccionados.map(ps => {
          const base = this.programasDisponibles.find(p => p.id === ps.id);
          return this.networkingBeneficiary.consultarBeneficiarioPrograma({ idCotizacion, idBeneficiario: idBeneficiarioGuardado, programa: this.codigoProgramaParaGuardar(ps) }).pipe(
            map((resp: any) => {
              if (resp?.data?.idBenPrograma) { (ps as any).__idBenPrograma = resp.data.idBenPrograma; }
              return resp;
            }),
            catchError(() => of(null))
          );
        });
        return forkJoin(consultas);
      }),

      // PASO 5: Enriquecer tarifas (Con trazabilidad financiera para depuración)
      concatMap(() => {
        console.log('=== ENTRADA PASO 5 EN EL CONTRATANTE ===');
        const programasConId = this.programasSeleccionados.filter(ps => !!(ps as any).__idBenPrograma && !!ps.tarifa);
        console.log(`Cantidad de carnet-programas listos con idBenPrograma: ${programasConId.length}`);
        const consultas = programasConId.map(ps => {
          if (this.esFlujoColectivoOGA && !this.esFlujoInclusion) {
            const planCodiNorm = (ps.id || '').trim().toUpperCase();
            const deno = (ps.subcuenta || '').trim();

            let subcta =
              this.mapaDenoASubctaPorPrograma
                .get(ps.id)
                ?.get(deno) || '';

            const cuentaInicial = String(
              this.cuentaColectivoGA ?? ''
            ).trim();

            const filaColectivo: any = (
              this.datosColectivoGA || []
            ).find((r: any) => {
              const rPlan = String(
                r?.plan_codi ??
                r?.PLAN_CODI ??
                ''
              ).trim().toUpperCase();

              const rSubcta = String(
                r?.subcta ??
                r?.SUBCTA ??
                ''
              ).trim();

              const rCuenta = String(
                r?.cuenta ??
                r?.CUENTA ??
                ''
              ).trim();

              const coincidePlan = this.coincidePlanCodiAfinidad(
                rPlan,
                planCodiNorm
              );

              return (
                coincidePlan &&
                (!subcta || rSubcta === subcta) &&
                (!cuentaInicial || rCuenta === cuentaInicial)
              );
            });

            if (!subcta) {
              subcta = String(
                filaColectivo?.subcta ??
                filaColectivo?.SUBCTA ??
                (ps as any).__subctaCodeSeleccionada ??
                ''
              ).trim();
            }

            const cuenta = String(
              cuentaInicial ||
              filaColectivo?.cuenta ||
              filaColectivo?.CUENTA ||
              ''
            ).trim();

            // En GA resuelve OPLC → OPLF.
            // En colectivo conserva el código original, por ejemplo OADC → OADC.
            const planCodiServicio = this.resolverPlanCodiServicio(
              planCodiNorm,
              subcta,
              cuenta
            );

            const valRef = Number(
              filaColectivo?.valor_tari ??
              filaColectivo?.VALOR_TARI ??
              filaColectivo?.valor ??
              filaColectivo?.VALOR ??
              0
            );

            const tariCodRef = String(
              filaColectivo?.tari ??
              filaColectivo?.TARI ??
              ''
            ).trim();

            const tariDenoRef =
              this.resolverDescripcionTarifaColectivo(
                filaColectivo,
                tariCodRef
              );

            if (subcta && cuenta) {
              return this.consultarTarifasColectivosGruposService
                .consultarTarifaColectivoGrupo({
                  prm_cuenta: cuenta,
                  prm_subcta: subcta,
                  prm_plan_codi: planCodiServicio
                })
                .pipe(
                  map((resp: any) => {
                    const data =
                      resp?.data?.jsonRespuesta ??
                      resp?.data?.respuesta ??
                      resp?.data ??
                      [];

                    const item =
                      resp?.status &&
                      Array.isArray(data) &&
                      data.length > 0
                        ? data.find((tarifa: any) => {
                            const codigo = String(
                              tarifa?.tarifa_codigo ??
                              tarifa?.TARIFA_CODIGO ??
                              tarifa?.tari ??
                              tarifa?.TARI ??
                              ''
                            ).trim();

                            return codigo === tariCodRef;
                          }) ?? data[0]
                        : null;

                    const valServer = Number(
                      item?.valor ??
                      item?.VALOR ??
                      0
                    );

                    const valorFinal =
                      valServer > 0 ? valServer : valRef;

                    const codFinal = String(
                      item?.tarifa_codigo ??
                      item?.TARIFA_CODIGO ??
                      item?.tari ??
                      item?.TARI ??
                      tariCodRef
                    ).trim();

                    const nomFinal = String(
                      item?.tarifa_nombre ??
                      item?.TARIFA_NOMBRE ??
                      item?.tari_deno ??
                      item?.TARI_DENO ??
                      tariDenoRef
                    ).trim();

                    return {
                      ps,
                      valorItem: {
                        tarifa_codigo: codFinal,
                        tarifa_nombre: nomFinal,
                        valor: valorFinal
                      }
                    };
                  }),
                  catchError(() =>
                    of({
                      ps,
                      valorItem:
                        valRef > 0
                          ? {
                              tarifa_codigo: tariCodRef,
                              tarifa_nombre: tariDenoRef,
                              valor: valRef
                            }
                          : null
                    })
                  )
                );
            }

            return of({
              ps,
              valorItem:
                valRef > 0
                  ? {
                      tarifa_codigo: tariCodRef,
                      tarifa_nombre: tariDenoRef,
                      valor: valRef
                    }
                  : null
            });
          }

          console.log(` Programa Evaluado: '${ps.id}' | Tarifa UI: '${ps.tarifa}'`);
          console.log(`Catálogo completo de tarifasDisponibles para '${ps.id}':`, ps.tarifasDisponibles);
          const det = this.buscarTarifaDisponibleSeleccionada(ps);
          console.log(`Instancia hallada por buscarTarifaDisponibleSeleccionada:`, det);
          const valorIva = det?.valorMensualIva ?? det?.valorMensualBase;
          const valorNum = Number(valorIva);
          console.log(`Importe extraído (valorIva): ${valorIva} | Convertido a número: ${valorNum}`);
          const valorItem = det && Number.isFinite(valorNum) && valorNum > 0 ? { valor: valorNum } : null;
          return of({ ps, valorItem });
        });

        return forkJoin(consultas).pipe(
          map((resultados: any[]) => {
            for (const { ps, valorItem } of resultados) {
              if (valorItem) {
                if (this.esFlujoColectivoOGA && !this.esFlujoInclusion) {
                  (ps as any).__tarifaCodigoLimpio = (valorItem.tarifa_codigo ?? '').toString().trim();
                  (ps as any).__tarifaNombreLimpio = (valorItem.tarifa_nombre ?? '').toString().trim();
                  const valorColectivo = Number((valorItem.valor ?? '').toString().trim());
                  (ps as any).__valorTarifaParaGuardar = { valorMensualIva: Number.isFinite(valorColectivo) ? valorColectivo : null };
                } else {
                  (ps as any).__valorTarifaParaGuardar = { valorMensualIva: Number(valorItem.valor) || null };
                  console.log(`Seteado __valorTarifaParaGuardar en Inclusión para '${ps.id}':`, (ps as any).__valorTarifaParaGuardar);
                }
              } else {
                console.error(`ERROR: El valorItem se resolvió como NULL para el carnet: ${ps.id}`);
              }
            }
            return resultados;
          })
        );
      }),

      // PASO 6: Guardar Tarifas (Con trazabilidad del request de salida de red)
      concatMap(() => {
        console.log('🔍 [AUDITORIA-FINANCIERA] === ENTRADA PASO 6 (CONSTRUCCIÓN DEL REQUEST ) ===');
        const programas = this.programasSeleccionados
          .filter(ps => !!(ps as any).__idBenPrograma && !!ps.tarifa)
          .map(ps => {
            const tarifaRaw = (ps.tarifa || '').trim();
            let codTarifa: string;
            let nombreTarifa: string | null = null;
            let valorBaseColectivo: number | null = null;
            let valorIvaColectivo: number | null = null;

            if (this.esFlujoColectivoOGA && !this.esFlujoInclusion) {
              const planCodiNorm = (ps.id || '').trim().toUpperCase();
              const filaColectivo: any = (this.datosColectivoGA || []).find((r: any) => {
                const rPlan = (r?.plan_codi ?? r?.PLAN_CODI ?? '').toString().trim().toUpperCase();
                return rPlan === planCodiNorm;
              });

              codTarifa = (ps as any).__tarifaCodigoLimpio || (filaColectivo?.tari ?? filaColectivo?.TARI) || tarifaRaw.match(/\(([^)]+)\)$/)?.[1]?.trim() || tarifaRaw;
              nombreTarifa = (ps as any).__tarifaNombreLimpio || this.resolverDescripcionTarifaColectivo(filaColectivo, codTarifa) || null;

              const valoresGuardados = (ps as any).__valorTarifaParaGuardar ?? null;
              const valNum = Number(valoresGuardados?.valorMensualIva ?? filaColectivo?.valor_tari ?? filaColectivo?.VALOR_TARI ?? filaColectivo?.valor ?? filaColectivo?.VALOR ?? 0);
              if (valNum > 0) {
                valorBaseColectivo = valNum;
                valorIvaColectivo = valNum;
              }
            }
            else {
              const codDesdeTexto = tarifaRaw.includes(' - ') ? tarifaRaw.split(' - ')[0].trim() : (tarifaRaw.match(/\(([^)]+)\)$/)?.[1]?.trim() || tarifaRaw);
              const det = (ps.tarifasDisponibles || []).find((t: any) => (t?.tarifa ?? '').toString().trim() === tarifaRaw || (t?.tarifa ?? '').toString().trim() === codDesdeTexto);
              codTarifa = (det?.tarifa && !det.tarifa.includes(' - ') ? det.tarifa : codDesdeTexto || '').trim();
              nombreTarifa = det?.descripcion ?? null;
            }

            if (!codTarifa) {
              console.error(` Abortando subnodo: No se pudo resolver codTarifa para ${ps.id}`);
              return null;
            }

            const valoresGuardados = (ps as any).__valorTarifaParaGuardar ?? null;
            const detIndividual = !this.esFlujoColectivoOGA ? this.buscarTarifaDisponibleSeleccionada(ps) : undefined;
            const valorCatalogo = detIndividual?.valorMensualIva ?? detIndividual?.valorMensualBase;
            const valorMensualIvaIndividual = Number.isFinite(Number(valorCatalogo)) && Number(valorCatalogo) > 0 ? Number(valorCatalogo) : null;

            const finalValorIva = (this.esFlujoColectivoOGA && !this.esFlujoInclusion) ? (valorIvaColectivo ?? valoresGuardados?.valorMensualIva ?? null) : (valoresGuardados?.valorMensualIva ?? valorMensualIvaIndividual);
            const finalValorBase = (this.esFlujoColectivoOGA && !this.esFlujoInclusion) ? (valorBaseColectivo ?? null) : (detIndividual?.valorMensualBase ?? null);

            const tarifas: any[] = [{
              tari: codTarifa,
              nombreTarifa,
              esTarifaAsociado: detIndividual?.esTarifaAsociado ?? false,
              fueSeleccionada: true,
              esAnexo: false,
              valorMensualBase: finalValorBase,
              valorMensualIva: finalValorIva,
              porcentajeIva: detIndividual?.porcentajeIva ?? 0
            }];

         if (this.shouldShowTarifaAnexo(ps) && (ps.anexoCodigo || '').trim() !== '') {
          const codAnexoSel = (ps.anexoCodigo ?? '').trim();
          let anexoDet = this.findAnexoEnOpciones(ps.anexosDisponibles || [], codAnexoSel);
          
          if (!anexoDet && (ps as any).anexoDetalle) {
            anexoDet = {
              tari: (ps as any).anexoDetalle?.tari || (ps as any).anexoDetalle?.clave || '',
              nombre: (ps as any).anexoDetalle?.nombreTarifa || '',
              valor: (ps as any).anexoDetalle?.valorMensualIva || ''
            } as any;
          }

          let codTarifaAnexo = (anexoDet?.tari || codAnexoSel.split('|')[1] || codAnexoSel).toString().trim();
          if (codTarifaAnexo.includes('|')) {
            codTarifaAnexo = codTarifaAnexo.split('|')[1] || codTarifaAnexo.split('|')[0];
          }

          const nombreAnexoResuelto = (anexoDet?.nombre || (ps as any).nombreAnexo || (ps as any).anexoDetalle?.nombreTarifa || '').toString().trim();
          const nombreTarifaAnexoFinal = nombreAnexoResuelto 
            ? (nombreAnexoResuelto.includes(codTarifaAnexo) ? nombreAnexoResuelto : `${codTarifaAnexo} - ${nombreAnexoResuelto}`)
            : codTarifaAnexo;

          const valorAnexoRaw = Number(anexoDet?.valor ?? (ps as any).anexoDetalle?.valorMensualIva ?? 0);
          const valorAnexoFinal = Number.isFinite(valorAnexoRaw) ? valorAnexoRaw : 0;

          console.log(`[ANEXO-DEBUG-CORRECCION] [Contratante] Anexo preparado para guardar -> Código: "${codTarifaAnexo}", Nombre: "${nombreTarifaAnexoFinal}", Valor: ${valorAnexoFinal}`, {
            ps,
            anexoDet,
            programasContratanteStorage: JSON.parse(localStorage.getItem('programas_contratante') || '[]')
          });

          if (codTarifaAnexo && codTarifaAnexo !== '0' && codTarifaAnexo !== '0.0000') {
            tarifas.push({
              tari: codTarifaAnexo,
              nombreTarifa: nombreTarifaAnexoFinal,
              esTarifaAsociado: null,
              fueSeleccionada: true,
              esAnexo: true,
              valorMensualBase: valorAnexoFinal,
              valorMensualIva: valorAnexoFinal,
              porcentajeIva: null
            });
          } else {
            console.warn(`[ANEXO-DEBUG-CORRECCION] [Contratante] ⚠️ Se omitió código de anexo inválido '${codTarifaAnexo}' para el carnet ${ps.id}`);
          }
        }
            return { idBenPrograma: (ps as any).__idBenPrograma, tarifas };
          })
          .filter(Boolean) as any[];

        console.log(` Payload al método guardarTarifas:`, JSON.stringify({ idCotizacion, idBeneficiario: idBeneficiarioGuardado, programas }));
        if (!programas.length) return of(true);
        return this.networkingBeneficiary.guardarTarifas({ idCotizacion, idBeneficiario: idBeneficiarioGuardado, programas }).pipe(
          map((resp: any) => {
            console.log('Respuesta del servidor recibida con éxito:', resp);
            hidratarIdsTarifaDesdeRespuesta(resp);
            guardarIdsCotizacionEnDatosContratante();
            return resp;
          })
        );
      }),

      // PASO 7: Guardar Campañas
      concatMap(() => {
        return this.networkingBeneficiary.guardarCampanias({ idCotizacion, idBeneficiario: idBeneficiarioGuardado, programasSeleccionados: this.programasSeleccionados as any }).pipe(
          map((resp: any) => {
            hidratarIdsCampaniaDesdeRespuesta(resp);
            guardarIdsCotizacionEnDatosContratante();
            return resp;
          }),
          catchError(() => of(null))
        );
      })
    ).subscribe({
      next: () => {
        this.spinner.hide();
        onOk();
      },
      error: (err: unknown) => {
        this.spinner.hide();
        onError(err);
      }
    });
  }

  /**
   * Guardar programas seleccionados (Tab Programas).
   *
   * Persiste la selección en ProgramaSeleccionStore (localStorage).
   * El guardado BD de Beneficiario/Tarifas/Campañas queda a cargo de la pantalla Beneficiario.
   */
  guardarProgramas(): void {
    if (this.esPrecargaVisualFAEM) return;
    if (this.procesoBloqueadoPorHistorial) {
      this.mostrarPopupBloqueoRetiro();
      return;
    }
    if (this.programasSeleccionados.length === 0) {
      return;
    }

    const programasPendientesDeTarifa =
      this.programasSeleccionados.filter(
        programa =>
          !this.esFlujoColectivoOGA &&
          !this.esFlujoInclusion &&
          programa.tarifasConsultaRealizada !== true
      );

    if (programasPendientesDeTarifa.length > 0) {
      console.warn(
        '[GRUPO-PROGRAMA][CONTRATANTE] Guardado detenido: consultas de tarifas pendientes',
        programasPendientesDeTarifa.map(programa => ({
          programa: programa.id,
          grupoPrograma: programa.grupoPrograma,
          tarifasConsultaRealizada:
            programa.tarifasConsultaRealizada
        }))
      );

      this.dialog.open(PopUpMensajeComponent, {
        width: '500px',
        maxWidth: '90vw',
        disableClose: true,
        data: {
          titulo: 'Información',
          texto:
            'Espera un momento mientras se termina de cargar la información de los programas.',
          tipoIcono: 'info',
          textoBoton: 'ACEPTAR'
        } as PopUpMensajeData
      });

      programasPendientesDeTarifa.forEach(
        programa =>
          this.cargarTarifasParaPrograma(programa)
      );

      return;
    }

    if (this.configuracionProgramasIncompleta || this.tieneColectivoSinSubcuenta) {
      alert('Por favor complete la configuración de todos los programas seleccionados (Subcuenta, Tarifa y Campaña).');
      return;
    }
    if (this.esFlujoInclusion) {
      console.log('guardarProgramas inicia almacenamiento de programas del flujo de inclusion ')
      this.actualizarProgramasContratanteLocalStorage();
      const programasIds = this.programasSeleccionados.map(p => p.id);
      localStorage.setItem('programas_seleccionados_inclusion', JSON.stringify(programasIds));
    }

    const cerrarDialogoGuardarProgramas = (): void => {
      // Guardar en store con el idCotizacion ya resuelto (puede haberse creado justo antes)
      this.actualizarProgramasContratanteLocalStorage();
      this.dialogRef.close({
        accion: 'guardar_programas',
        esUsuario: this.esUsuario,
        programasSeleccionados: this.programasSeleccionados,
        lineaNegocio: this.lineasSeleccionadas
      });
    };

    const idCotizacion = this.getIdCotizacionEnCurso();

    if (idCotizacion != null) {
      // Si editaron el formulario, actualizar contratante+validaciones en BD.
      // Los programas siguen solo en LS (sin cambios en su persistencia).
      if (this.cotizacionesIncompletasService.hayCambiosDatosContratanteFormulario()) {
        let validacionesParaUpdate: ValidacionesContratantePayload = {
          tipoDocumento: this.tipoDocumento?.trim() || '',
          idContratante: this.numeroDocumento.trim(),
          fechaConsulta: new Date().toISOString(),
          items: []
        };
        try {
          const rawValidaciones = localStorage.getItem(this.KEY_VALIDACIONES_CONTRATANTE);
          if (rawValidaciones) {
            const parsed = JSON.parse(rawValidaciones);
            if (parsed && Array.isArray(parsed.items)) {
              validacionesParaUpdate = parsed;
            }
          }
        } catch { /* no-op */ }

        this.cotizacionesIncompletasService
          .actualizarCotizacionIncompletaContratanteValidaciones(idCotizacion, validacionesParaUpdate)
          .subscribe({
            error: (err) => {
              console.error('[CONTRATANTE] Error al actualizar contratante/validaciones:', err);
            }
          });
      }

      if (this.esFlujoInclusion) {
        console.log('guardarProgramas inicia Sincronizar con cotizaciones incompletas  de programas del flujo de inclusion ')
        const raw = localStorage.getItem(this.KEY_PROGRAMAS_CONTRATANTE);
        if (raw) {
          try {
            const programasInclusion = JSON.parse(raw);
            this.cotizacionesIncompletasService.guardarProgramas(idCotizacion, programasInclusion).subscribe();
          } catch (_) { }
        }
        // Paridad VN/Resultados (LS-only): marcar visita activa para Continuar.
        // Inclusión con id ya existente no pasa por CREATE (que sí setea sesion_activa).
        // Espejo de guardar() Resultados — NO persiste programas en BD.
        this.actualizarContextoCotizacionPrecargada({
          idCotizacion,
          tipoDocumento: this.tipoDocumento,
          numeroDocumento: this.numeroDocumento,
          fecha: new Date().toISOString()
        });
        sessionStorage.setItem(KEY_COTIZACION_CONTRATANTE_SESION_ACTIVA, '1');
      } else {

        // Sincronizar con cotizaciones incompletas (no bloquea el flujo)
        const stored = this.programaSeleccionStore.cargar();
        if (stored?.programas?.length) {
          this.cotizacionesIncompletasService.guardarProgramas(idCotizacion, stored.programas).subscribe();
        }
      }
      /* ── Guardado en BD de Beneficiario/Tarifas/Campañas DESACTIVADO ──────
       * La pantalla de Beneficiario leerá ProgramaSeleccionStore y ejecutará:
       *   guardarDatosBeneficiarios → guardarBeneficiarioProgramas →
       *   guardarSubcuentas → guardarTarifas → guardarCampanias
       * ───────────────────────────────────────────────────────────────────── */

      cerrarDialogoGuardarProgramas();
      return;
    }

    if (this.esEditModeActivo) {
      cerrarDialogoGuardarProgramas();
      return;
    }

    // Sin idCotizacion: crear el header de cotización en BD para obtener el id,
    // luego persistir en el store y cerrar.
    let validacionesPayload: { items: ItemValidacion[] } = { items: [] };
    try {
      const rawValidaciones = localStorage.getItem(this.KEY_VALIDACIONES_CONTRATANTE);
      if (rawValidaciones) {
        const parsed = JSON.parse(rawValidaciones);
        if (Array.isArray(parsed?.items)) {
          validacionesPayload = { items: parsed.items };
        }
      }
    } catch (_) { }

    this.spinner.show();
    this.guardarCotizacionEnBD(
      validacionesPayload,
      () => {
        this.spinner.hide();
        // idCotizacion ya está disponible en getIdCotizacionEnCurso() tras guardarCotizacionEnBD
        cerrarDialogoGuardarProgramas();
      },
      (err) => {
        this.spinner.hide();
        console.error('[CONTRATANTE] Error al crear cotización:', err);
        this.dialog.open(PopUpMensajeComponent, {
          width: '500px',
          maxWidth: '90vw',
          disableClose: true,
          data: {
            titulo: 'Error',
            texto: (err instanceof Error ? err.message : 'No se pudo guardar la cotización en la base de datos. Intente de nuevo.'),
            tipoIcono: 'error',
            textoBoton: 'ACEPTAR'
          } as PopUpMensajeData
        });
      }
    );
  }

  /**
   * Indica si hay programas seleccionados pero la configuración está incompleta
   * (falta subcuenta/tarifa/campaña en algún programa o CEM sin cobertura validada).
   */
  get configuracionProgramasIncompleta(): boolean {
    if (this.programasSeleccionados.length === 0) return false;
    const faltaConfiguracion = this.programasSeleccionados.some(p => {
      const sinSubcuentasDisponibles = this.esFlujoColectivoOGA
        && p.subcuentasConsultaRealizada
        && (p.subcuentasDisponibles?.length ?? 0) === 0;
      const requiereSubcuenta = (p.subcuentasDisponibles?.length ?? 0) > 0;
      const subcuentaOk = !sinSubcuentasDisponibles && (!requiereSubcuenta || (requiereSubcuenta && !!p.subcuenta));
      const requiereTarifaAnexo = this.shouldShowTarifaAnexo(p);
      const tarifaAnexoOk = !requiereTarifaAnexo || !!(p.anexoCodigo && p.anexoCodigo.trim());
      return !subcuentaOk || !p.tarifa || !p.campana || !tarifaAnexoOk;
    });
    // Gate CEM: exigir cobertura solo si la UI de validación está visible.
    // Inclusión + cotizacion_precargada oculta <app-validacion-area-cobertura>
    // (*ngIf="hayProgramaCemSeleccionado && !esPrecargaIncompleta") pero el gate
    // seguía pidiendo coberturaCemValida → GUARDAR permanentemente disabled.
    // Venta Nueva F/A/E: sin cambio (esFlujoInclusion=false → misma fórmula de siempre).
    const cemSinCobertura = this.hayProgramaCemSeleccionado
      && !this.coberturaCemValida
      && !(this.esFlujoInclusion && this.esPrecargaIncompleta);
    return faltaConfiguracion || cemSinCobertura;
  }

  /**
   * Verificar si hay cambios sin guardar
   */
  private tieneCambiosSinGuardar(): boolean {
    return this.programasSeleccionados.length > 0 ||
      this.lineasSeleccionadas.length > 0 ||
      this.historialCliente.length > 0 ||
      this.estadoEPS.length > 0 ||
      this.condicionAsociado.length > 0 ||
      this.consultasPrevias.length > 0;
  }

  /**
   * Captura el store de programas al abrir el modal (antes de escrituras en vivo).
   * Permite restaurar en "Salir sin guardar" sin perder evidencia de BD.
   */
  private capturarSnapshotProgramasAlAbrir(): void {
    try {
      const raw = localStorage.getItem(this.KEY_PROGRAMAS_CONTRATANTE);
      this.habiaProgramasStoreAlAbrir = !!raw;
      const stored = this.programaSeleccionStore.cargar();
      this.programasStoreSnapshotAlAbrir = stored
        ? (JSON.parse(JSON.stringify(stored)) as ProgramasContratanteStore)
        : null;
    } catch {
      this.habiaProgramasStoreAlAbrir = false;
      this.programasStoreSnapshotAlAbrir = null;
    }
  }

  /**
   * Descarta cambios de UI en programas_contratante:
   * - Si había snapshot al abrir → lo restaura (conserva idBenPrograma/guardadoEnBd).
   * - Si no había store al abrir → removeItem (selección nueva de esta sesión).
   */
  private restaurarOConservarProgramasAlDescartar(): void {
    if (this.programasStoreSnapshotAlAbrir) {
      this.programaSeleccionStore.guardar(this.programasStoreSnapshotAlAbrir);
      return;
    }
    if (!this.habiaProgramasStoreAlAbrir) {
      localStorage.removeItem(this.KEY_PROGRAMAS_CONTRATANTE);
    }
  }

  /**
   * Cerrar el modal con confirmación (requisito 10).
   * Opciones: "Guardar y salir" (guarda en storage y cierra) / "Salir sin guardar" (solo cierra).
   */
  cerrar(): void {
    if (this.esPrecargaVisualFAEM) {
      this.dialogRef.close(null);
      return;
    }
    if (this.tieneCambiosSinGuardar()) {
      const dialogRefConfirmacion = this.dialog.open(PopUpConfirmacionComponent, {
        data: {
          titulo: 'Confirmación de Salida',
          texto: '¿Deseas salir sin guardar la información actual? Los datos ingresados podrían perderse.',
          textoBotonSi: 'Guardar y salir',
          textoBotonNo: 'Salir sin guardar'
        } as PopUpConfirmacionData,
        width: '500px',
        maxWidth: '90vw',
        disableClose: true,
        panelClass: 'pop-up-confirmacion'
      });

      dialogRefConfirmacion.afterClosed().subscribe((resultado: boolean | null) => {
        if (resultado === true) {
          // Guardar y salir: si estamos en tab Programas con programas incompletos, no persistir programas en local
          if (this.tabSeleccionadoIndex === 1 && this.configuracionProgramasIncompleta) {
            if (this.esFlujoInclusion) {
              if (this.inclusionSnapshotAlAbrir) {
                localStorage.setItem(this.KEY_PROGRAMAS_CONTRATANTE, this.inclusionSnapshotAlAbrir);
                console.log('[Flujo-Inclusion][LOG-DIAGNOSTICO] Configuración incompleta. Restaurando carné original de la sesión.');
              } else {
                localStorage.removeItem(this.KEY_PROGRAMAS_CONTRATANTE);
              }
            } else {
              localStorage.removeItem(this.KEY_PROGRAMAS_CONTRATANTE);
            }
          }
          this.guardar();
        } else if (resultado === false) {
          if (this.esFlujoInclusion) {
            if (this.inclusionSnapshotAlAbrir) {
              localStorage.setItem(this.KEY_PROGRAMAS_CONTRATANTE, this.inclusionSnapshotAlAbrir);
              console.log('[Flujo-Inclusion][LOG-DIAGNOSTICO] Cambios descartados por el usuario. Rollback de IDs máster ejecutado con éxito.');
            } else if (this.programasSeleccionados && this.programasSeleccionados.length > 0) {
              this.actualizarProgramasContratanteLocalStorage();
              console.log('[Flujo-Inclusion][LOG-DIAGNOSTICO] Preservando programas de inclusión calculados en memoria.');
            } else {
              localStorage.removeItem(this.KEY_PROGRAMAS_CONTRATANTE);
              console.log('[Flujo-Inclusion][LOG-DIAGNOSTICO] Cambios descartados. No existían datos previos, limpiando storage.');
            }
          } else {
            localStorage.removeItem(this.KEY_PROGRAMAS_CONTRATANTE);
          }
          this.dialogRef.close(null);
        }
      });
    } else {
      this.dialogRef.close(null);
    }
  }

  private obtenerEdadContratante(): number {
    if (this.data?.datosContratante) {
      const edadData = this.data.datosContratante.edad ?? this.data.datosContratante.contratanteEdad;
      if (edadData != null && !isNaN(Number(edadData)) && Number(edadData) > 0) {
        return Number(edadData);
      }
    }
    try {
      const raw = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
      if (raw) {
        const datos = JSON.parse(raw);
        const edadLS = datos?.edad ?? datos?.contratanteEdad;
        if (edadLS != null && !isNaN(Number(edadLS)) && Number(edadLS) > 0) {
          return Number(edadLS);
        }
      }
    } catch (_) { }
    return 0;
  }

  public onTarifaChange(programaSel: ProgramaSeleccionado): void {
    this.cargarCampaniasParaPrograma(programaSel);
    this.actualizarProgramasContratanteLocalStorage();
  }

  isSubcuentaDisabled(programaSel: any): boolean {
    if (this.esFlujoInclusion) {
      return true;
    }
    return (programaSel?.subcuentasDisponibles?.length ?? 0) === 0;
  }

  private deducirLineaDesdePlan(planCodi: string): 'MI' | 'SO' | 'CEM' {
    const c = (planCodi || '').toString().trim().toUpperCase();

    if (c.startsWith('DE') || c.startsWith('SO') ||  c.startsWith('SAO') ||  c === 'SAOB' || c === 'CLEAR') {
      return 'SO';
    }
    if (c.startsWith('CEM') || c === 'FULL' || c === 'FULC') {
      return 'CEM';
    }
    return 'MI';
  }

  private mapNumberToLinea(linea: any, planCodi: string): 'MI' | 'SO' | 'CEM' {
    const l = String(linea ?? '').trim().toUpperCase();
    if (l === '1' || l === 'MI' || l === 'SMP') return 'MI';
    if (l === '2' || l === 'SO' || l === 'SAO') return 'SO';
    if (l === '3' || l === 'CEM') return 'CEM';

    return this.deducirLineaDesdePlan(planCodi);
  }

}
